import React, { Suspense } from "react";
import { withTranslation } from "react-multi-lang";
import { Modal, ModalBody, Popover, PopoverBody } from "reactstrap";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import { Collapse, CardBody, Card, CardTitle } from "reactstrap";
import Userdetail from "./../custom_modules/general/Userdetail.jsx";
import store from "../redux_store/store/index.js";
import {
  convertUTCDateToLocalDate,
  Servicecalls,
  Silentauditobject,
  convertdoubledigitdate,
  convertdoubledigittime,
  orderTypeforprotocol,
  orderType, ProtocolHistory, toDateFilter,
  ControlRightsOnOrdersTask,
  userdetails
} from "./../custom_functions/Functions.jsx";
import { isMultitenant, month } from "./../custom_functions/Constance.jsx";
import { type } from "jquery";
import KendoGridView from "./KendoGridView.jsx";
import KendoDatepicker from "./KendoDatepicker.jsx";
import KendoCombobox from "./KendoCombobox.jsx";
// import { ProtocolHistory } from "../custom_modules/protocolorders/ProtocolFunctions.jsx";

class CustomDetailviewCell extends React.Component {
  constructor(props) {
    super(props);
    let filterdate = new Date();
    this.state = {
      // versionexpanded: true,
      // transactionexpanded: true,
      // workflowexpanded: false,
      // versionexpandgetdata: false,
      activeTab: 1,
      screenHistoryDatas: [],
      transactionscolumn: [
        {
          header: this.props.t("Templates.Sheettemplates.IDS_LBL_TRANS"),
          datatype: "filecode",
          rowselector: false,
          visible: false,
          doFilter: true,
          sortable: false,
          resizable: false,
          celltype: "CommonTransactionHistoryDesing",
          className: "simple-grid-view",
          width: "100px"
        },
      ],
      OnKendoDateFrom: new Date(filterdate.setDate(filterdate.getDate() - 7)),
      OnKendoDateTo: new Date(),
      FilterType: [
        {
          id: 1,
          type: props.t("Dashboard.IDS_LBL_FILTERBYCURRENTDATE")
        },
        {
          id: 2,
          type: props.t("Dashboard.IDS_LBL_FILTERBY7DAYS")
        },
        {
          id: 3,
          type: props.t("Dashboard.IDS_LBL_FILTERBY30DAYS")
        },
        {
          id: 4,
          type: props.t("Dashboard.IDS_LBL_FILTERBYCUSTOMDATE")
        },
      ],
      SelectedFilter: {
        id: 1,
        type: props.t("Dashboard.IDS_LBL_FILTERBYCURRENTDATE")
      },
    };
    this.month = this.props.details && this.props.details.month ? this.props.details.month : month;
    this.ELNurl = window.appUrl.ELN;
    this.userRights = this.getScreenRights();
    this.imageurl = "";
    if (isMultitenant === 1 || isMultitenant === 2) {
      this.imageurl = "/User/Cloudprofile/";
    } else {
      this.imageurl = "/User/profile/";
    }
  }


  formattransactiondetails(dataItem, index) {
    let d = null;
    let day = null;
    let dayname = null;
    let time = null;

    if (dataItem?.isOriginal) {
      let localdate = convertUTCDateToLocalDate(
        new Date(dataItem.createdate)
      );
      d = new Date(localdate);
      day = d.getDate();
      dayname = this.month[d.getMonth()];
      day = convertdoubledigitdate(day);
      time = convertdoubledigittime(
        d.getHours(),
        d.getMinutes(),
        d.getSeconds()
      );
      let year = d.getFullYear();
      let imgurl = this.ELNurl + this.imageurl + "-1";
      if (
        dataItem.createby !== null &&
        dataItem.createby !== undefined
      ) {
        imgurl =
          this.ELNurl + this.imageurl + dataItem.createby.usercode;
      }

      //  "IDS_LDL_CREATEWITHTASK": "{Screenname} template: {templatename} was created for task {taskname} with {visibility name} visibility by User: {user}",
      // "IDS_LDL_CREATEWITHOUTTASK": "{Screenname} template: {templatename} was created with {visibility name} visibility by User: {user}",
      const sentence = dataItem.task ? this.props.t("Templates.Sheettemplates.IDS_LDL_CREATEWITHTASK", {
        Screenname: this.props.t("Dashboard.IDS_LBL_SHEET", { param: "" }),// "Sheet",
        templatename: dataItem.filenameuser,
        taskname: dataItem.task,
        visibilityname: dataItem.viewoption === 1 ? "site" : "project team",
        user: dataItem.createby.username
      }) : this.props.t("Templates.Sheettemplates.IDS_LDL_CREATEWITHOUTTASK", {
        Screenname: this.props.t("Dashboard.IDS_LBL_SHEET", { param: "" }),// "Sheet",
        templatename: dataItem.filenameuser,
        visibilityname: dataItem.viewoption === 1 ? "site" : "project team",
        user: dataItem.createby.username
      });


      if (
        dataItem !== undefined &&
        dataItem[this.props.keyfield] !== undefined
      ) {
        return (
          {
            ...dataItem, userdetailsindex: "Trans-" + index, key: dataItem.filecode + "Trans_-2" + index, dayname: dayname, day: day, year: year, time: time, imgurl: imgurl, commentsDesign:
              (<p>
                {sentence}
                {/* {this.props.t("Templates.Sheettemplates.IDS_LBL_CREATEDF", {
                  user1: dataItem.createby.username,
                  user2: dataItem.filenameuser,
                })} */}
              </p>)
          }
          // <>
          //   <li
          //     key={dataItem.filecode + "Trans_-2"}
          //     className="list-group-item"
          //   >
          //     <div className="row no-gutters align-items-center">
          //       <div className="col-2">
          //         <div className="calender-list small">
          //           <span className="d-flex eln-stamp">{dayname}</span>
          //           <span className="d-flex eln-date">{day}</span>
          //           <span className="d-flex eln-stamp">{year}</span>
          //           <span className="d-flex eln-stamp ">{time}</span>
          //         </div>
          //       </div>
          //       <div className="col-10 mnuContainer2  userDetails">
          //         <Userdetail
          //           index={"Trans3--2"}
          //           imgurl={imgurl}
          //           user={dataItem.createby}
          //         />
          //         <p>
          //           {this.props.t("Templates.Sheettemplates.IDS_LBL_CREATEDF", {
          //             user1: dataItem.createby.username,
          //             user2: dataItem.filenameuser,
          //           })}
          //         </p>
          //       </div>
          //     </div>
          //   </li>
          // </>

        );
      }
    } else {
      let localdate = convertUTCDateToLocalDate(
        new Date(
          dataItem.createdate
        )
      );
      d = new Date(localdate);
      day = d.getDate();
      dayname = this.month[d.getMonth()];
      day = convertdoubledigitdate(day);
      time = convertdoubledigittime(
        d.getHours(),
        d.getMinutes(),
        d.getSeconds()
      );
      let year = d.getFullYear();
      let imgurl = this.ELNurl + this.imageurl + "-1";
      if (
        dataItem.modifiedby !== null &&
        dataItem?.modifiedby !== undefined
      ) {
        imgurl =
          this.ELNurl +
          this.imageurl +
          dataItem?.modifiedby?.usercode;
      }

      let commentsDesign = null;
      if (dataItem?.sheetcomment !== undefined && dataItem?.sheetcomment !== null && (dataItem?.templateobjects === undefined || dataItem?.templateobjects === null)) {
        commentsDesign = dataItem?.sheetcomment
      } else if ((dataItem?.templateobjects !== undefined || dataItem?.templateobjects !== null) && dataItem?.templateobjects?.action === "saveas") {
        commentsDesign = dataItem?.templateobjects?.type === "to" ? this.props.t("Templates.Sheettemplates.IDS_SHEETTEMPLATESAVEASTEMPLATE", {
          NewTemplatename: dataItem.templateobjects.filenameto,
          VersionNumber: dataItem.templateobjects.filenametoversionno,
          oldtemplatename: dataItem.templateobjects.filenamefrom,
          OldtempVersionNumber: dataItem.templateobjects?.filenamefromversionno,
          user: dataItem.templateobjects?.createdby?.username
        }) : this.props.t("Templates.Sheettemplates.IDS_SHEETTEMPLATESAVEASORIGINAL", {
          "Sheet/Protocol": this.props.t("Dashboard.IDS_LBL_SHEET", {}),
          Templatename: dataItem.templateobjects.filenamefrom,
          VersionNumber: dataItem.templateobjects.filenamefromversionno,
          newtemplatename: dataItem.templateobjects.filenameto,
          // OldtempVersionNumber: dataItem.templateobjects?.filenamefromversionno,
          user: dataItem.templateobjects?.createdby?.username
        })
      } else if ((dataItem?.templateobjects !== undefined || dataItem?.templateobjects !== null) && dataItem?.templateobjects?.action === "Edit") {
        console.log("kumu");
        if (dataItem?.templateobjects?.edittype === "Rename") {
          commentsDesign = this.props.t("Templates.Sheettemplates.IDS_LDL_EDITTEMPLATENAME", {
            "Sheet/Protocol": this.props.t("Dashboard.IDS_LBL_SHEET", {}),
            templatename: dataItem.templateobjects?.filenameto,
            previousvalue: dataItem.templateobjects.filenamefrom,
            currentvalue: dataItem.templateobjects?.filenameto,
          })
        } else if (dataItem?.templateobjects?.edittype === "Visibility") {
          commentsDesign = this.props.t("Templates.Sheettemplates.IDS_LDL_EDITTEMPLATEVISIBILITY", {
            "Sheet/Protocol": this.props.t("Dashboard.IDS_LBL_SHEET", {}),
            templatename: dataItem.templateobjects?.filenameto,
            previousvisibility: dataItem.templateobjects.viewoptionfrom === 1 ? this.props.t("Dashboard.IDS_LBL_SITE", {}) : this.props.t("Dashboard.IDS_LBL_PROJECTTEAM", {}), // "Project Team",
            currentvisibility: dataItem.templateobjects?.viewoptionto === 1 ? this.props.t("Dashboard.IDS_LBL_SITE", {}) : this.props.t("Dashboard.IDS_LBL_PROJECTTEAM", {}),
            user: dataItem.createdby?.username
          })
        } else {
          // {Sheet/Protocol} Template: {TemplateName Version: {VersionNumber} was Modified by User: <user></user>
          commentsDesign = this.props.t("Templates.Sheettemplates.IDS_LDL_EDITTEMPLATEOTHERS", {
            "Sheet/Protocol": this.props.t("Dashboard.IDS_LBL_SHEET", {}),
            TemplateName: dataItem.templateobjects?.filenameto,
            VersionNumber: dataItem.templateobjects?.VersionNumber,
            user: dataItem.createdby?.username
          })
        }
      } else if ((dataItem?.templateobjects !== undefined || dataItem?.templateobjects !== null) && dataItem?.templateobjects?.action === "Save") {
        commentsDesign = this.props.t("Templates.Sheettemplates.IDS_LDL_TEMPLATESAVE", {
          "Sheet/Protocol": this.props.t("Dashboard.IDS_LBL_SHEET", {}),
          TemplateName: dataItem.templateobjects?.filename,
          VersionNumber: dataItem.templateobjects.versionno,
          user: dataItem.createdby?.username
        })
      } else if ((dataItem?.templateobjects !== undefined || dataItem?.templateobjects !== null) && dataItem?.templateobjects?.action === "Workflow") {
        const approvedStatusText = dataItem?.templateobjects?.approvelstatus === 1
          ? this.props.t("Dashboard.IDS_LBL_APPROVED", {}) // "Approved"
          : dataItem?.templateobjects?.approvelstatus === 2
            ? this.props.t("Orders.Sheetorders.IDS_LBL_RETURN", {})// "Returned"
            : this.props.t("Dashboard.IDS_LBL_REJECTED", {})// "Rejected";
        commentsDesign = this.props.t("Templates.Sheettemplates.IDS_LDL_WORKFLOWTRANSITION", {
          "Template/Order": "Template",
          "TemplateName/OrderID": dataItem.templateobjects?.filename,
          VersionNumber: dataItem.templateobjects.versionno,
          "Approved/Returned/Rejected": approvedStatusText,
          Workflowstep: dataItem?.templateobjects?.previousworkflow?.workflowname,
          user: dataItem.createdby?.username
        })
      } else if ((dataItem?.templateobjects !== undefined || dataItem?.templateobjects !== null) && dataItem?.templateobjects?.action === "Retire") {
        commentsDesign = this.props.t("Templates.Sheettemplates.IDS_LDL_TEMPALTERETIRED", {
          "Sheet/Protocol": this.props.t("Dashboard.IDS_LBL_SHEET", {}),
          TemplateName: dataItem.templateobjects?.filename,
          user: dataItem.createdby?.username
        })
      } else if ((dataItem?.templateobjects !== undefined || dataItem?.templateobjects !== null) && dataItem?.templateobjects?.action === "ExportJSON") {
        commentsDesign = this.props.t("Templates.Sheettemplates.IDS_LDL_TEMPALTEEXPORTJSON", {
          "Sheet/Protocol": this.props.t("Dashboard.IDS_LBL_SHEET", {}),
          TemplateName: dataItem.templateobjects?.filename,
          filename: dataItem.templateobjects?.exportFilename,
          extention: dataItem.templateobjects?.exportExtention,
          user: dataItem.createdby?.username
        })
      } else if ((dataItem?.templateobjects !== undefined || dataItem?.templateobjects !== null) && dataItem?.templateobjects?.action === "TemplateMapping") {
        if (dataItem?.templateobjects?.isNew) {
          commentsDesign = this.props.t("Templates.Sheettemplates.IDS_LDL_TEMPALTEMAPPING", {
            "Sheet/Protocol": this.props.t("Dashboard.IDS_LBL_SHEET", {}),
            TemplateName: dataItem.templateobjects?.filename,
            TaskName: dataItem.templateobjects?.currentTask?.testname,
            user: dataItem.createdby?.username
          })
        } else if (dataItem.templateobjects?.PreviousTask !== undefined) {
          commentsDesign = this.props.t("Templates.Sheettemplates.IDS_LBL_TEMPALTEREMAPPING", {
            "Sheet/Protocol": this.props.t("Dashboard.IDS_LBL_SHEET", {}),
            TemplateName: dataItem.templateobjects?.filename,
            TaskName: dataItem.templateobjects?.PreviousTask?.testname,
            user: dataItem.createdby?.username
          })
        }
      } else if (dataItem?.templateobjects !== undefined && dataItem?.templateobjects !== null && dataItem?.templateobjects?.action === "newversion") {
        //  "Version {newversionno} of {Sheet/Protocol} Template: {TemplateName} was generated by user {user}"
        commentsDesign = this.props.t("Templates.Sheettemplates.IDS_LBL_TEMPALTENEWVERSION", {
          "Sheet/Protocol": this.props.t("Dashboard.IDS_LBL_SHEET", {}),   // "Sheet",
          newversionno: dataItem.templateobjects?.newversionno,
          TemplateName: dataItem.templateobjects?.filename,
          user: dataItem.createdby?.username
        })
      }



      return (
        {
          ...dataItem, userdetailsindex: "Trans2-" + index, key: this.props.dataItem.filecode + "TransDetails_" + index, dayname: dayname, day: day, year: year, time: time, imgurl: imgurl, commentsDesign:
            (<p>
              {commentsDesign}
            </p>),
          createby: dataItem.createdby
        }
        // <li
        //   key={this.props.dataItem.filecode + "TransDetails_" + index}
        //   className="list-group-item"
        // >
        //   <div className="row no-gutters align-items-center">
        //     <div className="col-2">
        //       <div className="calender-list small">
        //         <span className="d-flex eln-stamp">{dayname}</span>
        //         <span className="d-flex eln-date">{day}</span>
        //         <span className="d-flex eln-stamp">{year}</span>
        //         <span className="d-flex eln-stamp ">{time}</span>

        //       </div>
        //     </div>
        //     <div className="col-10 mnuContainer2  userDetails">
        //       <Userdetail
        //         index={"Trans2-" + index}
        //         imgurl={imgurl}
        //         user={{
        //           usercode: dataItem?.modifiedby?.usercode,
        //           username: dataItem?.modifiedby?.username
        //         }}
        //       />
        //       <p>
        //         {dataItem?.sheetcomment}
        //       </p>
        //     </div>
        //   </div>
        // </li>
      );
    }
  }

  formatversiondetails(dataItem, index) {
    if (dataItem?.isOriginal) {
      let localdate = convertUTCDateToLocalDate(
        new Date(this.props.dataItem?.createdate || new Date())
      );
      let d = new Date(localdate);
      let day = d.getDate();
      let dayname = this.month[d.getMonth()];
      day = convertdoubledigitdate(day);
      let time = convertdoubledigittime(
        d.getHours(),
        d.getMinutes(),
        d.getSeconds()
      );
      let year = d.getFullYear();
      let imgurl = this.ELNurl + this.imageurl + "-1";
      if (
        this.props.dataItem.createby !== null &&
        this.props.dataItem.createby !== undefined
      ) {
        imgurl =
          this.ELNurl +
          this.imageurl +
          this.props.dataItem.createby.usercode;
      }
      return (
        {
          ...dataItem, userdetailsindex: "version_" + index, key: this.props.dataItem.filecode + "version_" + index, dayname: dayname, day: day, year: year, time: time, imgurl: imgurl, commentsDesign:
            (<p>
              {this.props.t("Orders.Protocolorders.IDS_LBL_CREATEDFILE", {
                user2: this.props.dataItem.createby.username,
                user1: 1,
                // user1: this.props.dataItem.fileversioncount,
              })}
            </p>)
        }
        // <li
        //   key={this.props.dataItem.filecode + "Trans_"}
        //   className="list-group-item"
        // >
        //   <div className="row no-gutters align-items-center">
        //     <div className="col-2">
        //       <div className="calender-list  small">
        //         <span className="d-flex eln-stamp">{dayname}</span>
        //         <span className="d-flex eln-date">{day}</span>
        //         <span className="d-flex eln-stamp">{year}</span>
        //         <span className="d-flex eln-stamp">{time}</span>
        //       </div>
        //     </div>
        //     <div className="col-10 mnuContainer2 userDetails">
        //       <Userdetail
        //         index={"Trans-"}
        //         imgurl={imgurl}
        //         user={this.props.dataItem.createby}
        //       />
        //       <p>
        //         {this.props.t("Orders.Protocolorders.IDS_LBL_CREATEDFILE", {
        //           user2: this.props.dataItem.createby.username,
        //           user1: this.props.dataItem.filenameuser,
        //         })}
        //       </p>
        //     </div>
        //   </div>
        // </li>
      );
    } else {
      let localdate = convertUTCDateToLocalDate(
        new Date(dataItem?.createdate || new Date())
      );
      let d = new Date(localdate);
      let day = d.getDate();
      let dayname = this.month[d.getMonth()];
      day = convertdoubledigitdate(day);
      let time = convertdoubledigittime(
        d.getHours(),
        d.getMinutes(),
        d.getSeconds()
      );
      let year = d.getFullYear();
      let imgurl = this.ELNurl + this.imageurl + "-1";
      if (
        dataItem?.modifiedby !== null &&
        dataItem?.modifiedby !== undefined
      ) {
        imgurl =
          this.ELNurl +
          this.imageurl +
          dataItem?.modifiedby.usercode;
      }
      return (
        {
          ...dataItem, userdetailsindex: "version_" + index, key: this.props.dataItem.filecode + "version_", dayname: dayname, day: day, year: year, time: time, imgurl: imgurl, commentsDesign:
            (<p>
              {this.props.t("Orders.Protocolorders.IDS_LBL_MODIFIEDF", {
                user2:
                  dataItem?.modifiedby
                    .username,
                user1:
                  dataItem?.versionname,
              })}
            </p>)
        }
        // <li
        //   key={this.props.dataItem.filecode + "Trans_" + index}
        //   className="list-group-item"
        // >
        //   <div className="row no-gutters align-items-center">
        //     <div className="col-2">
        //       <div className="calender-list  small">
        //         <span className="d-flex  eln-stamp">{dayname}</span>
        //         <span className="d-flex eln-date">{day}</span>
        //         <span className="d-flex eln-stamp">{year}</span>
        //         <span className="d-flex  eln-stamp">{time}</span>
        //       </div>
        //     </div>
        //     <div className="col-10 mnuContainer2 userDetails">
        //       <Userdetail
        //         index={"Trans-" + index}
        //         imgurl={imgurl}
        //         user={dataItem?.modifiedby}
        //       />
        //       <p>
        //         {this.props.t("Orders.Protocolorders.IDS_LBL_MODIFIEDF", {
        //           user2:
        //             dataItem?.modifiedby
        //               .username,
        //           user1:
        //             dataItem?.versionname,
        //         })}
        //       </p>
        //     </div>
        //   </div>
        // </li>
      );
    }
  }


  formatworkflowdetails(dataItem, index) {
    let imgurl;
    let localDate = convertUTCDateToLocalDate(new Date(dataItem?.createdate));
    let d = new Date(localDate);
    let day = d.getDate();
    let dayname = this.month[d.getMonth()];
    day = convertdoubledigitdate(day);
    let time = convertdoubledigittime(d.getHours(), d.getMinutes(), d.getSeconds());
    let year = d.getFullYear();
    imgurl = this.ELNurl + this.imageurl + "-1";
    // let imgdetails = [];
    // imgdetails.push(imgurl);
    if (
      dataItem?.createby !== null &&
      dataItem?.createby !== undefined
    ) {
      imgurl = this.ELNurl + this.imageurl + dataItem?.createby.usercode;
      // imgdetails.push(imgurl);
    }

    // 1st workflow:
    // <Template>: <Template Name> (v<Version Number>) was <Approved>from workflow step : < workflow step> to <Workflow step> by User: <user>
    // 2nd workflow:
    // <Template>: <Template Name> (v<Version Number>) was <Approved> from workflow step : < workflow step> to <Workflow step> by User: <user>
    // 3rd workflow:
    // <Template>: <Template Name> (v<Version Number>)was <Approved>in workflow step : < workflow step> by User: <user>
    // Return:
    // <Template>: <Template Name> (v<Version Number>) was <Returned>from workflow step : < workflow step>  to <Workflow step> by User: <user>
    // Reject:
    // <Template>: <Template Name> (v<Version Number>) was <Rejected>in workflow step: < workflow step>  by User: <user>



    // {Template}: {TemplateName} v{VersionNumber} was {ApprovedStatus} {fromorin} workflow step : {previousworkflow} to {nextworkflow} by User: {user}
    // to {nextworkflow}
    const isWorkflowPresent = dataItem?.previousworkflowcode?.workflowcode !== undefined;
    const approvedStatusText = dataItem?.approvelstatus === 1
      ? this.props.t("Dashboard.IDS_LBL_APPROVED", {}) // "Approved"
      : dataItem?.approvelstatus === 2
        ? this.props.t("Orders.Sheetorders.IDS_LBL_RETURN", {})//"Returned"
        : this.props.t("Dashboard.IDS_LBL_REJECTED", {})// "Rejected";
    const fromOrin = (
      (dataItem?.approvelstatus === 1 && !dataItem?.currentworkflow) ||
      dataItem?.approvelstatus === 3
    ) ? this.props.t("Templates.Sheettemplates.IDS_LBL_IN", { param: "" }) : this.props.t("Templates.Sheettemplates.IDS_LBL_FROM", { param: "" });
    const translationParams = {
      Template: "Template",
      TemplateName: dataItem?.templatename || this.props?.dataItem?.filenameuser || "N/A",
      VersionNumber: dataItem?.templateversionNumber || this.props?.dataItem?.viewoption || "N/A",
      ApprovedStatus: approvedStatusText,
      fromorin: fromOrin,
      previousworkflow: dataItem?.previousworkflowcode?.workflowname || "",
      nextworkflow: dataItem?.currentworkflow?.workflowname || "",
      user: dataItem?.createby?.username || "Unknown User"
    };
    let workflowHistoryText = this.props.t("Templates.Sheettemplates.IDS_WORKFLOWHISTORY", translationParams);
    if (!translationParams.nextworkflow) {
      workflowHistoryText = workflowHistoryText.replace("to  by", "by");
    }
    // const fromOrin = ((dataItem?.approvelstatus === 1 && dataItem?.currentworkflow === undefined) || dataItem?.approvelstatus === 3) ? "in" : "from";
    // const workflowHistoryText = this.props.t("Templates.Sheettemplates.IDS_WORKFLOWHISTORY", {
    //   Template: "Template",
    //   TemplateName: dataItem?.templatename || this.props?.dataItem?.filenameuser,
    //   VersionNumber: dataItem?.templateversionNumber || this.props?.dataItem?.viewoption,
    //   ApprovedStatus: approvedStatusText,
    //   fromorin:fromOrin,
    //   previousworkflow: dataItem?.previousworkflowcode?.workflowname || "",
    //   nextworkflow: dataItem?.currentworkflow?.workflowname || "",
    //   user: dataItem?.createby?.username || ""
    // }).replaceAll("to {nextworkflow}","");

    const commentsDesign = (
      <p>
        {isWorkflowPresent ? workflowHistoryText : dataItem?.action}
        <div className="userComts">
          <b>{this.props.t("Templates.Sheettemplates.IDS_LBL_COMMENT", { param: "" })} : </b>{" "}
          {dataItem?.comment}
        </div>
      </p>
    );
    return (
      {
        ...dataItem, userdetailsindex: "CreateWKFlow-" + index, key: dataItem?.historycode !== undefined ? dataItem?.historycode + "Trans_" + index : "Trans_" + index, dayname: dayname, day: day, year: year, time: time, imgurl: imgurl, commentsDesign:
          commentsDesign
      }
      // <li
      //   className="list-group-item"
      //   key={
      //     dataItem?.historycode !== undefined ? dataItem?.historycode : index
      //   }
      // >
      //   <div className="row no-gutters align-items-center">
      //     <div className="col-2">
      //       <div className="calender-list small">
      //         <span className="d-flex eln-stamp">{dayname}</span>
      //         <span className="d-flex eln-date">{day}</span>
      //         <span className="d-flex eln-stamp">{year}</span>
      //         <span className="d-flex eln-stamp">{time}</span>
      //       </div>
      //     </div>
      //     <div className="col-10 mnuContainer2 userDetails">
      //       <Suspense fallback={<div></div>}>
      //         <Userdetail
      //           index={"CreateWKFlow-" + index}
      //           imgurl={imgurl}
      //           user={{
      //             usercode: dataItem?.createby.usercode,
      //             username: dataItem?.createby.username
      //           }}
      //         />
      //       </Suspense>
      //       <p>
      //         {dataItem?.action}

      //         <div className="userComts">
      //           <b>{this.props.t("Templates.Sheettemplates.IDS_LBL_COMMENT", { param: "" })} : </b>{" "}
      //           {dataItem?.comment}
      //         </div>
      //       </p>
      //     </div>
      //   </div>
      // </li>
    );
  }

  formatHistorys = (finalHistory) => {
    let historys = finalHistory?.reduce((acc, curr, index) => {
      if (curr?.type === "Workflow") {
        acc.push(this.formatworkflowdetails(curr, index))
      } else if (curr?.type === "Transaction") {
        acc.push(this.formattransactiondetails(curr, index))
      } else if (curr?.type === "Version") {
        acc.push(this.formatversiondetails(curr, index))
      }
      return acc;
    }, [])
    return historys;
  }
  onClose(e) {
    this.setState({ customSheetView: false })
  }


  getScreenRights() {
    let auotoRegRights = ControlRightsOnOrdersTask("IDS_SCN_SHEETTEMPLATE", "IDS_TSK_TRANHISTORY");

    let auotoReg = auotoRegRights.UserGroupRights.rights;

    return {
      transHistory: auotoReg,
    };
  }


  fetchHistoryData = async (url, body) => {
    return new Promise((resolve, reject) => {
      Servicecalls(
        url,
        body,
        (res) => resolve(res || []),
        (err) => reject(err)
      );
    });
  };

  getTransactionDatas = async () => {
    if (!this.props.dataItem.filecode) return [];
    const result = await this.fetchHistoryData(
      `${this.ELNurl}/File/GetSheetTransactionDetails`,
      {
        filecode: this.props.dataItem.filecode,
        response: { information: this?.state?.SelectedFilter.id?.toString() || "" },
        ...this?.state?.SelectedFilter.id === 4 && {
          objsilentaudit: {
            fromdate: this?.state?.OnKendoDateFrom?.setHours(0, 0, 0, 0), todate: toDateFilter(this?.state?.OnKendoDateTo)
          }
        }
      }
    );
    let data = result?.modifiedlist?.map(item => ({
      createdby: item.modifiedby,
      sheetmodifiedDate: item.sheetmodifiedDate,
      createdate: item.sheetmodifiedDate,
      modifiedby: item.modifiedby,
      sheetcomment: item.sheetcomment,
      type: "Transaction",
      templateobjects: item.templateobjects && JSON.parse(item.templateobjects),
    })) || [];
    const created = new Date(this.props.dataItem.createdate);
    const from = this.state.OnKendoDateFrom;
    const to = this.state.OnKendoDateTo;

    const isBetween = created.getTime() >= from.getTime() && created.getTime() <= to.getTime();

    console.log("Is between:", isBetween);

    if (data?.length > 0) {
      let dataWithOriginal = [
        isBetween && {
          ...this.props.dataItem,
          type: "Transaction",
          isOriginal: true
        },
        ...data
      ].filter(Boolean);

      return dataWithOriginal;
    } else {
      return [];
    }

  };

  getVersionDatas = async () => {
    if (!this.props.dataItem.filecode) return [];
    const result = await this.fetchHistoryData(
      `${this.ELNurl}/File/Getfileversions`,
      {
        filecode: this.props.dataItem.filecode,
        response: { information: this?.state?.SelectedFilter.id?.toString() || "" },
        ...this?.state?.SelectedFilter.id === 4 && {
          objsilentaudit: {
            fromdate: this?.state?.OnKendoDateFrom?.setHours(0, 0, 0, 0), todate: toDateFilter(this?.state?.OnKendoDateTo)
          }
        }
      }
    );


    const created = new Date(this.props.dataItem.createdate);
    const from = this.state.OnKendoDateFrom;
    const to = this.state.OnKendoDateTo;

    const isBetween = created.getTime() >= from.getTime() && created.getTime() <= to.getTime();

    if (result?.length > 0) {
      let dataWithOriginal = [
        result?.filter((items) => items.versionno === 1)?.length === 0 && isBetween && {
          ...this.props.dataItem,
          type: this.props.t("Dashboard.IDS_LBL_VERSION"),
          isOriginal: true
        },
        ...result?.map((items) => {
          if (items.versionno === 1) {
            return { ...items, type: this.props.t("Dashboard.IDS_LBL_VERSION"), isOriginal: true };
          }
          return { ...items, type: this.props.t("Dashboard.IDS_LBL_VERSION") };
        })
      ].filter(Boolean);

      return dataWithOriginal?.map(item => ({ ...item, type: this.props.t("Dashboard.IDS_LBL_VERSION"), createdate: item.modifieddate })) || [];
    } else {
      return [];
    }
  };

  getWorkflowHistoryDatas = async () => {
    if (!this.props.dataItem.filecode) return [];
    if (this.props.dataItem.lssheetworkflowhistory) {
      return this.props.dataItem.lssheetworkflowhistory
        .map(item => ({ ...item, type: "Workflow" })) || [];
    }
    const result = await this.fetchHistoryData(
      `${this.ELNurl}/File/Getfileworkflowhistory`,
      {
        filecode: this.props.dataItem.filecode,
        response: { information: this?.state?.SelectedFilter.id?.toString() || "" },
        ...this?.state?.SelectedFilter.id === 4 && {
          objsilentaudit: {
            fromdate: this?.state?.OnKendoDateFrom?.setHours(0, 0, 0, 0), todate: toDateFilter(this?.state?.OnKendoDateTo)
          }
        }
      }
    );
    return result?.map(item => ({ ...item, type: "Workflow" })) || [];
  };

  onHistoryClick = async () => {
    if (!this.props.dataItem.filecode) return;
    try {
      const [transactions, versions, workflows] = await Promise.all([
        this.getTransactionDatas(),
        this.getVersionDatas(),
        this.getWorkflowHistoryDatas()
      ]);
      let finalHistory = [...transactions, ...versions, ...workflows].sort((a, b) => {
        const getTime = (item) =>
          typeof item.createdate === "number"
            ? item.createdate
            : Date.parse(item.createdate);
        const diff = getTime(b) - getTime(a);
        if (diff === 0) {
          return (a.id || "").toString().localeCompare((b.id || "").toString());
        }
        return diff;
      });
      console.log(finalHistory.map(i => new Date(i.createdate)));
      finalHistory = finalHistory.map((items, index) => { items.id = index; return items })
      const passObjDet = {
        objsilentaudit: Silentauditobject(
          "view",
          "Sheet Templates",
          this.props.t("Templates.Sheettemplates.IDS_AUDIT_SHEETINFOOPENED", {
            user1: this.props.dataItem.filenameuser,
            user: store.getState().Loggeduser.username
          })
        ),
      };
      Servicecalls(
        `${this.ELNurl}/AuditTrail/silentandmanualRecordHandler`,
        passObjDet,
        () => { },
        () => { }
      );
      let allDatas = this.formatHistorys(finalHistory || [])
      this.setState({ screenHistoryDatas: allDatas?.map((items) => { items.select = false; return items }), customSheetView: true })
    } catch (error) {
      console.error("History load failed:", error);
    }
  };

  onFilterTypeChange = (event) => {
    this.setState({ SelectedFilter: event }, () => {
      this.onHistoryClick()
    })
  }

  onDatefilterDatachange = (changedDate, statekey) => {
    this.setState({ [statekey]: changedDate }, () => {
      this.onHistoryClick()
    })
  }

  onFilteReset = () => {
    this.setState({ SelectedFilter: { id: 1 }, OnKendoDateFrom: new Date(new Date().setDate(new Date().getDate() - 7)), OnKendoDateTo: new Date() }, () => {
      this.onHistoryClick()
    })
  }

  render() {

    const { activeTab } = this.state;
    const props = {
      t: (key, options) => {/* Your translation logic here */ },
    };

    return (
      this.props.dataItem[this.props.keyfield] !== undefined &&
      <div>
        {this.userRights.transHistory && <button
          id={`user-${this.props.dataItem[this.props.keyfield]}`}
          className="grid-icons"
          alt="user"
          data-placement="top"
          title={this.props.t("Templates.Sheettemplates.IDS_LBL_HISTORY")}
          onClick={this.onHistoryClick.bind(this)}
        >
          <i className="far fa-eye 1" title={this.props.t("Templates.Sheettemplates.IDS_LBL_HISTORY")} />
        </button>}

        {this.state.customSheetView &&
          <Modal
            isOpen={this.state.customSheetView}
            backdrop={true}
            toggle={() => { this.setState({ customSheetView: !this.state.customSheetView }) }}
            className=" modal-md smallPopup protocol-history sheet-history"
          >
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel"> {this.props.t("Templates.Sheettemplates.IDS_LBL_TEMPLATEHISTORY")}
              </h5>
              <button
                type="button"
                className="btn_white_bg"
                data-dismiss="modal"
                aria-label="Close"
                onClick={this.onClose.bind(this)}
              >
                <i className="fas fa-times" aria-hidden="true"></i>
              </button>
            </div>
            <ModalBody>
              <div>
                {/* <ul className="nav nav-tabs">
                  <li className={`nav-item ${activeTab === 1 ? 'active' : ''}`}>
                    <a
                      className="nav-link"
                      onClick={() => this.handleTabClick(1)}
                      href="#tab1"
                    >
                      {this.props.t("Templates.Sheettemplates.IDS_LBL_HISTORY")}
                    </a>
                  </li>
                  <li className={`nav-item ${activeTab === 2 ? 'active' : ''}`}>
                    <a
                      className="nav-link"
                      onClick={() => this.handleTabClick(2)}
                      href="#tab2"
                    >
                      {this.props.t("Templates.Sheettemplates.IDS_LBL_TRANS")}
                    </a>
                  </li>
                  {this?.props?.props?.dataItem?.assignedto === undefined ?
                    <li className={`nav-item ${activeTab === 3 ? 'active' : ''}`}>
                      <a
                        className="nav-link"
                        onClick={() => this.handleTabClick(3)}
                        href="#tab3"
                      >
                        {this.props.t("Templates.Sheettemplates.IDS_LBL_WORKF")}
                      </a>
                    </li>
                    : ""
                  }
                </ul> */}

                <div className="row w-100 align-items-center mb-2">
                  <span className="col-3 filter-table text-left m-0">{this.props.t("Dashboard.IDS_LBL_FILTERBY")}</span>
                  <KendoCombobox
                    initialValue=""
                    id="protocol-history-date"
                    Datasource={this.state.FilterType}
                    DefaultValue={this.state.SelectedFilter}
                    onvaluechange={this.onFilterTypeChange.bind(this)}
                    ValueMember="id"
                    DisplayMember="type"
                    allowCustom={true}
                    additionalclass={"clshideclearbutton col-6"}
                  />
                </div>
                {this.state.SelectedFilter?.id === 4 &&
                  <div className="shadow-box filter-date-group">
                    <div className="flex-form-group padding-align-form disable-callendar-input">
                      <label htmlFor="inputText">
                        {this.props.t("Dashboard.IDS_LBL_FILTERFROMDATE")}
                      </label>
                      <Suspense fallback={<div></div>}>
                        <KendoDatepicker
                          DefaultValue={this.state.OnKendoDateFrom}
                          onDatachanges={(changedDate) => { this.onDatefilterDatachange(changedDate, "OnKendoDateFrom") }}
                        />
                      </Suspense>
                    </div>
                    <div className="flex-form-group padding-align-form disable-callendar-input">
                      <label htmlFor="inputText">
                        {this.props.t("Dashboard.IDS_LBL_FILTERTO")}
                      </label>
                      <Suspense fallback={<div></div>}>
                        <KendoDatepicker
                          DefaultValue={this.state.OnKendoDateTo}
                          onDatachanges={(changedDate) => { this.onDatefilterDatachange(changedDate, "OnKendoDateTo") }}

                        />
                      </Suspense>
                    </div>
                    <div className="d-flex align-items-end flex-column bd-highlight mb-3">
                      <button
                        className="mg-l-1 btn btn-primary-blue active"
                        onClick={this.onFilteReset.bind(this)}
                      >
                        {this.props.t("Orders.Sheetorders.IDS_LBL_RESET")}
                      </button>
                    </div>
                  </div>
                }
                <div>
                  <div
                    className={`tab-pane ${activeTab === 1 ? 'active' : ''}`}
                    id="tab1"
                  >
                    <div className="popup-group-list-inner" >
                      <KendoGridView
                        enableTooltip={true}
                        primaryKey={"id"}
                        source={this.state.screenHistoryDatas}
                        Columns={this.state.transactionscolumn}
                        DataSearchvisible={false}
                        ShowDetailsVisible={false}
                        height="calc(100vh - 165px)"
                      />
                      {/* // this.formatHistorys()
                      } */}
                    </div>
                  </div>
                  {/* <div
                    className={`tab-pane ${activeTab === 2 ? 'active' : ''}`}
                    id="tab2"
                  >
                    <div className="popup-group-list-inner" >
                      {this.formattransactiondetails()}
                    </div>
                  </div>
                  <div
                    className={`tab-pane ${activeTab === 3 ? 'active' : ''}`}
                    id="tab3"
                  >
                    <div className="popup-group-list-inner">
                      {this.formatworkflowdetails(
                        this.props.dataItem.lssheetworkflowhistory,
                        this.props
                      )}
                    </div> 
                  </div>*/}
                </div>
              </div>

            </ModalBody>
          </Modal>
        }

      </div>
    );
  }
}
export default withTranslation(CustomDetailviewCell);


export const FormateTransactionHistoryDetails = (props) => {
  return (
    <td>
      {/* <li
        key={props?.dataItem?.key}
        className="list-group-item"
      > */}
      <div className="row no-gutters align-items-center">
        <div className="col-2">
          <div className="calender-list small">
            <span className="d-flex eln-stamp">{props?.dataItem?.dayname}</span>
            <span className="d-flex eln-date">{props?.dataItem?.day}</span>
            <span className="d-flex eln-stamp">{props?.dataItem?.year}</span>
            <span className="d-flex eln-stamp ">{props?.dataItem?.time}</span>

          </div>
        </div>
        <div className="col-10 mnuContainer2 userDetails">
          <Suspense fallback={<div></div>}>
            <Userdetail
              index={props?.dataItem?.userdetailsindex}
              imgurl={props?.dataItem?.imgurl}
              user={{
                usercode: props?.dataItem?.createby?.usercode,
                username: props?.dataItem?.createby?.username
              }}
            />
          </Suspense>
          {props?.dataItem?.commentsDesign}
        </div>
      </div>
      {/* </li> */}
    </td>
  )
}

class CustomUsergroupviewCell extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.ELNurl = window.appUrl.ELN;
  }
  isToolTipOpen = (targetName) => {
    return this.state[targetName] ? this.state[targetName].tooltipOpen : false;
  };
  toggle = (targetName) => {
    if (!this.state[targetName]) {
      this.setState({
        ...this.state,
        [targetName]: {
          tooltipOpen: true,
        },
      });
    } else {
      this.setState({
        ...this.state,
        [targetName]: {
          tooltipOpen: !this.state[targetName].tooltipOpen,
        },
      });
    }

    this.setState({
      transactionexpanded: false,
      workflowexpanded: false,
    });
  };
  formatdefaultusergroup(multiusergroupcode, lsmultisites) {
    var detail = [];
    if (multiusergroupcode !== undefined && multiusergroupcode !== null) {
      var listofusergroup = multiusergroupcode;

      var filterdefaulusergroup = [];

      filterdefaulusergroup = listofusergroup.filter(
        (items) => items.defaultusergroup === 1
      );

      if (filterdefaulusergroup.length === 1) {

        const siteNames = lsmultisites.flatMap(item =>
          item?.lssiteMaster?.sitecode === filterdefaulusergroup[0]?.lsusergroup?.lssitemaster ? [item.lssiteMaster.sitename] : []
        );



        detail.push(
          <li
            className="list-group-item list-group-item-action "
            aria-disabled="true"
            key={filterdefaulusergroup[0].lsusergroup.multiusergroupcode !== undefined ? filterdefaulusergroup[0].lsusergroup.multiusergroupcode : "nodefaultgroupval"}
          >
            <p>{filterdefaulusergroup[0].lsusergroup.usergroupname + "-" + (siteNames.length > 0 ? siteNames[0] : "")}</p>{" "}
          </li>
        );
      } else {
        detail.push(
          <li className="list-group-item" aria-disabled="true" key="nodefaultgroup">
            <p>{"No Default Usergroup"}</p>
          </li>
        );
      }

      // }
    }
    let detailsvalue = (
      <ul className="list-group list-group-flush">{detail}</ul>
    );
    return detailsvalue;
  }
  closeusergroupinformation() {
    this.setState({ customUsergroup: false })

  }

  formatusergroup(multiusergroupcode, lsmultisites) {
    var detail = [];
    if (multiusergroupcode !== undefined && multiusergroupcode !== null) {
      for (let index = 0; index < multiusergroupcode.length; index++) {
        // let d = new Date(lsorderworkflowhistory[index].createdate);
        // let day = d.getDate();
        // let dayname = this.month[d.getMonth()];
        // let time = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
        // let imgurl = this.ELNurl + this.imageurl + "-1";
        // if (lsorderworkflowhistory[index].createby !== null && lsorderworkflowhistory[index].createby !== undefined) {
        //     imgurl = this.ELNurl + this.imageurl + lsorderworkflowhistory[index].createby.usercode;
        // }
        const siteNames = lsmultisites.flatMap(item =>
          item?.lssiteMaster?.sitecode === multiusergroupcode[index]?.lsusergroup?.lssitemaster ? [item.lssiteMaster.sitename] : []
        );
        detail.push(
          <React.Fragment key={"multigroupindex_" + index}>
            {multiusergroupcode[index].defaultusergroup !== 1 ? (
              <li
                className="list-group-item list-group-item-action"
                aria-disabled="true"
                key={multiusergroupcode[index].multiusergroupcode}
              >
                <p>{multiusergroupcode[index].lsusergroup.usergroupname + "-" + (siteNames.length > 0 ? siteNames[0] : "")}</p>

              </li>
            ) : (
              ""
            )}
          </React.Fragment>
        );
      }
    }
    let detailsvalue = (
      <ul className="list-group list-group-flush">{detail}</ul>
    );
    return detailsvalue;
  }

  render() {
    return (
      this.props.dataItem[this.props.keyfield] !== undefined ? (
        <div className="column">
          <button
            id={`user-${this.props.dataItem[this.props.keyfield]}`}
            className="grid-icons mg-t-half mg-l-1"
            alt="user"
            data-placement="top"
            title={this.props.t("Setup.Usermaster.IDS_LBL_USERGROUP")}
            onClick={() => {
              this.setState({ customUsergroup: true })
              let passObjDet = {
                objsilentaudit: Silentauditobject(
                  "view",
                  "usermaster",
                  this.props.t("Setup.Usermaster.IDS_AUDIT_USERMASTERINFOOPEN", {
                    user1: this.props.dataItem.username,
                    user: store.getState().Loggeduser.username,
                  })

                ),
              };
              Servicecalls(
                "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
                passObjDet,
                (res) => { },
                (res) => { }
              );
            }}
          >
            <i className="far fa-eye 2"></i>
          </button>
          {this.state.customUsergroup ?
            <Modal
              isOpen={this.state.customUsergroup}
              backdrop={true}
              toggle={() => {
                this.setState({ customUsergroup: !this.state.customUsergroup })

              }}

              className="screen-centered-scroll v-centerd modal-width"
            >
              <ModalBody>
                {/*     <Card>
                                <CardBody>
                                    <CardTitle>
                                        <b> */}
                <div className="popup-group-list  full-width popup-lg-container">
                  {/* <h6>
                  {this.props.t("Master_UserMaster.ID_DEFAULTUSERGROUP", {
                    param: "",
                  })}
                </h6> */}
                  <h6>
                    {this.props.t("Setup.Usermaster.IDS_LBL_USERGROUPS", {
                      param: "",
                    })}
                  </h6>
                  {/* <button className="btn float-right" onClick={() => { */}
                  {/* // this.setState({ versionexpanded: !this.state.versionexpanded, version: !this.state.versionexpanded }); */}
                  {/* }}> */}
                  {/* <i className={this.state.versionexpanded ? "fa fa-angle-up" : "fa fa-angle-down"} aria-hidden="true"></i> */}
                  {/* <i className="fa fa-angle-up" aria-hidden="true"></i> */}
                  {/* </button> */}
                  {/* <hr></hr> */}
                  {/* </CardTitle> */}
                  {/* <Collapse isOpen={this.state.versionexpanded}> */}
                  {/* <Collapse isOpen="true"> */}
                  <div className="popup-group-list-inner">

                    {isMultitenant === 2 ? sessionStorage.designationname : this.formatdefaultusergroup(
                      this.props.dataItem.multiusergroupcode, this.props.dataItem.lsmultisites
                    )}
                  </div>

                  {/* </Collapse> */}

                  {/* </CardBody> */}

                  {/* <CardBody>
                                    <CardTitle>
                                        <b> */}
                  {/* <h6>
                  {this.props.t("Master_UserMaster.ID_ALTERNATIVEUSERGROUP", {
                    param: "",
                  })}
                </h6> */}
                  {/* </b> */}
                  {/* <button className="btn float-right" onClick={() => { */}
                  {/* // this.setState({ versionexpanded: !this.state.versionexpanded, version: !this.state.versionexpanded }); */}
                  {/* }}> */}
                  {/* <i className={this.state.versionexpanded ? "fa fa-angle-up" : "fa fa-angle-down"} aria-hidden="true"></i> */}
                  {/* <i className="fa fa-angle-up" aria-hidden="true"></i> */}
                  {/* </button> */}
                  {/* <hr></hr> */}
                  {/* </CardTitle> */}
                  {/* <Collapse isOpen={this.state.versionexpanded}> */}
                  {/* <Collapse isOpen="true"> */}
                  <div className="popup-group-list-inner">
                    {this.formatusergroup(
                      this.props.dataItem.multiusergroupcode, this.props.dataItem.lsmultisites
                    )}
                  </div>
                  {/* </Collapse> */}

                  {/* </CardBody>

                            </Card> */}
                </div>
              </ModalBody>
              <div className="modal-footer">
                <button
                  type="button"
                  className="textBtn btn_white_bg"

                  onClick={this.closeusergroupinformation.bind(this)}

                > {this.props.t("Setup.Usermaster.IDS_LBL_CLOSE")}
                </button>
              </div>
            </Modal>
            : ""
          }

          {/* <Popover
              placement="bottom"
              trigger="hover"
              isOpen={this.isToolTipOpen(
                `user-${this.props.dataItem[this.props.keyfield]}`
              )}
              target={`user-${this.props.dataItem[this.props.keyfield]}`}
              toggle={() =>
                this.toggle(`user-${this.props.dataItem[this.props.keyfield]}`)
              }
            >
              <PopoverBody className="no-pad">
                <OverlayScrollbarsComponent
                  options={{ scrollbars: { autoHide: "scroll" } }}
                  style={{ maxHeight: "40vh" }}
                >
                  <div className="popup-group-list">
                    <h6>
                      {this.props.t("Master_UserMaster.ID_USERGROUPS", {
                        param: "",
                      })}
                    </h6>
                    <div className="popup-group-list-inner">
                      {this.formatdefaultusergroup(
                        this.props.dataItem.multiusergroupcode
                      )}
                    </div>

                    <div className="popup-group-list-inner">
                      {this.formatusergroup(
                        this.props.dataItem.multiusergroupcode
                      )}
                    </div>
                  </div>
                </OverlayScrollbarsComponent>
              </PopoverBody>
            </Popover> */}
        </div>
      ) : (
        ""
      )
    );
  }
}
const CustomUsergroupviewCells = withTranslation(CustomUsergroupviewCell);
// export default withTranslation(CustomUsergroupviewCell);



class Formatprotocolversion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Data: [],
      inventryexpand: true,
      inventryhistoryexpand: false,
      userMasterScreen: true,
      ServiceToUrl: "",
      ServiceMethodType: "POST",
      ServiceHeaderobject: {},
      ServcieonSuccess: undefined,
      ServcieonFailure: undefined,
    }
    this.ELNurl = window.appUrl.ELN;

    this.month = [
      this.props.t("months.IDS_LBL_JAN", { param: "" }),
      this.props.t("months.IDS_LBL_FEB", { param: "" }),
      this.props.t("months.IDS_LBL_MAR", { param: "" }),
      this.props.t("months.IDS_LBL_APR", { param: "" }),
      this.props.t("months.IDS_LBL_MAY", { param: "" }),
      this.props.t("months.IDS_LBL_JUN", { param: "" }),
      this.props.t("months.IDS_LBL_JUL", { param: "" }),
      this.props.t("months.IDS_LBL_AUG", { param: "" }),
      this.props.t("months.IDS_LBL_SEP", { param: "" }),
      this.props.t("months.IDS_LBL_OCT", { param: "" }),
      this.props.t("months.IDS_LBL_NOV", { param: "" }),
      this.props.t("months.IDS_LBL_DEC", { param: "" }),
    ];

  }

  render() {
    let d = null;
    let day = null;
    let dayname = null;
    let time = null;
    let localDate = convertUTCDateToLocalDate(
      new Date(this.props.dataItem.createdate ? this.props.dataItem.createdate : this.props.dataItem.protocolmodifiedDate)
    );
    d = new Date(
      localDate
    );
    day = d.getDate();
    dayname = this.month[d.getMonth()];
    // time = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
    day = convertdoubledigitdate(day);
    time = convertdoubledigittime(d.getHours(), d.getMinutes(), d.getSeconds());
    let year = d.getFullYear();
    let imgurl = this.ELNurl + this.imageurl + "-1";
    if (
      this.props.dataItem
        .createdbyusername !== null &&
      this.props.dataItem
        .createdbyusername !== undefined
    ) {
      imgurl =
        this.ELNurl +
        this.imageurl +
        this.props.dataItem
          .createdby;
    }
    return (<div>
      <li
        className="list-group-item"
        aria-disabled="true"
      >
        <div className="row no-gutters align-items-center">
          <div className="col-2">
            <div className="calender-list">
              <span className="d-flex eln-stamp">{dayname}</span>
              <span className="d-flex eln-date">{day}</span>
              <span className="d-flex eln-stamp">{year}</span>
              <span className="d-flex eln-stamp">{time}</span>
            </div>
          </div>
          <div className="col-10 mnuContainer2 userDetails">
            <Userdetail
              index={"Trans1-" + this.props.index}
              imgurl={imgurl}
              user={{
                usercode: this.props.dataItem
                  .createdby, username: this.props.dataItem.createdbyusername
              }

              }
            />

            <div className="col-12">


              <div className="container my-4">
                {this.props.dataItem.versionname === "1" ?
                  this.props.t(
                    "Templates.Protocoltemplates.IDS_LBL_CREATEDFILE",
                    {
                      user2: this.props.dataItem.createdbyusername,
                      user1: this.props.dataItem.versionname,
                    }
                  )
                  :
                  this.props.t("Templates.Protocoltemplates.IDS_LBL_MODIFIEDF", {
                    user2: this.props.dataItem.createdbyusername,
                    user1: this.props.dataItem.versionname,
                  })
                }


              </div>
            </div>
          </div>
        </div>
      </li>
    </div>);
  }

}

const Formatprotocolversioncell = withTranslation(Formatprotocolversion);




class FormatResultUsedDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // Data: {},
      inventryexpand: true,
      inventryhistoryexpand: false,
      userMasterScreen: true,
      ServiceToUrl: "",
      ServiceMethodType: "POST",
      ServiceHeaderobject: {},
      ServcieonSuccess: undefined,
      ServcieonFailure: undefined,
    }
    this.ELNurl = window.appUrl.ELN;

    this.month = [
      this.props.t("months.IDS_LBL_JAN", { param: "" }),
      this.props.t("months.IDS_LBL_FEB", { param: "" }),
      this.props.t("months.IDS_LBL_MAR", { param: "" }),
      this.props.t("months.IDS_LBL_APR", { param: "" }),
      this.props.t("months.IDS_LBL_MAY", { param: "" }),
      this.props.t("months.IDS_LBL_JUN", { param: "" }),
      this.props.t("months.IDS_LBL_JUL", { param: "" }),
      this.props.t("months.IDS_LBL_AUG", { param: "" }),
      this.props.t("months.IDS_LBL_SEP", { param: "" }),
      this.props.t("months.IDS_LBL_OCT", { param: "" }),
      this.props.t("months.IDS_LBL_NOV", { param: "" }),
      this.props.t("months.IDS_LBL_DEC", { param: "" }),
    ];

  }

  // componentDidMount = () => {

  //   this.setState({ Data: data });
  // }


  replaceInventorySampleStatus = (statuscode) => {
    const actions = {
      0: "Used",
      1: "Return",
      3: "Restock",
      4: "Release",
      5: "Open",
      28: "Available",
      37: "Quarantine",
      22: "Release",
      55: "Expired"
    };
    return actions[statuscode] || "Used";
  };


  ongetCommentTransactionData = (dataItem) => {
    const Isreturned_Data = dataItem?.isreturn === 1 || false;
    const { statuschangesTo, statuschangesFrom, createdbyuser, sinventoryid, jsondata, nqtyused, isCreated, showfullcomment, sequenceid } = dataItem || {};
    if (statuschangesTo !== undefined && statuschangesFrom !== undefined) {
      if (statuschangesFrom === -2) {
        return this.props.t("Inventory.IDS_MSG_INVENTORYLOWSTK", {
          username: createdbyuser,
          // oldsinventoryid: sinventoryid,
          oldsinventoryid: sequenceid ?? sinventoryid,
          newsinventoryid: jsondata,
          Quantity: nqtyused,
        });
      }
      return this.props.t("Inventory.IDS_MSG_QUARANTINESTATUS", {
        username: createdbyuser,
        oldstatus: this.replaceInventorySampleStatus(statuschangesFrom),
        // sinventoryid: sinventoryid,
        sinventoryid: sequenceid ?? sinventoryid,
        newstatus: statuschangesTo !== undefined && statuschangesTo === -1 ? "Dispose" : this.replaceInventorySampleStatus(statuschangesTo),
      });
    }
    if (showfullcomment === 1) {
      return jsondata;
    }

    if (isCreated) {
      return this.props.t("Inventory.IDS_MSG_CREATEDBY", {
        //inventoryid: dataItem.sinventoryid,
        inventoryid: dataItem.sequenceid ?? dataItem.sinventoryid,
        username: createdbyuser,
      });
    }

    return this.props.t(Isreturned_Data ? "Inventory.IDS_MSG_RESULTDISPLAYRETURNED" : "Inventory.IDS_MSG_RESULTDISPLAY", {
      sinventoryid: sequenceid,
      param2: createdbyuser,
      param1: nqtyused,
      param6: dataItem.resultedUnit,
      param3: dataItem.displayscreen,
      param4: dataItem.nqtyleft,
      param5: dataItem.batchid,
    });
  }


  rearrangeInventoryTransactionData = (data) => {
    data = data !== undefined && data.map((x) => {
      x.sinventoryid = x.sequenceid ?? x.sinventoryid;
      x.comment = this.ongetCommentTransactionData(x);
      return x;
    })
    // if (data?.length > 0) {
    //     return data?.reverse()
    // }
    return data[0] || [];
  }


  render() {
    let d = null;
    let day = null;
    let dayname = null;
    let time = null;
    let localDate = convertUTCDateToLocalDate(new Date(this.props?.dataItem?.createddate || new Date()));
    d = new Date(localDate);
    day = d.getDate();

    dayname = this.month[d.getMonth()];
    // time = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
    day = convertdoubledigitdate(day);
    time = convertdoubledigittime(d.getHours(), d.getMinutes(), d.getSeconds());
    let year = d.getFullYear();

    // let Isreturned_Data = this.props.dataItem?.jsondata?.includes("returned") || false;

    let Isreturned_Data = this.props.dataItem?.isreturn === 1 || false;

    let data = this.rearrangeInventoryTransactionData([this.props.dataItem]);
    return (
      <li className="list-group-item" aria-disabled="true" >
        <div className="row no-gutters align-items-center">
          <div className="col-2">
            <div className="calender-list">
              <span className="d-flex eln-stamp">{dayname}</span>
              <span className="d-flex eln-date">{day}</span>
              <span className="d-flex eln-stamp">{year}</span>
              <span className="d-flex eln-stamp">{time}</span>
            </div>
          </div>
          <div className="col-10 mnuContainer2 userDetails">
            <Userdetail index={"Trans-" + -1} user={this.props.dataItem.createdbyusercode} />
            <div className="col-12">
              <div className="container my-4">
                {/* {this.props.t(Isreturned_Data ? "Inventory.IDS_MSG_RESULTDISPLAYRETURNED" : "Inventory.IDS_MSG_RESULTDISPLAY", {
                  sinventoryid: this.props.dataItem?.sequenceid ?? this.props.dataItem?.sinventoryid,
                  param2: this.props.dataItem.createdbyusercode && this.props.dataItem.createdbyusercode.username,
                  param1: this.props.dataItem.nqtyused,
                  param6: this.props.dataItem.resultedUnit ?? "",
                  param3: this.props.dataItem.displayscreen,
                  param4: this.props.dataItem.nqtyleft ?? "",
                  param5: this.props.dataItem.batchid,
                })} */}
                {data?.comment || ""}
              </div>
            </div>
          </div>
        </div>
      </li>
    );
  }
}
const FormatResultUsedDetailscell = withTranslation(FormatResultUsedDetails);

class FormatResultEquipmentDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Data: [],
      inventryexpand: true,
      inventryhistoryexpand: false,
      userMasterScreen: true,
      ServiceToUrl: "",
      ServiceMethodType: "POST",
      ServiceHeaderobject: {},
      ServcieonSuccess: undefined,
      ServcieonFailure: undefined,
    }
    this.ELNurl = window.appUrl.ELN;

    this.month = [
      this.props.t("months.IDS_LBL_JAN", { param: "" }),
      this.props.t("months.IDS_LBL_FEB", { param: "" }),
      this.props.t("months.IDS_LBL_MAR", { param: "" }),
      this.props.t("months.IDS_LBL_APR", { param: "" }),
      this.props.t("months.IDS_LBL_MAY", { param: "" }),
      this.props.t("months.IDS_LBL_JUN", { param: "" }),
      this.props.t("months.IDS_LBL_JUL", { param: "" }),
      this.props.t("months.IDS_LBL_AUG", { param: "" }),
      this.props.t("months.IDS_LBL_SEP", { param: "" }),
      this.props.t("months.IDS_LBL_OCT", { param: "" }),
      this.props.t("months.IDS_LBL_NOV", { param: "" }),
      this.props.t("months.IDS_LBL_DEC", { param: "" }),
    ];

  }

  render() {
    let d = null;
    let day = null;
    let dayname = null;
    let time = null;
    let localDate = convertUTCDateToLocalDate(new Date(this.props.dataItem.createddate));
    d = new Date(localDate);
    day = d.getDate();

    dayname = this.month[d.getMonth()];
    day = convertdoubledigitdate(day);
    time = convertdoubledigittime(d.getHours(), d.getMinutes(), d.getSeconds());
    let year = d.getFullYear();

    return (
      <li className="list-group-item" aria-disabled="true" >
        <div className="row no-gutters align-items-center">
          <div className="col-2">
            <div className="calender-list">
              <span className="d-flex eln-stamp">{dayname}</span>
              <span className="d-flex eln-date">{day}</span>
              <span className="d-flex eln-stamp">{year}</span>
              <span className="d-flex eln-stamp">{time}</span>
            </div>
          </div>
          <div className="col-10 mnuContainer2 userDetails">
            <Userdetail index={"Trans-" + -1} user={this.props.dataItem.createdby} />
            <div className="col-12">
              <div className="container my-4">
                {this.props.dataItem?.historytype !== undefined ? (this.props.dataItem?.historytype === 1 ?
                  this.props.t("Inventory.IDS_MSG_EQUIPCALLIB", {
                    param1: this.props.dataItem.createdby.username,
                    param2: convertUTCDateToLocalDate(new Date(this.props.dataItem.callibrationdate)),
                    param4: this.props.dataItem.sequipmentname,
                    param5: this.props.dataItem.sequipmentid,
                  }) : this.props.t("Inventory.IDS_MSG_EQUIPMAINTAIN", {
                    param1: this.props.dataItem.createdby.username,
                    param2: convertUTCDateToLocalDate(new Date(this.props.dataItem.manintanancedate)),
                    param4: this.props.dataItem.sequipmentname,
                    param5: this.props.dataItem.sequipmentid,
                  })) : this.props.t("Inventory.IDS_MSG_RESULTEQUIPMENTDISPLAY", {
                    param1: this.props.dataItem.createdby.username,
                    param2: this.props.dataItem.displayscreen,
                    param3: this.props.dataItem.batchid,
                    param4: this.props.dataItem.sequipmentname,
                    param5: this.props.dataItem.sequipmentid,
                  })}
              </div>
            </div>
          </div>
        </div>
      </li>
    );
  }
}
const FormatResultUsedEquipment = withTranslation(FormatResultEquipmentDetails);

class Formatprotocoltransaction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Data: [],
      inventryexpand: true,
      inventryhistoryexpand: false,
      userMasterScreen: true,
      ServiceToUrl: "",
      ServiceMethodType: "POST",
      ServiceHeaderobject: {},
      ServcieonSuccess: undefined,
      ServcieonFailure: undefined,
    };
    this.ELNurl = window.appUrl.ELN;

    this.month = [
      this.props.t("months.IDS_LBL_JAN", { param: "" }),
      this.props.t("months.IDS_LBL_FEB", { param: "" }),
      this.props.t("months.IDS_LBL_MAR", { param: "" }),
      this.props.t("months.IDS_LBL_APR", { param: "" }),
      this.props.t("months.IDS_LBL_MAY", { param: "" }),
      this.props.t("months.IDS_LBL_JUN", { param: "" }),
      this.props.t("months.IDS_LBL_JUL", { param: "" }),
      this.props.t("months.IDS_LBL_AUG", { param: "" }),
      this.props.t("months.IDS_LBL_SEP", { param: "" }),
      this.props.t("months.IDS_LBL_OCT", { param: "" }),
      this.props.t("months.IDS_LBL_NOV", { param: "" }),
      this.props.t("months.IDS_LBL_DEC", { param: "" }),
    ];

  }
  render() {
    let d = null;
    let day = null;
    let dayname = null;
    let time = null;
    let year = null;
    let imgurl = this.ELNurl + this.imageurl + "-1";

    if (this.props.dataItem !== undefined) {
      // let d = null;
      // let day = null;
      // let dayname = null;
      // let time = null;
      if (
        this.props.dataItem !== undefined &&
        this.props.dataItem !== null
      ) {

        if (
          this.props.dataItem.protocolmodifiedDate !== undefined &&
          this.props.dataItem.protocolmodifiedDate !== null
        ) {

          let localdate = convertUTCDateToLocalDate(
            new Date(
              this.props.dataItem.protocolmodifiedDate
            )
          );
          d = new Date(localdate);
          // d = new Date(
          //   this.state.selectProtocolMaster.modifiedlist[
          //     index
          //   ].protocolmodifiedDate
          // );
          day = d.getDate();
          dayname = this.month[d.getMonth()];
          // time = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
          day = convertdoubledigitdate(day);
          time = convertdoubledigittime(d.getHours(), d.getMinutes(), d.getSeconds());
          year = d.getFullYear();
          let imgurl = this.ELNurl + this.imageurl + "-1";
          if (
            this.props.dataItem.protocolmodifiedDate !== null &&
            this.props.dataItem.protocolmodifiedDate !== undefined
          ) {
            imgurl =
              this.ELNurl +
              this.imageurl +
              this.props.dataItem.modifiedby
                .usercode;
          }
        }
      }
    }
    return (
      <div>
        <li
          className="list-group-item"
          aria-disabled="true"
        >
          <div className="row no-gutters align-items-center">
            <div className="col-2">
              <div className="calender-list">
                <span className="d-flex eln-stamp">{dayname}</span>
                <span className="d-flex eln-date">{day}</span>
                <span className="d-flex eln-stamp">{year}</span>
                <span className="d-flex eln-stamp">{time}</span>
              </div>
            </div>
            <div className="col-10 mnuContainer2 userDetails">
              <Suspense fallback={<div></div>}>
                <Userdetail
                  index={"Trans2-" + this.props.index}
                  imgurl={imgurl}
                  user={{ usercode: this.props.dataItem.createdby.usercode, username: this.props.dataItem.createdby.username }}
                />
              </Suspense>
              <div className="container my-4">
                {
                  this.props.dataItem
                    .protocolcomment
                }
              </div>
              {/* <p>
                {this.props.t("SheetCreation.IDS_CREATEDF", {
                  user1: this.state.selectProtocolMaster.createdbyusername,
                  user2: this.state.protocolrecord.protocolmastername,
                })}
              </p> */}
            </div>
          </div>
        </li>
      </div>
    );

  }
}

const Formatprotocoltransactioncell = withTranslation(Formatprotocoltransaction);

export const Formatprotocolordertransactioncell = (props) => {
  // class Formatprotocolordertransaction extends React.Component {

  // render() {
  return (
    <td>
      {/* <li
        key={props?.dataItem?.key}
        className="list-group-item"
      > */}
      <div className="row no-gutters align-items-center">
        <div className="col-2">
          <div className="calender-list small">
            <span className="d-flex eln-stamp">{props?.dataItem?.dayname}</span>
            <span className="d-flex eln-date">{props?.dataItem?.day}</span>
            <span className="d-flex eln-stamp">{props?.dataItem?.year}</span>
            <span className="d-flex eln-stamp ">{props?.dataItem?.time}</span>

          </div>
        </div>
        <div className="col-10 mnuContainer2 userDetails">
          <Suspense fallback={<div></div>}>
            <Userdetail
              index={props?.dataItem?.userdetailsindex}
              imgurl={props?.dataItem?.imgurl}
              user={{
                usercode: props?.dataItem?.createby?.usercode || props?.dataItem?.createby,
                username: props?.dataItem?.createby?.username
              }}
            />
          </Suspense>
          {props?.dataItem?.commentsDesign}
        </div>
      </div>
      {/* </li> */}
    </td>
  )
  // }
  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     Data: [],
  //     inventryexpand: true,
  //     inventryhistoryexpand: false,
  //     userMasterScreen: true,
  //     ServiceToUrl: "",
  //     ServiceMethodType: "POST",
  //     ServiceHeaderobject: {},
  //     ServcieonSuccess: undefined,
  //     ServcieonFailure: undefined,
  //   };
  //   this.ELNurl = window.appUrl.ELN;

  //   this.month = [
  //     this.props.t("months.IDS_LBL_JAN", { param: "" }),
  //     this.props.t("months.IDS_LBL_FEB", { param: "" }),
  //     this.props.t("months.IDS_LBL_MAR", { param: "" }),
  //     this.props.t("months.IDS_LBL_APR", { param: "" }),
  //     this.props.t("months.IDS_LBL_MAY", { param: "" }),
  //     this.props.t("months.IDS_LBL_JUN", { param: "" }),
  //     this.props.t("months.IDS_LBL_JUL", { param: "" }),
  //     this.props.t("months.IDS_LBL_AUG", { param: "" }),
  //     this.props.t("months.IDS_LBL_SEP", { param: "" }),
  //     this.props.t("months.IDS_LBL_OCT", { param: "" }),
  //     this.props.t("months.IDS_LBL_NOV", { param: "" }),
  //     this.props.t("months.IDS_LBL_DEC", { param: "" }),
  //   ];

  // }
  // render() {
  //   let d = null;
  //   let day = null;
  //   let dayname = null;
  //   let time = null;
  //   let year = null;
  //   let imgurl = this.ELNurl + this.imageurl + "-1";

  //   if (this.props.dataItem !== undefined) {
  //     if (
  //       this.props.dataItem !== undefined &&
  //       this.props.dataItem !== null
  //     ) {

  //       if (
  //         this.props.dataItem?.stepstartdate !== undefined &&
  //         this.props.dataItem?.stepstartdate !== null ||
  //         this.props.dataItem?.stependdate !== undefined &&
  //         this.props.dataItem?.stependdate !== null
  //       ) {

  //         let localdate = convertUTCDateToLocalDate(
  //           new Date(
  //             this.props.dataItem.stepstartdate !== undefined ?
  //               this.props.dataItem.stepstartdate : this.props.dataItem.stependdate
  //           )
  //         );
  //         d = new Date(localdate);
  //         day = d.getDate();
  //         dayname = this.month[d.getMonth()];
  //         day = convertdoubledigitdate(day);
  //         time = convertdoubledigittime(d.getHours(), d.getMinutes(), d.getSeconds());
  //         year = d.getFullYear();
  //         let imgurl = this.ELNurl + this.imageurl + "-1";
  //         if (
  //           this.props.dataItem.createby.createby !== null &&
  //           this.props.dataItem.createby.createby !== undefined
  //         ) {
  //           imgurl =
  //             this.ELNurl +
  //             this.imageurl +
  //             this.props.dataItem.createby.createby.usercode;
  //         }
  //       }
  //     }
  //   }
  //   return (
  //     <div>
  //       <li
  //         className="list-group-item"
  //         aria-disabled="true"
  //       >
  //         <div className="row no-gutters align-items-center">
  //           <div className="col-2">
  //             <div className="calender-list">
  //               <span className="d-flex eln-stamp">{dayname}</span>
  //               <span className="d-flex eln-date">{day}</span>
  //               <span className="d-flex eln-stamp">{year}</span>
  //               <span className="d-flex eln-stamp">{time}</span>
  //             </div>
  //           </div>
  //           <div className="col-10 mnuContainer2 userDetails">
  //             <Suspense fallback={<div></div>}>
  //               <Userdetail
  //                 index={"Trans3--2"}
  //                 imgurl={imgurl}
  //                 user={this.props.dataItem.createby}
  //               />
  //             </Suspense>
  //             <div className="container my-4">
  //               {
  //                 this.props.dataItem.action
  //               }
  //             </div>

  //           </div>
  //         </div>
  //       </li>
  //     </div>
  //   );

  // }
}

// const Formatprotocolordertransactioncell = withTranslation(Formatprotocolordertransaction);

class Formatprotocolversiondetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Data: [],
      inventryexpand: true,
      inventryhistoryexpand: false,
      userMasterScreen: true,
      ServiceToUrl: "",
      ServiceMethodType: "POST",
      ServiceHeaderobject: {},
      ServcieonSuccess: undefined,
      ServcieonFailure: undefined,
    };
    this.ELNurl = window.appUrl.ELN;

    this.month = [
      this.props.t("months.IDS_LBL_JAN", { param: "" }),
      this.props.t("months.IDS_LBL_FEB", { param: "" }),
      this.props.t("months.IDS_LBL_MAR", { param: "" }),
      this.props.t("months.IDS_LBL_APR", { param: "" }),
      this.props.t("months.IDS_LBL_MAY", { param: "" }),
      this.props.t("months.IDS_LBL_JUN", { param: "" }),
      this.props.t("months.IDS_LBL_JUL", { param: "" }),
      this.props.t("months.IDS_LBL_AUG", { param: "" }),
      this.props.t("months.IDS_LBL_SEP", { param: "" }),
      this.props.t("months.IDS_LBL_OCT", { param: "" }),
      this.props.t("months.IDS_LBL_NOV", { param: "" }),
      this.props.t("months.IDS_LBL_DEC", { param: "" }),
    ];

  }
  render() {
    let d = null;
    let day = null;
    let dayname = null;
    let time = null;
    let year = null;
    let imgurl = this.ELNurl + this.imageurl + "-1";

    if (this.props.dataItem !== undefined) {
      if (
        this.props.dataItem !== undefined &&
        this.props.dataItem !== null
      ) {

        if (
          this.props.dataItem.createdbyusername !== undefined &&
          this.props.dataItem.createdbyusername !== null
        ) {
          if (
            this.props.dataItem.createdate !== undefined
          ) {
            let localdate = convertUTCDateToLocalDate(
              new Date(this.props.dataItem.createdate)
            );
            d = new Date(localdate);
          } else {
            d = new Date();
          }
          day = d.getDate();
          dayname = this.month[d.getMonth()];
          day = convertdoubledigitdate(day);
          time = convertdoubledigittime(
            d.getHours(),
            d.getMinutes(),
            d.getSeconds()
          );
          let year = d.getFullYear();
          let imgurl = this.ELNurl + this.imageurl + "-1";
          if (
            this.props.dataItem.createdbyusername !==
            null &&
            this.props.dataItem.createdbyusername !==
            undefined
          ) {
            imgurl =
              this.ELNurl +
              this.imageurl +
              this.props.dataItem.createdby;
          }
        }
      }
      return (
        <div>
          <li
            className="list-group-item"
            aria-disabled="true"
          >
            <div className="row no-gutters align-items-center">
              <div className="col-2">
                <div className="calender-list">
                  <span className="d-flex eln-stamp">{dayname}</span>
                  <span className="d-flex eln-date">{day}</span>
                  <span className="d-flex eln-stamp">{year}</span>
                  <span className="d-flex eln-stamp">{time}</span>
                </div>
              </div>
              <div className="col-10 mnuContainer2 userDetails">
                <Suspense fallback={<div></div>}>
                  <Userdetail
                    index={"Trans1-" + this.props.index}
                    imgurl={imgurl}
                    user={{ usercode: this.props.dataItem.createdby, username: this.props.dataItem.createdbyusername }}
                  />
                </Suspense>
                <div className="container my-4">
                  {
                    this.props.dataItem.versionno !== 1 ?
                      this.props.t("Orders.Protocolorders.IDS_LBL_MODIFIEDF", {
                        user2:
                          this.props.dataItem.createdbyusername,
                        user1:
                          this.props.dataItem.versionno,
                      })
                      :
                      this.props.t("Orders.Protocolorders.IDS_LBL_CREATEDFILE", {
                        user2:
                          this.props.dataItem.createdbyusername,
                        user1:
                          this.props.dataItem.versionno,
                      })
                  }
                </div>

              </div>
            </div>
          </li>
        </div>
      );

    }
  }
}

const Formatprotocolversiondetailscell = withTranslation(Formatprotocolversiondetails);

class Custominventry extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Data: [],
      inventryexpand: true,
      inventryhistoryexpand: false,
      userMasterScreen: true,
      ServiceToUrl: "",
      ServiceMethodType: "POST",
      ServiceHeaderobject: {},
      ServcieonSuccess: undefined,
      ServcieonFailure: undefined,
    };
    // this.month = this.props.details.month;
    this.ELNurl = window.appUrl.ELN;

    this.imageurl = "";
    if (isMultitenant === 1 || isMultitenant === 2) {
      this.imageurl = "/User/Cloudprofile/";
    } else {
      this.imageurl = "/User/profile/";
    }

    this.month = [
      this.props.t("months.IDS_LBL_JAN", { param: "" }),
      this.props.t("months.IDS_LBL_FEB", { param: "" }),
      this.props.t("months.IDS_LBL_MAR", { param: "" }),
      this.props.t("months.IDS_LBL_APR", { param: "" }),
      this.props.t("months.IDS_LBL_MAY", { param: "" }),
      this.props.t("months.IDS_LBL_JUN", { param: "" }),
      this.props.t("months.IDS_LBL_JUL", { param: "" }),
      this.props.t("months.IDS_LBL_AUG", { param: "" }),
      this.props.t("months.IDS_LBL_SEP", { param: "" }),
      this.props.t("months.IDS_LBL_OCT", { param: "" }),
      this.props.t("months.IDS_LBL_NOV", { param: "" }),
      this.props.t("months.IDS_LBL_DEC", { param: "" }),
    ];
  }
  isToolTipOpen = (targetName) => {
    return this.state[targetName] ? this.state[targetName].tooltipOpen : false;
  };
  toggle = (targetName) => {
    if (!this.state[targetName]) {
      this.setState({
        ...this.state,
        [targetName]: {
          tooltipOpen: true,
        },
      });
    } else {
      this.setState({
        ...this.state,
        [targetName]: {
          tooltipOpen: !this.state[targetName].tooltipOpen,
        },
      });
    }

    this.setState({
      transactionexpanded: false,
      workflowexpanded: false,
      inventryexpand: false,
      inventryhistoryexpand: false,
    });
  };

  formatversiondetails() {
    var detail = [];

    if (
      this.state.Data !== undefined &&
      this.state.Data !== null &&
      this.state.Data.length !== 0
    ) {
      let d = null;
      let day = null;
      let dayname = null;
      let time = null;

      // if (this.props.dataItem.lsfileversion !== undefined && this.props.dataItem.lsfileversion !== null && this.props.dataItem.lsfileversion.length > 0) {

      for (let index = 0; index < this.state.Data.length; index++) {
        let createby = {
          usercode: this.state.Data[index].usercode,
          username: this.state.Data[index].createdbyusername,
        };
        // if (index === 0) {
        if (
          this.state.Data[index].usercode !== undefined &&
          this.state.Data[index].createdbyusername !== null
        ) {
          let localdate = convertUTCDateToLocalDate(
            new Date(this.state.Data[index].createddate)
          );

          d = new Date(localdate);
          day = d.getDate();
          dayname = this.month[d.getMonth()];
          // time = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
          day = convertdoubledigitdate(day);
          time = convertdoubledigittime(
            d.getHours(),
            d.getMinutes(),
            d.getSeconds()
          );
          let year = d.getFullYear();
          // let gmt =d.toString();
          // gmt=gmt.slice(25,34);

          let imgurl = this.ELNurl + this.imageurl + "-1";
          if (
            this.state.Data[index].usercode !== null &&
            this.state.Data[index].createdbyusername !== undefined
          ) {
            imgurl =
              this.ELNurl + this.imageurl + this.state.Data[index].usercode;
          }



          detail.push(
            <li
              key={this.props.dataItem.repositorydatacode + "Trans_" + index}
              className="list-group-item"
              aria-disabled="true"
            >
              <div className="row no-gutters align-items-center">
                <div className="col-2">
                  <div className="calender-list small">
                    <span className="d-flex eln-stamp">{dayname}</span>
                    <span className="d-flex eln-date">{day}</span>
                    <span className="d-flex eln-stamp">{year}</span>
                    <span className="d-flex eln-stamp">{time}</span>
                    {/* <span className="d-flex eln-stamp">{gmt}</span> */}
                  </div>
                </div>
                <div className="col-10 mnuContainer2 userDetails">
                  <Userdetail
                    index={"Trans-" + index}
                    imgurl={imgurl}
                    user={createby}
                  />
                  <p>
                    {
                      this.state.Data[index].historydetails !== undefined ?
                        this.state.Data[index].historydetails :
                        this.state.Data[index].protocolsampleusedDetail !== undefined ?
                          this.state.Data[index].protocolsampleusedDetail :
                          this.state.Data[index].logbooksampleusedDetail !== undefined ?
                            this.state.Data[index].logbooksampleusedDetail : ""
                    }


                  </p>
                </div>
              </div>
            </li>
          );

          // detail.push(
          //   <li
          //     key={this.props.dataItem.repositorydatacode + "Trans_" + index}
          //     className="list-group-item"
          //     aria-disabled="true"
          //   >
          //     <div className="row no-gutters align-items-center">
          //       <div className="col-2">
          //         <div className="calender-list small">
          //           <span className="d-flex eln-stamp">{dayname}</span>
          //           <span className="d-flex eln-date">{day}</span>
          //           <span className="d-flex eln-stamp">{time}</span>
          //         </div>
          //       </div>
          //       <div className="col-10 mnuContainer2 userDetails">
          //         <Userdetail
          //           index={"Trans-" + index}
          //           imgurl={imgurl}
          //           user={createby}
          //         />
          //         {/*  <div className="row">
          //                       <div className="col-md-4">
          //                           <div className="p-2">
          //                               <b>Details</b>
          //                           </div>

          //                       </div>

          //                       <div className="col-md-6">
          //                           <div className="p-2">
          //                               {this.state.Data[index].historydetails}
          //                           </div>

          //                       </div>
          //                   </div>

          //                   <div className="row">
          //                       <div className="col-md-4">
          //                           <div className="p-2">
          //                               <b>Screen Name</b>
          //                           </div>

          //                       </div>

          //                       <div className="col-md-6">
          //                           <div className="p-2">
          //                               {this.state.Data[index].screenmodule}
          //                           </div>

          //                       </div>
          //                   </div> */}
          //         {/* <p>{this.state.Data[index].historydetails}</p> */}
          //         <div class="">
          //           {this.state.Data[index].historydetails}
          //         </div>
          //         {/* <div className="col">
          //                       <div className="col-12">
          //                           {this.state.Data[index].screenmodule}

          //                       </div>
          //                   </div> */}
          //       </div>{" "}
          //     </div>
          //   </li>
          // );
        }

        // }
      }

      //       detail.push(<li className="list-group-item" aria-disabled="true">
      //           {this.props.t("SheetCreation.IDS_NOTVERSIONED", {
      //              param: "",
      //        })}
      //   </li>);
    } else {
      detail.push(
        <ul className="list-group list-group-flush">
          <li className="list-group-item" aria-disabled="true">
            <p>
              {this.props.t("Masters.Inventory.IDS_LBL_NOINVENTRYDETAAILS", {
                param: "",
              })}
            </p>
          </li>
        </ul>
      );
    }

    let detailsvalue = (
      <ul className="list-group list-group-flush">{detail}</ul>
    );
    return detailsvalue;
  }

  async onfinddataclick(e) {

    // if (!this.state.inventryexpand) {
    let passobject = {
      repositorycode: this.props.dataItem.repositorycode,
      repositorydatacode: this.props.dataItem.repositorydatacode,
    };

    Servicecalls(
      "" + this.ELNurl + "/Master/getinventoryhistory",
      passobject,
      (res) => {
        this.onRepositorySuccess(res);
      },
      (res) => { }
    );
  }

  onRepositorySuccess(res) {
    this.setState({
      Data: res
      // inventryexpand: !this.state.inventryexpand,
      // inventryhistoryexpand: !this.state.inventryhistoryexpand,
    });
  }

  // onRepositoryFailure(responce) {

  // }

  render() {
    return (
      this.props.dataItem[this.props.keyfield] !== undefined ? (
        <React.Fragment>

          <button
            id={`user-${this.props.dataItem[this.props.keyfield]}`}
            className="grid-icons mg-t-1"
            alt="user"
            data-placement="top"
            title={this.props.t("Templates.Sheettemplates.IDS_LBL_HISTORY")}
            onClick={() => { this.setState({ customInventry: true }); this.onfinddataclick(); }}

          >
            <i className="far fa-eye 3"></i>

          </button>
          {this.state.customInventry ?
            <Modal
              isOpen={this.state.customInventry}
              backdrop={true}
              toggle={() => { this.setState({ customInventry: !this.state.customInventry }) }}
              className=" modal-md smallPopup"
            >
              <div className="modal-header">
                <h5 className="modal-title" id="staticBackdropLabel">
                  {/* {"Share with other users"} */}
                </h5>
                <button
                  type="button"
                  className="btn_white_bg"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => { this.setState({ customInventry: false }) }}
                >
                  <i className="fas fa-times" aria-hidden="true"></i>
                </button>
              </div>
              <ModalBody>
                <OverlayScrollbarsComponent
                  options={{ scrollbars: { autoHide: "scroll" } }}
                >
                  <div className="popup-group-list full-width popup-lg-container">
                    <Card className="listed-user-details no-border-card">
                      <CardBody>
                        <CardTitle>
                          {this.props.t("Masters.Inventory.IDS_LBL_INVENTRYHISTORY", {
                            param: "",
                          })}
                          {/* <button className="btn float-right" onClick={this.onfinddataclick.bind(this)}

                                                    > */}
                          <button
                            className="btn float-right"
                            onClick={() => {
                              this.setState({
                                inventryexpand: !this.state.inventryexpand,
                              });
                            }}
                          >
                            <i
                              className={
                                this.state.inventryexpand
                                  ? "fa fa-angle-up"
                                  : "fa fa-angle-down"
                              }
                              aria-hidden="true"
                            ></i>
                            {/* <i className="fa fa-angle-up" aria-hidden="true"></i> */}
                          </button>
                        </CardTitle>
                        <Collapse isOpen={this.state.inventryexpand}>
                          {this.formatversiondetails()}
                        </Collapse>
                      </CardBody>
                    </Card>

                  </div>
                </OverlayScrollbarsComponent>
              </ModalBody>
              <div className="modal-footer">
                <button
                  type="button"
                  className="textBtn btn_white_bg"
                  onClick={() => this.setState({ customInventry: false })}
                > {withTranslation("Orders.Sheetorders.IDS_LBL_CLOSE")}
                </button>
              </div>
            </Modal>
            : ""
          }


          {/* <Popover
              placement="bottom"
              trigger="hover"
              className="popoverContainer"
              id="popover-trigger-focus"
              isOpen={this.isToolTipOpen(
                `user-${this.props.dataItem[this.props.keyfield]}`
              )}
              target={`user-${this.props.dataItem[this.props.keyfield]}`}
              toggle={() =>
                this.toggle(`user-${this.props.dataItem[this.props.keyfield]}`)
              }
            >
              <PopoverBody className="no-padding">
                <OverlayScrollbarsComponent style={{ maxHeight: "400px" }}>
                  <Card className="box-md listed-user-details">
                    <CardBody>
                      <CardTitle>
                        {this.props.t("SheetCreation.IDS_INVENTRYHISTORY", {
                          param: "",
                        })}
                        <button
                          className="btn float-right"
                          onClick={() => {
                            this.setState({
                              inventryexpand: !this.state.inventryexpand,
                            });
                            this.onfinddataclick();
                          }}
                        >
                          <i
                            className={
                              this.state.inventryhistoryexpand
                                ? "fa fa-angle-up"
                                : "fa fa-angle-down"
                            }
                            aria-hidden="true"
                          ></i>
                        </button>
                      </CardTitle>
                      {this.state.inventryhistoryexpand ? (
                        <Collapse isOpen={this.state.inventryhistoryexpand}>
                          {this.state.inventryhistoryexpand &&
                            this.formatversiondetails()}
                        </Collapse>
                      ) : (
                        ""
                      )}
                    </CardBody>
                  </Card>
                </OverlayScrollbarsComponent>
              </PopoverBody>
            </Popover> */}
        </React.Fragment>
      ) : (
        ""
      )
    );
  }
}

const Custominventrycells = withTranslation(Custominventry);

class Customprotocolorder extends React.Component {
  constructor(props) {
    super(props);
    let filterdate = new Date();
    this.state = {
      Data: [],
      transactionhistory: {},
      inventryexpand: true,
      workflowexpanded: true,
      userMasterScreen: true,
      ServiceToUrl: "",
      ServiceMethodType: "POST",
      ServiceHeaderobject: {},
      ServcieonSuccess: undefined,
      ServcieonFailure: undefined,
      versionexpanded: true,
      versionlist: undefined,
      protocolstephistory: false,
      clickTimer: null,
      OnKendoDateFrom: new Date(filterdate.setDate(filterdate.getDate() - 7)),
      OnKendoDateTo: new Date(),
      transactionscolumn: [
        {
          header: this.props.t("Templates.Sheettemplates.IDS_LBL_TRANS"),
          datatype: "protocolorderstephistorycode",
          rowselector: false,
          visible: false,
          doFilter: true,
          sortable: false,
          resizable: false,
          celltype: "formatprotocolordertransactiondetails",
          className: "simple-grid-view",
          width: "100px"
        },
      ],
      Versioncolumns: [
        {
          header: this.props.t("Templates.Sheettemplates.IDS_LBL_VERSIONHISTORY"),
          datatype: "protocolorderversioncode",
          rowselector: false,
          visible: false,
          doFilter: true,
          sortable: false,
          resizable: false,
          celltype: "formatprotocolorderversiondetails",
          className: "simple-grid-view",
          width: "100px"
        }
      ],
      protocoltransactionhistory: undefined,
      FilterRecord: {
        sFromDate:
          (parseInt(new Date().getMonth()) + 1).toString() +
          "/" +
          new Date().getDate().toString() +
          "/" +
          new Date().getFullYear().toString(),
        sToDate:
          (parseInt(new Date().getMonth()) + 1).toString() +
          "/" +
          new Date().getDate().toString() +
          "/" +
          new Date().getFullYear().toString(),

      },
    };

    this.ELNurl = window.appUrl.ELN;

    this.imageurl = "";
    if (isMultitenant === 1 || isMultitenant === 2) {
      this.imageurl = "/User/Cloudprofile/";
    } else {
      this.imageurl = "/User/profile/";
    }

    this.month = [
      this.props.t("months.IDS_LBL_JAN", { param: "" }),
      this.props.t("months.IDS_LBL_FEB", { param: "" }),
      this.props.t("months.IDS_LBL_MAR", { param: "" }),
      this.props.t("months.IDS_LBL_APR", { param: "" }),
      this.props.t("months.IDS_LBL_MAY", { param: "" }),
      this.props.t("months.IDS_LBL_JUN", { param: "" }),
      this.props.t("months.IDS_LBL_JUL", { param: "" }),
      this.props.t("months.IDS_LBL_AUG", { param: "" }),
      this.props.t("months.IDS_LBL_SEP", { param: "" }),
      this.props.t("months.IDS_LBL_OCT", { param: "" }),
      this.props.t("months.IDS_LBL_NOV", { param: "" }),
      this.props.t("months.IDS_LBL_DEC", { param: "" }),
    ];
  }
  isToolTipOpen = (targetName) => {
    return this.state[targetName] ? this.state[targetName].tooltipOpen : false;
  };

  componentDidMount() {
    if (this.props.dataItem !== undefined) {
      let passobject = {
        usercode: this.props.dataItem.createby,
      };

      Servicecalls(
        "" + this.ELNurl + "/User/getUserOnCode",
        passobject,
        this.onRepositorySuccess.bind(this),
        this.onRepositoryFailure.bind(this)
      );
      const toDate = new Date();
      const fromDate = new Date(toDate);
      fromDate.setHours(0, 0, 0, 0);
      let passobjecthistory = {
        protocolordercode: this.props.dataItem.protocolordercode,
        fromdate: fromDate,
        todate: toDate,
      };
      Servicecalls(
        "" + this.ELNurl + "/protocol/getProtocolOrderworkflowhistoryList",
        passobjecthistory,
        this.ongetProtocolOrderworkflowhistoryListSuccess.bind(this),
        this.ongetProtocolOrderworkflowhistoryListFailure.bind(this)
      );

      let passobject1 = {
        protocolordercode: this.props.dataItem.protocolordercode,
        fromdate: fromDate,
        todate: toDate,
      };
      Servicecalls(
        "" + this.ELNurl + "/protocol/getprotocolstephistory",
        passobject1,
        this.ongetprotocolstephistorySuccess.bind(this),
        this.ongetProtocolOrderworkflowhistoryListFailure.bind(this)
      );
    }

  }

  ongetprotocolstephistorySuccess(responce) {

    // this.state.protocolorderstephistory.push(responce);
    const arrayToSort = responce.sort((a, b) => b.protocolorderstephistorycode - a.protocolorderstephistorycode);

    this.setState({
      protocolorderstephistory: responce,
      protocolstephistory:
        !this.state.protocolstephistory,
      protocoltransactionhistory: arrayToSort
    });
  }

  toggle = (targetName) => {
    if (!this.state[targetName]) {
      this.setState({
        ...this.state,
        [targetName]: {
          tooltipOpen: true,
        },
      });
    } else {
      this.setState({
        ...this.state,
        [targetName]: {
          tooltipOpen: !this.state[targetName].tooltipOpen,
        },
      });
    }

    this.setState({
      transactionexpanded: false,
      workflowexpanded: false,
    });
  };



  onfindversionclick(e) {
    // if (this.state.versionexpanded) {
    //   this.setState({
    //     versionexpanded: !this.state.versionexpanded,
    //   });
    // } else {
    const toDate = new Date();
    const fromDate = new Date(toDate);
    fromDate.setHours(0, 0, 0, 0);
    let passobject = {
      protocolordercode: this.props.dataItem.protocolordercode,
      fromdate: fromDate,
      todate: toDate
    };
    Servicecalls(
      "" + this.ELNurl + "/protocol/GetProtocolorderVersionDetails",
      passobject,
      this.onGetProtocolVersionDetailsSuccess.bind(this),
      this.onGetProtocolVersionDetailsFailure.bind(this)
    );
    // }
  }
  onGetProtocolVersionDetailsSuccess = (response) => {
    this.setState({
      // versionlist: response.lsprotocolorderversion,
      versiondata: response.lsprotocolorderversion.reverse()
      // versionexpanded: !this.state.versionexpanded,
    });
  };
  onGetProtocolVersionDetailsFailure(res) { }




  async onfinddataworkflowclick(e) {
    const toDate = new Date();
    const fromDate = new Date(toDate);
    fromDate.setHours(0, 0, 0, 0);
    let passobject = {
      protocolordercode: this.props.dataItem.protocolordercode,
      fromdate: fromDate,
      todate: toDate,
    };
    Servicecalls(
      "" + this.ELNurl + "/protocol/getProtocolOrderworkflowhistoryList",
      passobject,
      this.ongetProtocolOrderworkflowhistoryListSuccess.bind(this),
      this.ongetProtocolOrderworkflowhistoryListFailure.bind(this)
    );
  }

  ongetProtocolOrderworkflowhistoryListSuccess(response) {
    this.setState({
      Data: response.sort((a, b) => b.createdate - a.createdate)
      // workflowexpanded: !this.state.workflowexpanded
      // workflowehistoryxpanded: !this.state.workflowehistoryxpanded,
    });
  }

  ongetProtocolOrderworkflowhistoryListFailure(res) { }

  async onfinddataclick(e) {

    let passObjDetAudit = store.getState().Loggeduser;

    if (this.props.dataItem.filefor === "EPO") {
      passObjDetAudit.objsilentaudit = Silentauditobject(
        "view",
        "Protocol Orders",
        this.props.t("Orders.Protocolorders.IDS_AUDIT_TRANSHISTORYPROTOCOL", {
          screen: orderTypeforprotocol(this.props.dataItem.protocoltype),
          orderid: this.props.dataItem.protoclordername,
          user: store.getState().Loggeduser.username,
          screenName: "Pending work"

        })
      );
    }
    else if (this.props.dataItem.filefor === "ECO") {
      passObjDetAudit.objsilentaudit = Silentauditobject(
        "view",
        "Protocol Orders",
        this.props.t("Orders.Protocolorders.IDS_AUDIT_TRANSHISTORYPROTOCOL", {
          screen: orderTypeforprotocol(this.props.dataItem.protocoltype),
          orderid: this.props.dataItem.protoclordername,
          user: store.getState().Loggeduser.username,
          screenName: "Completed work"

        })
      );
    }
    Servicecalls(
      "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
      passObjDetAudit,
      (res) => { },
      (res) => { }
    );

    // if (this.state.inventryexpand && this.state.inventryhistoryexpand) {
    //   this.setState({
    //     inventryexpand: !this.state.inventryexpand,
    //     inventryhistoryexpand: !this.state.inventryhistoryexpand,
    //   });
    // } else {
    let passobject = {
      usercode: this.props.dataItem.createby !== undefined ? this.props.dataItem.createby : sessionStorage.User,
    };

    Servicecalls(
      "" + this.ELNurl + "/User/getUserOnCode",
      passobject,
      this.onRepositorySuccess.bind(this),
      this.onRepositoryFailure.bind(this)
    );

    // this.setState({
    //   inventryexpand: !this.state.inventryexpand
    // inventryhistoryexpand: !this.state.inventryhistoryexpand,
    // });
    // }
  }
  onRepositoryFailure(res) { }
  onRepositorySuccess(response) {
    this.setState({
      transactionhistory: response,
      inventryexpand: !this.state.inventryexpand
      // inventryhistoryexpand: !this.state.inventryhistoryexpand,
    });
  }

  onClose(e) {
    this.setState({ protocolView: false })

    let ordertypename = this.props.dataItem.protocoltype !== undefined ? this.props.dataItem.protocoltype === 1 ? "ELN Protocol order" :
      this.props.dataItem.protocoltype === 2 ? "Dynamic Protocol order" : "" : ""
    this.setState({ ordertypename: ordertypename })

  }
  handleclickevent = (event) => {
    // if (this.state.clickTimer === null) {
    //   const timer = window.setTimeout(() => {
    this.setState({ protocolView: true });
    this.TemplateHistroyService({
      id: 1,
      type: "Current Date"
    });
    //  this.onfinddataclick(); this.onfinddataworkflowclick(); this.onfindversionclick()
    //     console.log("single clicked");
    //     this.setState({ clickTimer: null });
    //   }, 250);
    //   this.setState({ clickTimer: timer });
    // } else {
    //   window.clearTimeout(this.state.clickTimer);
    //   this.setState({ sheetView: false, clickTimer: null });
    // }
  }

  handleChange = (event) => {
    this.TemplateHistroyService(event);
  };

  handleTabClick = (tab) => {
    this.setState({
      activeTab: tab
    })
  };

  TemplateHistroyService = async (event, fdate, tdate) => {
    let id = event.id;
    let passObjDet = {
      protocolordercode: this.props.dataItem.protocolordercode,
    };

    if (id === 1) {
      const toDate = new Date();
      const fromDate = new Date();
      fromDate.setHours(0, 0, 0, 0);
      passObjDet.fromdate = fromDate;
      passObjDet.todate = toDateFilter(toDate);
    } else if (id === 2) {
      const toDate = new Date();
      const fromDate = new Date();
      fromDate.setDate(fromDate.getDate() - 7);
      fromDate.setHours(0, 0, 0, 0);
      passObjDet.fromdate = fromDate;
      passObjDet.todate = toDateFilter(toDate);
    } else if (id === 3) {
      // const toDate = new Date();
      // const fromDate = new Date(toDate);
      // fromDate.setDate(fromDate.getDate() - 30);
      const toDate = new Date();
      const fromDate = new Date();
      fromDate.setDate(toDate.getDate() - 30);
      fromDate.setHours(0, 0, 0, 0);
      passObjDet.fromdate = fromDate;
      passObjDet.todate = toDateFilter(toDate);
    } else if (id === 4) {
      if (fdate && tdate) {
        const toDate = tdate;
        toDate.setHours(new Date().getHours());
        const fromDate = fdate;
        passObjDet.fromdate = fromDate;
        passObjDet.todate = toDateFilter(toDate);
      } else {
        const toDate = new Date();
        const fromDate = new Date();
        fromDate.setDate(fromDate.getDate() - 7);
        fromDate.setHours(0, 0, 0, 0);
        passObjDet.fromdate = fromDate;
        passObjDet.todate = toDateFilter(toDate);


        let KendoDateFrom =
          (parseInt(fromDate.getMonth()) + 1).toString() +
          "/" +
          fromDate.getDate().toString() +
          "/" +
          fromDate.getFullYear().toString();
        let KendoDateTo =
          (parseInt(toDate.getMonth()) + 1).toString() +
          "/" +
          toDate.getDate().toString() +
          "/" +
          toDate.getFullYear().toString();
        this.setState({
          OnKendoDateFrom: KendoDateFrom,
          OnKendoDateTo: KendoDateTo,
        })
      }
    }

    const commonServicecall = (url, passObjDet, RtnObjects) => {
      return new Promise((resolve, reject) => {
        Servicecalls(
          `${this.ELNurl}${url}`,
          passObjDet,
          (response) => {
            try {
              const data =
                RtnObjects === "VersionData"
                  ? response?.lsprotocolorderversion
                  : response;
              let mappedData = data?.map((item) => {
                if (RtnObjects === "TransactionHistory") {
                  item.createdateobj =
                    item.stepstartdate ||
                    item.stependdate ||
                    item.stepskipeddate;
                  item.orderobjects = item.orderobjects && JSON.parse(item.orderobjects)
                } else {
                  item.createdateobj = item.createdate;
                }

                item.type =
                  RtnObjects === "TransactionHistory"
                    ? "Transaction"
                    : RtnObjects === "WorkflowHistory"
                      ? "Workflow"
                      : "Version";

                return item;
              });

              if (RtnObjects === "TransactionHistory") {
                mappedData.push({
                  ...this.props.dataItem,
                  createdby: {
                    username: this.props.dataItem.Createdby_Username,
                    usercode: this.props.dataItem.createby
                  },
                  isOriginal: true,
                  type: "Transaction"
                });
              }
              resolve(mappedData || []);
            } catch (error) {
              reject(error);
            }
          },
          (error) => {
            reject(error);
          }
        );
      });
    };


    try {
      const [TransactionHistory, VersionData, WorkflowHistory] = await Promise.all([
        commonServicecall(
          "/protocol/getprotocolstephistory",
          passObjDet,
          "TransactionHistory"
        ),
        commonServicecall(
          "/protocol/GetProtocolorderVersionDetails",
          passObjDet,
          "VersionData"
        ),
        commonServicecall(
          "/protocol/getProtocolOrderworkflowhistoryList",
          passObjDet,
          "WorkflowHistory"
        ),
      ]);

      let AllHistoryData = [...TransactionHistory, ...VersionData, ...WorkflowHistory].sort((a, b) => {
        const getTime = (item) =>
          typeof item.createdateobj === "number"
            ? item.createdateobj
            : Date.parse(item.createdateobj);
        const diff = getTime(b) - getTime(a);
        if (diff === 0) {
          return (a.id || "").toString().localeCompare((b.id || "").toString());
        }
        return diff;
      });
      const FormatHistorys = (finalHistory) => {
        let historys = finalHistory?.reduce((acc, curr, index) => {
          if (curr?.type === "Workflow") {
            acc.push(this.formatworrkflowhistorydetails(curr, index))
          } else if (curr?.type === "Transaction") {
            acc.push(this.formatprotocolordertransactiondetails(curr, index))
          } else if (curr?.type === "Version") {
            acc.push(this.formatprotocolorderversiondetails(curr, index))
          }
          return acc;
        }, [])
        return historys;
      }
      AllHistoryData = AllHistoryData.map((items, index) => { items.id = index; return items })
      let AllHistoryDatawithDesign = FormatHistorys(AllHistoryData || [])
      console.log(AllHistoryData);
      this.setState({ screenHistoryDatas: AllHistoryDatawithDesign?.map((items) => { items.select = false; return items }), selecteddatevalue: event, })
    } catch (error) {
      console.error("Error fetching histories:", error);
      throw error;
    }
    // Servicecalls(
    //   "" + this.ELNurl + "/protocol/getProtocolOrderworkflowhistoryList",
    //   passObjDet,
    //   (response) => {
    //     this.setState({
    //       selecteddatevalue: event,
    //       Data: response.sort((a, b) => a.historycode - b.historycode)
    //     });
    //   },
    //   (res) => { }
    // );

    // Servicecalls(
    //   "" + this.ELNurl + "/protocol/GetProtocolorderVersionDetails",
    //   passObjDet,
    //   (response) => {
    //     this.setState({
    //       selecteddatevalue: event,
    //       // versionlist: response.lsprotocolorderversion,
    //       versiondata: response.lsprotocolorderversion.reverse(),

    //     });
    //   },
    //   (res) => { }
    // );

    // Servicecalls(
    //   "" + this.ELNurl + "/protocol/getprotocolstephistory",
    //   passObjDet,
    //   (responce) => {
    //     const arrayToSort = responce.sort((a, b) => b.protocolorderstephistorycode - a.protocolorderstephistorycode);
    //     this.setState({
    //       protocolorderstephistory: responce,
    //       protocoltransactionhistory: arrayToSort
    //     });
    //   },
    //   (res) => { }

    // );


  };

  formatprotocolorderversiondetails(dataItem, index) {

    let d = null;
    let day = null;
    let dayname = null;
    let time = null;

    if (dataItem.createdate !== undefined) {
      let localdate = convertUTCDateToLocalDate(
        new Date(dataItem.createdate)
      );
      d = new Date(localdate);
    } else {
      d = new Date();
    }

    day = d.getDate();
    dayname = this.month[d.getMonth()];
    // time = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
    day = convertdoubledigitdate(day);
    time = convertdoubledigittime(
      d.getHours(),
      d.getMinutes(),
      d.getSeconds()
    );
    let year = d.getFullYear();

    let imgurl = this.ELNurl + this.imageurl + "-1";
    if (
      dataItem.createdbyusername !== null &&
      dataItem.createdbyusername !== undefined
    ) {
      imgurl =
        this.ELNurl +
        this.imageurl +
        dataItem.createdby;
    }
    let content = null;
    // if (createby) {
    if (Number(dataItem?.versionno) === 1) {
      content = this.props.t("Orders.Protocolorders.IDS_LBL_CREATEDFILE", {
        user2: dataItem.createdbyusername,
        user1: dataItem.versionno,
      })
    }
    else {
      content = this.props.t("Orders.Protocolorders.IDS_LBL_MODIFIEDF", {
        user2: dataItem.createdbyusername,
        user1: dataItem.versionno,
      })
    }
    // }
    return (
      {
        ...dataItem, userdetailsindex: "version_" + index, key: dataItem.protocolordercode + "version_", dayname: dayname, day: day, year: year, time: time, imgurl: imgurl, commentsDesign:
          (<p>
            {content}
          </p>)
      }
    );

    //   if (
    //     this.props.dataItem !== undefined &&
    //     this.props.dataItem !== null
    //     // this.props.dataItem.length > 0
    //   ) {
    //     for (let index = this.state.versionlist.length - 1; index >= 0; index--) {
    //       if (
    //         this.state.versionlist[index].createdbyusername !== undefined &&
    //         this.state.versionlist[index].createdbyusername !== null
    //       ) {
    //         if (this.state.versionlist[index].createdate !== undefined) {
    //           let localdate = convertUTCDateToLocalDate(
    //             new Date(this.state.versionlist[index].createdate)
    //           );
    //           d = new Date(localdate);
    //         } else {
    //           d = new Date();
    //         }

    //         day = d.getDate();
    //         dayname = this.month[d.getMonth()];
    //         // time = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
    //         day = convertdoubledigitdate(day);
    //         time = convertdoubledigittime(
    //           d.getHours(),
    //           d.getMinutes(),
    //           d.getSeconds()
    //         );
    //         let year = d.getFullYear();
    //         // let gmt =d.toString();
    //         // gmt=gmt.slice(25,34);

    //         let imgurl = this.ELNurl + this.imageurl + "-1";
    //         if (
    //           this.state.versionlist[index].createdbyusername !== null &&
    //           this.state.versionlist[index].createdbyusername !== undefined
    //         ) {
    //           imgurl =
    //             this.ELNurl +
    //             this.imageurl +
    //             this.state.versionlist[index].createdby;
    //         }
    //         detail.push(
    //           <li
    //             key={this.props.dataItem.protocolordercode + "Trans_" + index}
    //             className="list-group-item"
    //             aria-disabled="true"
    //           >
    //             <div className="row no-gutters align-items-center">
    //               <div className="col-2">
    //                 <div className="calender-list">
    //                   <span className="d-flex eln-stamp">{dayname}</span>
    //                   <span className="d-flex eln-date">{day}</span>
    //                   <span className="d-flex eln-stamp">{year}</span>
    //                   <span className="d-flex eln-stamp ">{time}</span>
    //                   {/* <span className="d-flex eln-stamp">{gmt}</span> */}
    //                 </div>
    //               </div>
    //               <div className="col-10 mnuContainer2 userDetails">
    //                 <Userdetail
    //                   index={"Trans-" + index}
    //                   imgurl={imgurl}
    //                   user={this.state.versionlist[index].createdby}
    //                 />

    //                 <div className="col-12">
    //                   {this.props.t("Orders.Protocolorders.IDS_LBL_MODIFIEDF", {
    //                     user2: this.state.versionlist[index].createdbyusername,
    //                     user1: this.state.versionlist[index].versionno,
    //                   })}
    //                 </div>
    //               </div>
    //             </div>
    //           </li>
    //         );
    //       }
    //       // if (index === 0) {
    //       //   if (
    //       //     this.props.dataItem.createby !== undefined &&
    //       //     this.props.dataItem.createby !== null &&
    //       //     this.state.transactionhistory !== undefined
    //       //   ) {
    //       //     let createby = {
    //       //       usercode: this.props.dataItem.createby,
    //       //       username: this.state.transactionhistory.username,
    //       //     };
    //       //     let localdate = convertUTCDateToLocalDate(
    //       //       new Date(this.props.dataItem.createdtimestamp)
    //       //     );
    //       //     d = new Date(localdate);
    //       //     day = d.getDate();
    //       //     dayname = this.month[d.getMonth()];
    //       //     // time = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
    //       //     day = convertdoubledigitdate(day);
    //       //     time = convertdoubledigittime(
    //       //       d.getHours(),
    //       //       d.getMinutes(),
    //       //       d.getSeconds()
    //       //     );
    //       //     let year = d.getFullYear();
    //       //     // let gmt =d.toString();
    //       //     // gmt=gmt.slice(25,34);

    //       //     let imgurl = this.ELNurl + this.imageurl + "-1";
    //       //     if (
    //       //       this.props.dataItem.createby !== null &&
    //       //       this.state.transactionhistory.username !== undefined
    //       //     ) {
    //       //       imgurl =
    //       //         this.ELNurl + this.imageurl + this.props.dataItem.createby;
    //       //     }
    //       //     detail.push(
    //       //       <li
    //       //         key={this.props.dataItem.protocolordercode + "Trans_" + 1}
    //       //         className="list-group-item"
    //       //         aria-disabled="true"
    //       //       >
    //       //         <div className="row no-gutters align-items-center">
    //       //           <div className="col-2">
    //       //             <div className="calender-list small">
    //       //               <span className="d-flex eln-stamp">{dayname}</span>
    //       //               <span className="d-flex eln-date">{day}</span>
    //       //               <span className="d-flex eln-stamp">{year}</span>
    //       //               <span className="d-flex eln-stamp">{time}</span>
    //       //               {/* <span className="d-flex eln-stamp">{gmt}</span> */}
    //       //             </div>
    //       //           </div>
    //       //           <div className="col-10 mnuContainer2 userDetails">
    //       //             <Userdetail
    //       //               index={"Trans-" + 1}
    //       //               imgurl={imgurl}
    //       //               user={createby}
    //       //             />
    //       //             <p>
    //       //               {this.props.t("Orders.Protocolorders.IDS_LBL_CREATEDFILE", {
    //       //                 user2: createby.username,
    //       //                 user1: this.props.dataItem.protoclordername,
    //       //               })}
    //       //             </p>
    //       //           </div>{" "}
    //       //         </div>
    //       //       </li>
    //       //     );
    //       //   }
    //       // }
    //     }
    //   } else {
    //     if (
    //       this.state.selectProtocolMaster.createdby !== undefined &&
    //       this.state.selectProtocolMaster.createdby !== null
    //     ) {
    //       if (this.state.selectProtocolMaster.createdate !== undefined) {
    //         let localdate = convertUTCDateToLocalDate(
    //           new Date(this.state.selectProtocolMaster.createdate)
    //         );
    //         d = new Date(localdate);
    //       } else {
    //         d = new Date();
    //       }

    //       // d = new Date(this.state.selectProtocolMaster.createdate);
    //       day = d.getDate();
    //       dayname = this.month[d.getMonth()];
    //       // time = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
    //       day = convertdoubledigitdate(day);
    //       time = convertdoubledigittime(
    //         d.getHours(),
    //         d.getMinutes(),
    //         d.getSeconds()
    //       );
    //       let year = d.getFullYear();
    //       // let gmt =d.toString();
    //       // gmt=gmt.slice(25,34);

    //       let imgurl = this.ELNurl + this.imageurl + "-1";
    //       if (
    //         this.state.selectProtocolMaster.createdby !== null &&
    //         this.state.selectProtocolMaster.createdby !== undefined
    //       ) {
    //         imgurl =
    //           this.ELNurl +
    //           this.imageurl +
    //           this.state.selectProtocolMaster.createdby;
    //       }
    //       detail.push(
    //         <li
    //           key={
    //             this.state.selectProtocolMaster.protocolmastercode + "Trans_"
    //           }
    //           className="list-group-item"
    //           aria-disabled="true"
    //         >
    //           <div className="row no-gutters align-items-center">
    //             <div className="col-2">
    //               <div className="calender-list">
    //                 <span className="d-flex eln-stamp">{dayname}</span>
    //                 <span className="d-flex eln-date">{day}</span>
    //                 <span className="d-flex eln-stamp">{year}</span>
    //                 <span className="d-flex eln-stamp">{time}</span>
    //                 {/* <span className="d-flex eln-stamp">{gmt}</span> */}
    //               </div>
    //             </div>
    //             <div className="col-10 mnuContainer2 userDetails">
    //               <Userdetail
    //                 index={"Trans-"}
    //                 imgurl={imgurl}
    //                 user={this.state.selectProtocolMaster.createdby}
    //               />

    //               <div className="col-12">
    //                 {this.props.t("Orders.Protocolorders.IDS_LBL_CREATEDFILE", {
    //                   user2: this.state.selectProtocolMaster.createdbyusername,
    //                   user1: this.state.selectProtocolMaster.protocolmastername,
    //                 })}
    //               </div>
    //             </div>
    //           </div>
    //         </li>
    //       );
    //     }
    //     //       detail.push(<li className="list-group-item" aria-disabled="true">
    //     //           {this.props.t("SheetCreation.IDS_NOTVERSIONED", {
    //     //              param: "",
    //     //        })}
    //     //   </li>);
    //   }
    // }

    // let detailsvalue = (
    //   <ul className="list-group list-group-flush">{detail}</ul>
    // );
    // return detailsvalue;
  }

  formatworrkflowhistorydetails(dataItem, index) {

    let d = null;
    let day = null;
    let dayname = null;
    let time = null;
    let createby = {
      usercode: dataItem.createby.usercode,
      username: dataItem.createby.username,
    };

    let localdate = convertUTCDateToLocalDate(
      new Date(dataItem.createdate)
    );
    d = new Date(localdate);
    day = d.getDate();
    dayname = this.month[d.getMonth()];
    // time = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
    day = convertdoubledigitdate(day);
    time = convertdoubledigittime(
      d.getHours(),
      d.getMinutes(),
      d.getSeconds()
    );
    let year = d.getFullYear();
    let imgurl = this.ELNurl + this.imageurl + "-1";
    if (
      dataItem.createby.usercode !== null &&
      dataItem.username !== undefined
    ) {
      imgurl =
        this.ELNurl +
        this.imageurl +
        dataItem.createby.usercode;
    }
    const isWorkflowPresent = dataItem?.previousworkflowcode?.workflowcode !== undefined;
    let workflowHistoryText = "";
    const commentsDesign = (
      <p>
        {isWorkflowPresent ? workflowHistoryText : dataItem?.action}
        <div className="userComts">
          <b>{this.props.t("Templates.Sheettemplates.IDS_LBL_COMMENT", { param: "" })} : </b>{" "}
          {dataItem?.comment}
        </div>
      </p>
    );
    return (
      {
        ...dataItem, userdetailsindex: "CreateWKFlow-" + index, key: dataItem?.repositorydatacode !== undefined ? dataItem?.historycode + "Workflow_" + index : "Workflow_" + index, dayname: dayname, day: day, year: year, time: time, imgurl: imgurl, commentsDesign:
          commentsDesign
      }
    );
    // var detail = [];
    // if (this.state.Data.length !== 0) {
    //   let d = null;
    //   let day = null;
    //   let dayname = null;
    //   let time = null;
    //   for (let index = this.state.Data.length - 1; index >= 0; index--) {
    //     // for (let index = 0; index < this.state.Data.length; index++) {
    //     let createby = {
    //       usercode: this.state.Data[index].createby.usercode,
    //       username: this.state.Data[index].createby.username,
    //     };

    //     if (
    //       this.state.Data[index].createby.usercode !== undefined &&
    //       this.state.Data[index].createby.username !== null
    //     ) {
    //       let localdate = convertUTCDateToLocalDate(
    //         new Date(this.state.Data[index].createdate)
    //       );
    //       d = new Date(localdate);
    //       day = d.getDate();
    //       dayname = this.month[d.getMonth()];
    //       // time = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
    //       day = convertdoubledigitdate(day);
    //       time = convertdoubledigittime(
    //         d.getHours(),
    //         d.getMinutes(),
    //         d.getSeconds()
    //       );
    //       let year = d.getFullYear();
    //       // let gmt =d.toString();
    //       // gmt=gmt.slice(25,34);

    //       let imgurl = this.ELNurl + this.imageurl + "-1";
    //       if (
    //         this.state.Data[index].createby.usercode !== null &&
    //         this.state.Data[index].username !== undefined
    //       ) {
    //         imgurl =
    //           this.ELNurl +
    //           this.imageurl +
    //           this.state.Data[index].createby.usercode;
    //       }
    //       detail.push(
    //         <li
    //           key={this.props.dataItem.repositorydatacode + "Trans_" + index}
    //           className="list-group-item"
    //           aria-disabled="true"
    //         >
    //           <div className="row no-gutters align-items-center">
    //             <div className="col-2">
    //               <div className="calender-list small">
    //                 <span className="d-flex eln-stamp">{dayname}</span>
    //                 <span className="d-flex eln-date">{day}</span>
    //                 <span className="d-flex eln-stamp">{year}</span>
    //                 <span className="d-flex eln-stamp">{time}</span>
    //                 {/* <span className="d-flex eln-stamp">{gmt}</span> */}
    //               </div>
    //             </div>
    //             <div className="col-10 mnuContainer2 userDetails">
    //               <Userdetail
    //                 index={"Trans-" + index}
    //                 imgurl={imgurl}
    //                 user={createby}
    //               />
    //               <p>
    //                 {this.state.Data[index].action}
    //                 <div className="userComts">
    //                   <b>
    //                     {this.props.t("Orders.Protocolorders.IDS_LBL_COMMENT", { param: "" })} :
    //                   </b>{" "}
    //                   {this.state.Data[index].comment}
    //                 </div>
    //               </p>
    //             </div>
    //           </div>
    //         </li>
    //       );
    //     }
    //   }
    // } else {
    //   detail.push(
    //     <ul className="list-group list-group-flush">
    //       <li className="list-group-item" aria-disabled="true">
    //         <p>
    //           {this.props.t("Orders.Protocolorders.IDS_LBL_NOWORKF", {
    //             param: "",
    //           })}
    //         </p>
    //       </li>
    //     </ul>
    //   );
    // }

    // let detailsvalue = (
    //   <ul className="list-group list-group-flush">{detail}</ul>
    // );
    // return detailsvalue;
  }
  formatprotocolordertransactiondetails(dataItem, index) {
    let d = null;
    let day = null;
    let dayname = null;
    let time = null;
    if (dataItem?.isOriginal) {
      let createby = {
        usercode: this.state.transactionhistory.usercode,
        username: this.state.transactionhistory.username,
      };
      let localdate = convertUTCDateToLocalDate(
        new Date(dataItem.createdtimestamp)
      );
      d = new Date(localdate);
      day = d.getDate();
      dayname = this.month[d.getMonth()];
      day = convertdoubledigitdate(day);
      time = convertdoubledigittime(
        d.getHours(),
        d.getMinutes(),
        d.getSeconds()
      );
      let year = d.getFullYear();
      let imgurl = this.ELNurl + this.imageurl + "-1";
      if (
        this.state.transactionhistory.usercode !== null &&
        this.state.transactionhistory.username !== undefined
      ) {
        imgurl =
          this.ELNurl +
          this.imageurl +
          this.state.transactionhistory.usercode;
      }
      const content = dataItem.tn || dataItem?.testname !== undefined ? this.props.t("Orders.Sheetorders.IDS_LBL_REGISTERORDER", {
        OrderType: this.props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLORDERS", {}),
        OrderID: dataItem.protoclordername,
        taskname: dataItem.tn || dataItem?.testname,
        visibilityname: dataItem.viewoption === 1 ? "site" : "project team",
        "assigneduser/workflow": (dataItem?.assignedto?.username || dataItem?.elnprotocolworkflow?.workflowname) || (dataItem.at?.username || dataItem.lepw?.workflowname),
        user: createby.username
      }) : this.props.t("Orders.Sheetorders.IDS_LBL_REGISTERORDERWITHOUTTASK", {
        OrderType: this.props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLORDERS", {}),
        OrderID: dataItem.protoclordername,
        // taskname: dataItem.tn,
        visibilityname: dataItem.viewoption === 1 ? "site" : "project team",
        "assigneduser/workflow": (dataItem?.assignedto?.username || dataItem?.elnprotocolworkflow?.workflowname) || (dataItem.at?.username || dataItem.lepw?.workflowname),
        user: createby.username
      });
      return (
        {
          ...dataItem, userdetailsindex: "Trans-" + index, key: dataItem.protocolordercode + "Trans_-2" + index, dayname: dayname, day: day, year: year, time: time, imgurl: imgurl, commentsDesign:
            (<p>
              {content}
            </p>)
        }
      );
    } else {
      let localdate = convertUTCDateToLocalDate(
        new Date(
          dataItem?.stepstartdate !== undefined ? dataItem?.stepstartdate : dataItem?.stependdate
        )
      );
      let d = new Date(localdate);
      let day = d.getDate();
      let dayname = this.month[d.getMonth()];
      let time = convertdoubledigittime(
        d.getHours(),
        d.getMinutes(),
        d.getSeconds()
      );
      let year = d.getFullYear();
      let imgurl = this.ELNurl + this.imageurl + "-1";
      if (
        dataItem?.createby !== null &&
        dataItem?.createby !== undefined
      ) {
        imgurl =
          this.ELNurl +
          this.imageurl +
          dataItem?.createby.usercode;
      }
      let commentsDesign = null;
      if ((dataItem?.action !== undefined && dataItem?.action !== null && (dataItem?.orderobjects === undefined || dataItem?.orderobjects === null))) {
        commentsDesign = dataItem?.action
      }
      else if (dataItem?.orderobjects !== undefined && dataItem?.orderobjects !== null && dataItem?.orderobjects?.action === "File Attachment") {
        commentsDesign = this.props.t("Orders.Sheetorders.IDS_LBL_UPLOADATTACHEMENT", {
          "OrderType": this.props.t("Dashboard.IDS_LBL_PROTOCOLORDERS", {}),
          Attachmentfilename: dataItem.orderobjects?.lsOrderattachments?.filename,
          OrderID: dataItem?.orderobjects?.protoclordername,
          user: dataItem?.createby?.username
        })
      }
      else if (dataItem?.orderobjects !== undefined && dataItem?.orderobjects !== null && dataItem?.orderobjects?.action === "Attachment Download") {
        commentsDesign = this.props.t("Orders.Sheetorders.IDS_LBL_DOWNLOADATTACHEMENT", {
          "OrderType": this.props.t("Dashboard.IDS_LBL_PROTOCOLORDERS", {}),
          Attachmentfilename: dataItem.orderobjects?.lsOrderattachments?.filename,
          OrderID: dataItem?.orderobjects?.protoclordername,
          user: dataItem?.createby?.username
        })
      }
      else if (dataItem?.orderobjects !== undefined && dataItem?.orderobjects !== null && dataItem?.orderobjects?.action === "save") {
        commentsDesign = this.props.t("Orders.Sheetorders.IDS_LBL_SAVEWITHOUTVERSION", {
          OrderType: this.props.t("Dashboard.IDS_LBL_PROTOCOLORDERS", {}),
          OrderID: dataItem?.orderobjects?.protoclordername,
          VersionNumber: dataItem?.orderobjects?.versionno,
          user: dataItem?.createby?.username
        })
      } else if (dataItem?.orderobjects !== undefined && dataItem?.orderobjects !== null && dataItem?.orderobjects?.action === "savewithversion") {
        commentsDesign = this.props.t("Orders.Sheetorders.IDS_LBL_SAVEWITHVERSION", {
          OrderType: this.props.t("Dashboard.IDS_LBL_PROTOCOLORDERS", {}),
          OrderID: dataItem?.orderobjects?.protoclordername,
          VersionNumber: dataItem?.orderobjects?.previousversionnumber,
          newversionumber: dataItem?.orderobjects?.newversionumber,
          user: dataItem?.createby?.username
        })
      } else if (dataItem?.orderobjects !== undefined && dataItem?.orderobjects !== null && dataItem?.orderobjects?.action === "Share") {
        commentsDesign = this.props.t("Orders.Sheetorders.IDS_LBL_SHAREDUSER", {
          OrderType: this.props.t("Dashboard.IDS_LBL_PROTOCOLORDERS", {}),
          OrderID: dataItem?.orderobjects?.protoclordername,
          users: dataItem?.createby?.username,
          user2: dataItem?.orderobjects?.sharetousername,
          privileges: this.props.t((dataItem?.orderobjects?.privileges === 0 ? "Orders.Sheetorders.IDS_LBL_READ" : "Orders.Sheetorders.IDS_LBL_READ/WRITE"), {})
        })
      } else if (dataItem?.orderobjects !== undefined && dataItem?.orderobjects !== null && dataItem?.orderobjects?.action === "unshare") {
        commentsDesign = this.props.t("Orders.Sheetorders.IDS_LBL_UNSHARED", {
          OrderType: this.props.t("Dashboard.IDS_LBL_PROTOCOLORDERS", {}),
          OrderID: dataItem?.orderobjects?.protoclordername,
          users: dataItem?.orderobjects?.sharetousername,
          user2: dataItem?.createby?.username,
          privileges: this.props.t((dataItem?.orderobjects?.privileges === 0 ? "Orders.Sheetorders.IDS_LBL_READ" : "Orders.Sheetorders.IDS_LBL_READ/WRITE"), {})
        })
      } else if (dataItem?.orderobjects !== undefined && dataItem?.orderobjects !== null && dataItem?.orderobjects?.action === "Cancelledorder") {
        commentsDesign = this.props.t((dataItem?.orderobjects?.Reason !== undefined ? "Orders.Sheetorders.IDS_LBL_CANCELORDERWITHREASON" : "Orders.Sheetorders.IDS_LBL_CANCELORDER"), {
          OrderType: this.props.t("Dashboard.IDS_LBL_PROTOCOLORDERS", {}),
          OrderID: dataItem?.orderobjects?.protoclordername,
          users: dataItem?.createby?.username,
          ...dataItem?.orderobjects?.Reason !== undefined && { Reason: dataItem?.orderobjects?.Reason }
        })
      } else if (dataItem?.orderobjects !== undefined && dataItem?.orderobjects !== null && (dataItem?.orderobjects?.action === "OrderOpen" || dataItem?.orderobjects?.action === "OrderClose")) {
        commentsDesign = this.props.t("Templates.Protocoltemplates.IDS_LBL_PROCESSORDER", {
          OrderType: this.props.t("Dashboard.IDS_LBL_PROTOCOLORDERS", {}),
          batchid: dataItem?.orderobjects?.protoclordername,
          Processed: dataItem?.orderobjects?.opentype,
          user2: dataItem?.createby?.username,
        })
      }
      else if (dataItem?.orderobjects !== undefined && dataItem?.orderobjects !== null && dataItem?.orderobjects?.action === "OrderMoved") {
        commentsDesign = this.props.t("Orders.Sheetorders.IDS_LBL_ORDERMOVED", {
          OrderType: this.props.t("Orders.Sheetorders.IDS_LBL_SHEETORDERS", {}),
          OrderID: dataItem?.orderobjects?.protoclordername,
          FromFolderName: dataItem?.orderobjects?.OrderPreviousFolder,
          ToFolderName: dataItem?.orderobjects?.OrderNewFolder,
          users: dataItem?.createby?.username,
        })
      } else if (dataItem?.orderobjects !== undefined && dataItem?.orderobjects !== null && dataItem?.orderobjects?.action === "UnLockOrders") {
        commentsDesign = this.props.t("Orders.Sheetorders.IDS_LBL_UNLOCKEDORDER", {
          OrderType: this.props.t("Orders.Sheetorders.IDS_LBL_SHEETORDERS", {}),
          OrderID: dataItem?.orderobjects?.protoclordername,
          users1: dataItem?.orderobjects?.lockeduser,
          users2: dataItem?.orderobjects?.unlockeduser

        })
      } else if (dataItem?.action !== undefined && dataItem?.action !== null) {
        commentsDesign = dataItem?.action
      }

      return (
        {
          ...dataItem, userdetailsindex: "Trans2-" + index, key: dataItem.protocolorderstephistorycode + "TransDetails_" + index, dayname: dayname, day: day, year: year, time: time, imgurl: imgurl, commentsDesign:
            (<p>
              {commentsDesign}
            </p>),
          createby: dataItem.createby
        }
      );
    }

    // var detail = [];
    // if (this.state.protocolorderstephistory !== undefined && Object.entries(this.state.protocolorderstephistory).length !== 0) {
    //   for (let index = 0; index < this.state.protocolorderstephistory.length; index++) {
    //     let localdate = convertUTCDateToLocalDate(
    //       new Date(
    //         this.state.protocolorderstephistory[index].stepstartdate !== undefined ? this.state.protocolorderstephistory[index].stepstartdate : this.state.protocolorderstephistory[index].stependdate
    //       )
    //     );
    //     let d = new Date(localdate);
    //     let day = d.getDate();
    //     let dayname = this.month[d.getMonth()];
    //     let time = convertdoubledigittime(
    //       d.getHours(),
    //       d.getMinutes(),
    //       d.getSeconds()
    //     );
    //     let year = d.getFullYear();
    //     let imgurl = this.ELNurl + this.imageurl + "-1";
    //     if (
    //       this.state.protocolorderstephistory[index].createby !== null &&
    //       this.state.protocolorderstephistory[index].createby !== undefined
    //     ) {
    //       imgurl =
    //         this.ELNurl +
    //         this.imageurl +
    //         this.state.protocolorderstephistory[index].createby.usercode;
    //     }
    //     detail.push(
    //       <li
    //         className="list-group-item"
    //         aria-disabled="true"
    //         key={
    //           this.state.protocolorderstephistory[index].protocolorderstephistorycode !== undefined
    //             ? this.state.protocolorderstephistory[index].protocolorderstephistorycode
    //             : index
    //         }
    //       >
    //         <div className="row no-gutters align-items-center">
    //           <div className="col-2">
    //             <div className="calender-list">
    //               <span className="d-flex eln-stamp">{dayname}</span>
    //               <span className="d-flex eln-date">{day}</span>
    //               <span className="d-flex eln-stamp">{year}</span>
    //               <span className="d-flex eln-stamp">{time}</span>
    //             </div>
    //           </div>
    //           <div className="col-10 mnuContainer2 userDetails">

    //             <Userdetail
    //               index={"CreateWKFlow-" + index}
    //               imgurl={imgurl}
    //               user={this.state.protocolorderstephistory[index].createby}
    //             />
    //             <p>
    //               {" "}
    //               {this.state.protocolorderstephistory[index].action}

    //             </p>
    //           </div>
    //         </div>
    //       </li>
    //     );
    //   }
    // }
    // if (this.state.transactionhistory !== "") {
    //   let d = null;
    //   let day = null;
    //   let dayname = null;
    //   let time = null;
    //   let createby = {
    //     usercode: this.state.transactionhistory.usercode,
    //     username: this.state.transactionhistory.username,
    //   };
    //   if (
    //     this.state.transactionhistory.usercode !== undefined &&
    //     this.state.transactionhistory.username !== null
    //   ) {
    //     let localdate = convertUTCDateToLocalDate(
    //       new Date(this.props.dataItem.createdtimestamp)
    //     );
    //     d = new Date(localdate);
    //     day = d.getDate();
    //     dayname = this.month[d.getMonth()];
    //     day = convertdoubledigitdate(day);
    //     time = convertdoubledigittime(
    //       d.getHours(),
    //       d.getMinutes(),
    //       d.getSeconds()
    //     );
    //     let year = d.getFullYear();
    //     let imgurl = this.ELNurl + this.imageurl + "-1";
    //     if (
    //       this.state.transactionhistory.usercode !== null &&
    //       this.state.transactionhistory.username !== undefined
    //     ) {
    //       imgurl =
    //         this.ELNurl +
    //         this.imageurl +
    //         this.state.transactionhistory.usercode;
    //     }
    //     detail.push(
    //       <li
    //         key={this.props.dataItem.protocolordercode + "Trans_" + 1}
    //         className="list-group-item"
    //         aria-disabled="true"
    //       >
    //         <div className="row no-gutters align-items-center">
    //           <div className="col-2">
    //             <div className="calender-list small">
    //               <span className="d-flex eln-stamp">{dayname}</span>
    //               <span className="d-flex eln-date">{day}</span>
    //               <span className="d-flex eln-stamp">{year}</span>
    //               <span className="d-flex eln-stamp">{time}</span>
    //               {/* <span className="d-flex eln-stamp">{gmt}</span> */}
    //             </div>
    //           </div>
    //           <div className="col-10 mnuContainer2 userDetails">
    //             <Userdetail
    //               index={"Trans-" + 1}
    //               imgurl={imgurl}
    //               user={createby}
    //             />
    //             <p>
    //               {this.props.t("Orders.Protocolorders.IDS_LBL_CREATEDFILE", {
    //                 user2: createby.username,
    //                 user1: this.props.dataItem.protoclordername,
    //               })}
    //             </p>
    //           </div>{" "}
    //         </div>
    //       </li>
    //     );
    //   }
    // } else {
    //   detail.push(
    //     <ul className="list-group list-group-flush">
    //       <li className="list-group-item" aria-disabled="true">
    //         <p>
    //           {this.props.t("Masters.Inventory.IDS_LBL_NOINVENTRYDETAAILS", {
    //             param: "",
    //           })}
    //         </p>
    //       </li>
    //     </ul>
    //   );
    // }

    // let detailsvalue = (
    //   <ul className="list-group list-group-flush">{detail}</ul>
    // );
    // return detailsvalue;
  }

  OnHistoryfromDatachange = (DateValue) => {
    let FilterData = this.state.FilterRecord;

    let KendoDateFrom =
      (parseInt(new Date(DateValue).getMonth()) + 1).toString() +
      "/" +
      new Date(DateValue).getDate().toString() +
      "/" +
      new Date(DateValue).getFullYear().toString();

    this.setState({
      fdate: DateValue,
      FilterRecord: FilterData,
      OnKendoDateFrom: KendoDateFrom,
    });

    this.TemplateHistroyService(
      {
        id: 4,
        type: "Custom Date",
      },
      DateValue,
      new Date(this.state.OnKendoDateTo)
    );
  };
  OnHistorytoDatachange = (DateValue) => {
    let FilterData = this.state.FilterRecord;
    let KendoDateTo =
      (parseInt(new Date(DateValue).getMonth()) + 1).toString() +
      "/" +
      new Date(DateValue).getDate().toString() +
      "/" +
      new Date(DateValue).getFullYear().toString();

    this.setState({
      tdate: DateValue,
      FilterRecord: FilterData,
      OnKendoDateTo: KendoDateTo,
    });
    this.TemplateHistroyService(
      {
        id: 4,
        type: "Custom Date",
      },
      new Date(this.state.OnKendoDateFrom),
      DateValue
    );
  };

  ondatefilterreset = () => {
    const toDate = new Date();
    const fromDate = new Date(toDate);
    fromDate.setDate(fromDate.getDate() - 7);
    fromDate.setHours(0, 0, 0, 0);
    let KendoDateFrom =
      (parseInt(fromDate.getMonth()) + 1).toString() +
      "/" +
      fromDate.getDate().toString() +
      "/" +
      fromDate.getFullYear().toString();
    let KendoDateTo =
      (parseInt(toDate.getMonth()) + 1).toString() +
      "/" +
      toDate.getDate().toString() +
      "/" +
      toDate.getFullYear().toString();

    this.TemplateHistroyService({
      id: 4,
      type: "Custom Date",
    });

    this.setState({
      OnKendoDateFrom: KendoDateFrom,
      OnKendoDateTo: KendoDateTo,
    });
  };

  onClose = () => {
    this.setState({ protocolView: false });
  };
  render() {
    return (
      this.props.dataItem[this.props.keyfield] !== undefined ? (
        <React.Fragment>

          <button
            id={`user-${this.props.dataItem[this.props.keyfield]}`}
            className="grid-icons"
            alt="user"
            data-placement="top"
            title="Transaction"
            onClick={this.handleclickevent.bind(this)}
          // onClick={() => { this.setState({ protocolView: true }); this.onfinddataclick(); this.onfinddataworkflowclick(); this.onfindversionclick() }}
          >
            <i className="far fa-eye protocol-eye"></i>
          </button>

          {this.state.protocolView ? (
            <ProtocolHistory
              screentype={2}
              screen={"protocolordereyeview"}
              versioncolumn={this.state.Versioncolumns}
              transactionscolumn={this.state.transactionscolumn}
              isexpand={this.state.protocolView}
              state={this.state}
              props={this.props}
              getThis={() => this}
              onClose={this.onClose.bind(this)}
              handleChange={this.handleChange.bind(this)}
              handleTabClick={this.handleTabClick.bind(this)}
              OnHistoryfromDatachange={this.OnHistoryfromDatachange.bind(this)}
              OnHistorytoDatachange={this.OnHistorytoDatachange.bind(this)}
              ondatefilterreset={this.ondatefilterreset.bind(this)}
            />
          ) : (
            ""
          )}


        </React.Fragment>
      ) : (
        ""
      )
    );
  }
}
const Customprotocolordercells = withTranslation(Customprotocolorder);

class Customprotocol extends React.Component {


  constructor(props) {
    super(props);
    let filterdate = new Date();
    this.state = {
      Data: [],
      screenHistoryDatas: [],
      inventryexpand: true,
      workflowexpanded: true,
      workflowehistoryxpanded: false,
      inventryhistoryexpand: false,
      verexpanded: false,
      versionexpanded: true,
      userMasterScreen: true,
      ServiceToUrl: "",
      ServiceMethodType: "POST",
      ServiceHeaderobject: {},
      ServcieonSuccess: undefined,
      ServcieonFailure: undefined,
      columns: [
        {
          header: this.props.t("Templates.Sheettemplates.IDS_LBL_VERSIONHISTORY"),
          datatype: "protocolversioncode",
          rowselector: false,
          visible: false,
          doFilter: true,
          sortable: false,
          resizable: false,
          celltype: "formatversiondetails",
          className: "simple-grid-view",
          width: "100px"
        }
      ],
      transactionscolumn: [
        {
          header: this.props.t("Templates.Sheettemplates.IDS_LBL_TRANS"),
          datatype: "protocolmastercode",
          rowselector: false,
          visible: false,
          doFilter: true,
          sortable: false,
          resizable: false,
          celltype: "ProtocolTransactionHistory",
          className: "simple-grid-view",
          width: "100px"
        },
      ],
      OnKendoDateFrom: new Date(filterdate.setDate(filterdate.getDate() - 7)),
      OnKendoDateTo: new Date(),
      transactionhistory: undefined
    };

    this.ELNurl = window.appUrl.ELN;

    this.imageurl = "";
    if (isMultitenant === 1 || isMultitenant === 2) {
      this.imageurl = "/User/Cloudprofile/";
    } else {
      this.imageurl = "/User/profile/";
    }

    this.month = [
      this.props.t("months.IDS_LBL_JAN", { param: "" }),
      this.props.t("months.IDS_LBL_FEB", { param: "" }),
      this.props.t("months.IDS_LBL_MAR", { param: "" }),
      this.props.t("months.IDS_LBL_APR", { param: "" }),
      this.props.t("months.IDS_LBL_MAY", { param: "" }),
      this.props.t("months.IDS_LBL_JUN", { param: "" }),
      this.props.t("months.IDS_LBL_JUL", { param: "" }),
      this.props.t("months.IDS_LBL_AUG", { param: "" }),
      this.props.t("months.IDS_LBL_SEP", { param: "" }),
      this.props.t("months.IDS_LBL_OCT", { param: "" }),
      this.props.t("months.IDS_LBL_NOV", { param: "" }),
      this.props.t("months.IDS_LBL_DEC", { param: "" }),
    ];
  }
  isToolTipOpen = (targetName) => {
    return this.state[targetName] ? this.state[targetName].tooltipOpen : false;
  };
  toggle = (targetName) => {
    if (!this.state[targetName]) {
      this.setState({
        ...this.state,
        [targetName]: {
          tooltipOpen: true,
        },
      });
    } else {
      this.setState({
        ...this.state,
        [targetName]: {
          tooltipOpen: !this.state[targetName].tooltipOpen,
        },
      });
    }

    this.setState({
      transactionexpanded: false,
      workflowexpanded: false,
    });
  };

  formatProtocolTemplateWorkflowHistoryDetails() {
    var detail = [];

    if (this.state.Data.length !== 0) {
      let d = null;
      let day = null;
      let dayname = null;
      let time = null;

      for (let index = this.state.Data.length - 1;
        index >= 0;
        index--) {
        let createby = {
          usercode: this.state.Data[index].createby.usercode,
          username: this.state.Data[index].createby.username,
        };

        if (
          this.state.Data[index].createby.usercode !== undefined &&
          this.state.Data[index].createby.username !== null
        ) {
          let localdate = convertUTCDateToLocalDate(
            new Date(this.state.Data[index].createdate)
          );
          d = new Date(localdate);
          day = d.getDate();
          dayname = this.month[d.getMonth()];
          // time = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
          day = convertdoubledigitdate(day);
          time = convertdoubledigittime(
            d.getHours(),
            d.getMinutes(),
            d.getSeconds()
          );
          let year = d.getFullYear();
          // let gmt =d.toString();
          // gmt=gmt.slice(25,34);

          let imgurl = this.ELNurl + this.imageurl + "-1";
          if (
            this.state.Data[index].createby.usercode !== null &&
            this.state.Data[index].username !== undefined
          ) {
            imgurl =
              this.ELNurl +
              this.imageurl +
              this.state.Data[index].createby.usercode;
          }
          detail.push(
            <li
              key={this.props.dataItem.protocolmastercode + "Trans_" + index}
              className="list-group-item"
              aria-disabled="true"
            >
              <div className="row no-gutters align-items-center">
                <div className="col-2">
                  <div className="calender-list small">
                    <span className="d-flex eln-stamp">{dayname}</span>
                    <span className="d-flex eln-date">{day}</span>
                    <span className="d-flex eln-stamp">{year}</span>
                    <span className="d-flex eln-stamp">{time}</span>
                    {/* <span className="d-flex eln-stamp">{gmt}</span> */}
                  </div>
                </div>
                <div className="col-10 mnuContainer2 userDetails">
                  <Userdetail
                    index={"Trans-" + index}
                    imgurl={imgurl}
                    user={createby}
                  />
                  <p>
                    {this.state.Data[index].action}
                    <div className="userComts">
                      <b>
                        {this.props.t("Orders.Protocolorders.IDS_LBL_COMMENT", { param: "" })} :
                      </b>{" "}
                      {this.state.Data[index].comment}
                    </div>
                  </p>
                </div>
              </div>
            </li>
          );
        }
      }
    } else {
      detail.push(
        <ul className="list-group list-group-flush">
          <li className="list-group-item" aria-disabled="true">
            <p>
              {this.props.t("Orders.Protocolorders.IDS_LBL_NOWORKF", {
                param: "",
              })}
            </p>
          </li>
        </ul>
      );
    }

    let detailsvalue = (
      <ul className="list-group list-group-flush">{detail}</ul>
    );
    return detailsvalue;
  }
  onCloseinfo() {
    this.setState({ customProtocol: false })
  }
  formatProtocolTemplateVersionDetails() {
    var detail = [];
    if (this.state.selectProtocolMaster !== undefined) {
      let d = null;
      let day = null;
      let dayname = null;
      let time = null;

      if (
        this.state.selectProtocolMaster !== undefined &&
        this.state.selectProtocolMaster !== null &&
        this.state.selectProtocolMaster.length > 0
      ) {
        for (
          let index = this.state.selectProtocolMaster.length - 1;
          index >= 0;
          index--
        ) {
          if (
            this.state.selectProtocolMaster[index].createdbyusername !== undefined &&
            this.state.selectProtocolMaster[index].createdbyusername !== null &&
            this.state.selectProtocolMaster[index].versionno !== 1
          ) {
            if (
              this.state.selectProtocolMaster[index].createdate !== undefined
            ) {
              let localdate = convertUTCDateToLocalDate(
                new Date(this.state.selectProtocolMaster[index].createdate)
              );
              d = new Date(localdate);
            } else {
              d = new Date();
            }

            day = d.getDate();
            dayname = this.month[d.getMonth()];
            // time = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
            day = convertdoubledigitdate(day);
            time = convertdoubledigittime(
              d.getHours(),
              d.getMinutes(),
              d.getSeconds()
            );
            let year = d.getFullYear();
            // let gmt =d.toString();
            // gmt=gmt.slice(25,34);

            let imgurl = this.ELNurl + this.imageurl + "-1";
            if (
              this.state.selectProtocolMaster[index].createdbyusername !==
              null &&
              this.state.selectProtocolMaster[index].createdbyusername !==
              undefined
            ) {
              imgurl =
                this.ELNurl +
                this.imageurl +
                this.state.selectProtocolMaster[index].createdby;
            }
            detail.push(
              <li
                key={
                  this.state.selectProtocolMaster.protocolmastercode +
                  "Trans_" +
                  index
                }
                className="list-group-item"
                aria-disabled="true"
              >
                <div className="row no-gutters align-items-center">
                  <div className="col-2">
                    <div className="calender-list">
                      <span className="d-flex eln-stamp">{dayname}</span>
                      <span className="d-flex eln-date">{day}</span>
                      <span className="d-flex eln-stamp">{year}</span>
                      <span className="d-flex eln-stamp">{time}</span>
                      {/* <span className="d-flex eln-stamp">{gmt}</span> */}
                    </div>
                  </div>
                  <div className="col-10 mnuContainer2 userDetails">
                    <Userdetail
                      index={"Trans-" + index}
                      imgurl={imgurl}
                      user={this.state.selectProtocolMaster[index].createdby}
                    />

                    <div className="col-12">
                      {this.props.t("Orders.Protocolorders.IDS_LBL_MODIFIEDF", {
                        user2:
                          this.state.selectProtocolMaster[index]
                            .createdbyusername,
                        user1:
                          this.state.selectProtocolMaster[index].versionname,
                      })}
                    </div>
                  </div>
                </div>
              </li>
            );
          }
          if (index === 0) {
            if (
              this.props.dataItem.createdby !== undefined &&
              this.props.dataItem.createdby !== null
            ) {
              let createby = {
                usercode: this.props.dataItem.usercode,
                username: this.props.dataItem.username,
              };
              let localdate = convertUTCDateToLocalDate(
                new Date(this.props.dataItem.createdate)
              );
              d = new Date(localdate);
              day = d.getDate();
              dayname = this.month[d.getMonth()];
              // time = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
              day = convertdoubledigitdate(day);
              time = convertdoubledigittime(d.getHours(), d.getMinutes(), d.getSeconds());
              let year = d.getFullYear();
              // let gmt =d.toString();
              // gmt=gmt.slice(25,34);

              let imgurl = this.ELNurl + this.imageurl + "-1";
              if (
                this.state.transactionhistory.usercode !== null &&
                this.state.transactionhistory.username !== undefined
              ) {
                imgurl =
                  this.ELNurl +
                  this.imageurl +
                  this.state.transactionhistory.usercode;
              }
              detail.push(
                <li
                  key={this.props.dataItem.protocolmastercode + "Trans_" + 1}
                  className="list-group-item"
                  aria-disabled="true"
                >
                  <div className="row no-gutters align-items-center">
                    <div className="col-2">
                      <div className="calender-list small">
                        <span className="d-flex eln-stamp">{dayname}</span>
                        <span className="d-flex eln-date">{day}</span>
                        <span className="d-flex eln-stamp">{year}</span>
                        <span className="d-flex eln-stamp">{time}</span>
                        {/* <span className="d-flex eln-stamp">{gmt}</span> */}
                      </div>
                    </div>
                    <div className="col-10 mnuContainer2 userDetails">
                      <Userdetail
                        index={"Trans-" + 1}
                        imgurl={imgurl}
                        user={createby}
                      />
                      <p>
                        {this.props.t("Orders.Protocolorders.IDS_LBL_CREATEDFILE", {
                          user2: this.props.dataItem.createdbyusername,
                          user1: this.props.dataItem.protocolmastername,
                        })}
                      </p>
                    </div>{" "}
                  </div>
                </li>
              );
            }
          }

        }
      } else {
        if (
          this.state.selectProtocolMaster.createdby !== undefined &&
          this.state.selectProtocolMaster.createdby !== null
        ) {
          if (this.state.selectProtocolMaster.createdate !== undefined) {
            let localdate = convertUTCDateToLocalDate(
              new Date(this.state.selectProtocolMaster.createdate)
            );
            d = new Date(localdate);
          } else {
            d = new Date();
          }

          // d = new Date(this.state.selectProtocolMaster.createdate);
          day = d.getDate();
          dayname = this.month[d.getMonth()];
          // time = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
          day = convertdoubledigitdate(day);
          time = convertdoubledigittime(
            d.getHours(),
            d.getMinutes(),
            d.getSeconds()
          );
          let year = d.getFullYear();
          // let gmt =d.toString();
          // gmt=gmt.slice(25,34);

          let imgurl = this.ELNurl + this.imageurl + "-1";
          if (
            this.state.selectProtocolMaster.createdby !== null &&
            this.state.selectProtocolMaster.createdby !== undefined
          ) {
            imgurl =
              this.ELNurl +
              this.imageurl +
              this.state.selectProtocolMaster.createdby;
          }
          detail.push(
            <li
              key={
                this.state.selectProtocolMaster.protocolmastercode + "Trans_"
              }
              className="list-group-item"
              aria-disabled="true"
            >
              <div className="row no-gutters align-items-center">
                <div className="col-2">
                  <div className="calender-list">
                    <span className="d-flex eln-stamp">{dayname}</span>
                    <span className="d-flex eln-date">{day}</span>
                    <span className="d-flex eln-stamp">{year}</span>
                    <span className="d-flex eln-stamp">{time}</span>
                    {/* <span className="d-flex eln-stamp">{gmt}</span> */}
                  </div>
                </div>
                <div className="col-10 mnuContainer2 userDetails">
                  <Userdetail
                    index={"Trans-"}
                    imgurl={imgurl}
                    user={this.state.selectProtocolMaster.createdby}
                  />

                  <div className="col-12">
                    {this.props.t("Orders.Protocolorders.IDS_LBL_CREATEDFILE", {
                      user2: this.state.selectProtocolMaster.createdbyusername,
                      user1: this.state.selectProtocolMaster.protocolmastername,
                    })}
                  </div>
                </div>
              </div>
            </li>
          );
        }
        //       detail.push(<li className="list-group-item" aria-disabled="true">
        //           {this.props.t("SheetCreation.IDS_NOTVERSIONED", {
        //              param: "",
        //        })}
        //   </li>);
      }
    }

    let detailsvalue = (
      <ul className="list-group list-group-flush">{detail}</ul>
    );
    return detailsvalue;
  }

  formatProtocolTemplateTransactionDetails() {
    var detail = [];

    if (this.props.dataItem !== "") {
      let d = null;
      let day = null;
      let dayname = null;
      let time = null;

      if (
        this.state.selectProtocolMaster !== undefined &&
        this.state.selectProtocolMaster !== null
      ) {
        if (
          this.state.selectProtocolMaster.modifiedlist !== undefined &&
          this.state.selectProtocolMaster.modifiedlist !== null
        ) {
          for (
            let index = this.state.selectProtocolMaster.modifiedlist.length - 1;
            index >= 0;
            index--
          ) {
            if (
              this.state.selectProtocolMaster[0].createdate !== undefined &&
              this.state.selectProtocolMaster[0].createdate !== null
            ) {

              let localdate = convertUTCDateToLocalDate(
                new Date(this.state.selectProtocolMaster.modifiedlist[index].protocolmodifiedDate)
              );
              d = new Date(localdate);
              // d = new Date(
              //   this.state.selectProtocolMaster.modifiedlist[
              //     index
              //   ].protocolmodifiedDate
              // );
              day = d.getDate();
              dayname = this.month[d.getMonth()];
              // time = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
              day = convertdoubledigitdate(day);
              time = convertdoubledigittime(d.getHours(), d.getMinutes(), d.getSeconds());
              let year = d.getFullYear();
              let imgurl = this.ELNurl + this.imageurl + "-1";
              if (
                this.state.selectProtocolMaster[0].createdate !== null &&
                this.state.selectProtocolMaster[0].createdate !== undefined
              ) {
                imgurl =
                  this.ELNurl +
                  this.imageurl +
                  this.state.selectProtocolMaster.modifiedlist[index].modifiedby
                    .usercode;
              }
              detail.push(
                <li
                  key={
                    this.state.selectProtocolMaster[0].protocolmastercode +
                    "TransDetails_" +
                    index
                  }
                  className="list-group-item"
                  aria-disabled="true"
                >
                  <div className="row no-gutters align-items-center">
                    <div className="col-2">
                      <div className="calender-list">
                        <span className="d-flex eln-stamp">{dayname}</span>
                        <span className="d-flex eln-date">{day}</span>
                        <span className="d-flex eln-stamp">{year}</span>
                        <span className="d-flex eln-stamp">{time}</span>
                      </div>
                    </div>
                    <div className="col-10 mnuContainer2 userDetails">
                      <Suspense fallback={<div></div>}>
                        <Userdetail
                          index={"Trans2-" + index}
                          imgurl={imgurl}
                          user={
                            this.state.selectProtocolMaster.modifiedlist[index]
                              .modifiedby
                          }
                        />
                      </Suspense>

                      <div class="container my-4">
                        {
                          this.state.selectProtocolMaster.modifiedlist[index]
                            .protocolcomment
                        }
                      </div>
                    </div>
                  </div>
                </li>
              );
            }
          }
        }
      }
      let createby = {
        usercode: this.state.transactionhistory.usercode,
        username: this.state.transactionhistory.username,
      };

      if (
        this.state.transactionhistory.usercode !== undefined &&
        this.state.transactionhistory.username !== null
      ) {
        let localdate = convertUTCDateToLocalDate(
          new Date(this.props.dataItem.createdate)
        );
        d = new Date(localdate);
        day = d.getDate();
        dayname = this.month[d.getMonth()];
        // time = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
        day = convertdoubledigitdate(day);
        time = convertdoubledigittime(
          d.getHours(),
          d.getMinutes(),
          d.getSeconds()
        );
        let year = d.getFullYear();
        // let gmt =d.toString();
        // gmt=gmt.slice(25,34);

        let imgurl = this.ELNurl + this.imageurl + "-1";
        if (
          this.state.transactionhistory.usercode !== null &&
          this.state.transactionhistory.username !== undefined
        ) {
          imgurl =
            this.ELNurl +
            this.imageurl +
            this.state.transactionhistory.usercode;
        }
        detail.push(
          <li
            key={this.props.dataItem.protocolmastercode + "Trans_" + 1}
            className="list-group-item"
            aria-disabled="true"
          >
            <div className="row no-gutters align-items-center">
              <div className="col-2">
                <div className="calender-list small">
                  <span className="d-flex eln-stamp">{dayname}</span>
                  <span className="d-flex eln-date">{day}</span>
                  <span className="d-flex eln-stamp">{year}</span>
                  <span className="d-flex eln-stamp">{time}</span>
                  {/* <span className="d-flex eln-stamp">{gmt}</span> */}
                </div>
              </div>
              <div className="col-10 mnuContainer2 userDetails">
                <Userdetail
                  index={"Trans-" + 1}
                  imgurl={imgurl}
                  user={createby}
                />
                <p>
                  {this.props.t("Templates.Protocoltemplates.IDS_LBL_CREATEDF", {
                    user2: this.props.dataItem.protocolmastername,
                    user1: this.props.dataItem.createdbyusername,
                  })}
                </p>
              </div>{" "}
            </div>
          </li>
        );
      }
    } else {
      detail.push(
        <ul className="list-group list-group-flush">
          <li className="list-group-item" aria-disabled="true">
            <p>
              {this.props.t("Masters.Inventory.IDS_LBL_NOINVENTRYDETAAILS", {
                param: "",
              })
              }

            </p>
          </li>
        </ul>
      );
    }

    let detailsvalue = (
      <ul className="list-group list-group-flush">{detail}</ul>
    );
    return detailsvalue;
  }

  ongetProtocolOrderworkflowhistoryListSuccess(response) {
    this.setState({
      Data: response.lsprotocolworkflowhistory
      // workflowexpanded: !this.state.workflowexpanded,
      // workflowehistoryxpanded: !this.state.workflowehistoryxpanded,
    });
  }

  ongetProtocolOrderworkflowhistoryListSuccess1(response) {
    let addedprotocol = response.lsprotocolversion;
    addedprotocol.createby = response.createby;
    addedprotocol.lsprotocolworkflowhistory = response.lsprotocolworkflowhistory;
    addedprotocol.modifiedlist = response.modifiedlist;
    this.setState({
      selectProtocolMaster: addedprotocol,
      //   // verexpanded: !this.state.verexpanded,
      //   // versionexpanded: !this.state.versionexpanded,
    });
  }
  ongetProtocolOrderworkflowhistoryListFailure1(res) { }

  ongetProtocolOrderworkflowhistoryListFailure(res) { }


  onRepositoryFailure(res) { }
  onRepositorySuccess(response) {
    this.setState({
      transactionhistory: response
    });
  }
  OnClickHistory() {
    this.setState({ customProtocol: true });
    this.TemplateHistroyService({
      id: 1,
      type: "Current Date"
    });
  }
  OnHistoryfromDatachange(DateValue) {

    let FilterData = this.state.FilterRecord;

    let KendoDateFrom =
      (parseInt(new Date(DateValue).getMonth()) + 1).toString() +
      "/" +
      new Date(DateValue).getDate().toString() +
      "/" +
      new Date(DateValue).getFullYear().toString();

    this.setState({
      fdate: DateValue,
      FilterRecord: FilterData,
      OnKendoDateFrom: KendoDateFrom,
    });

    this.TemplateHistroyService({
      id: 4,
      type: "Custom Date"
    }, DateValue, new Date(this.state.OnKendoDateTo));
  }
  OnHistorytoDatachange(DateValue) {

    let FilterData = this.state.FilterRecord;
    let KendoDateTo =
      (parseInt(new Date(DateValue).getMonth()) + 1).toString() +
      "/" +
      new Date(DateValue).getDate().toString() +
      "/" +
      new Date(DateValue).getFullYear().toString();

    this.setState({
      tdate: DateValue,
      FilterRecord: FilterData,
      OnKendoDateTo: KendoDateTo,
    });
    this.TemplateHistroyService({
      id: 4,
      type: "Custom Date"
    }, new Date(this.state.OnKendoDateFrom), DateValue);
  }

  ondatefilterreset = () => {
    const toDate = new Date();
    const fromDate = new Date(toDate);
    fromDate.setDate(fromDate.getDate() - 7);
    fromDate.setHours(0, 0, 0, 0)
    let KendoDateFrom =
      (parseInt(fromDate.getMonth()) + 1).toString() +
      "/" +
      fromDate.getDate().toString() +
      "/" +
      fromDate.getFullYear().toString();
    let KendoDateTo =
      (parseInt(toDate.getMonth()) + 1).toString() +
      "/" +
      toDate.getDate().toString() +
      "/" +
      toDate.getFullYear().toString();

    this.TemplateHistroyService({
      id: 4,
      type: "Custom Date"
    });

    this.setState({
      OnKendoDateFrom: KendoDateFrom,
      OnKendoDateTo: KendoDateTo,
    })
  }
  TemplateHistroyService(event, fdate, tdate) {
    let id = event.id
    let passObjDet = {
      protocolmastercode: this.props.dataItem.protocolmastercode
    };

    if (id === 1) {
      const toDate = new Date();
      const fromDate = new Date(toDate);
      fromDate.setHours(0, 0, 0, 0)
      passObjDet.fromdate = fromDate;
      passObjDet.todate = toDateFilter(toDate);
    } else if (id === 2) {
      const toDate = new Date();
      const fromDate = new Date(toDate);
      fromDate.setDate(fromDate.getDate() - 7);
      fromDate.setHours(0, 0, 0, 0)
      passObjDet.fromdate = fromDate;
      passObjDet.todate = toDateFilter(toDate);
    } else if (id === 3) {
      const toDate = new Date();
      const fromDate = new Date(toDate);
      fromDate.setDate(fromDate.getDate() - 30);
      fromDate.setHours(0, 0, 0, 0)
      passObjDet.fromdate = fromDate;
      passObjDet.todate = toDateFilter(toDate);
    } else if (id === 4) {
      if (fdate && tdate) {
        const toDate = tdate;
        toDate.setHours(new Date().getHours());
        const fromDate = fdate;
        fromDate.setHours(0, 0, 0, 0)
        passObjDet.fromdate = fromDate;
        passObjDet.todate = toDateFilter(toDate);
      } else {
        const toDate = new Date();
        const fromDate = new Date(toDate);
        fromDate.setDate(fromDate.getDate() - 7);
        fromDate.setHours(0, 0, 0, 0)
        passObjDet.fromdate = fromDate;
        passObjDet.todate = toDateFilter(toDate);

        let KendoDateFrom =
          (parseInt(fromDate.getMonth()) + 1).toString() +
          "/" +
          fromDate.getDate().toString() +
          "/" +
          fromDate.getFullYear().toString();
        let KendoDateTo =
          (parseInt(toDate.getMonth()) + 1).toString() +
          "/" +
          toDate.getDate().toString() +
          "/" +
          toDate.getFullYear().toString();
        this.setState({
          OnKendoDateFrom: KendoDateFrom,
          OnKendoDateTo: KendoDateTo,
        })
      }
    }


    const getVersionDatas = async (result = []) => {
      const originalItem = result.find(item => item.versionno === 1);

      const dataWithOriginal = [
        originalItem
          ? { ...originalItem, type: this.props.t("Dashboard.IDS_LBL_VERSION"), isOriginal: true }
          : { ...this.props.dataItem, type: this.props.t("Dashboard.IDS_LBL_VERSION"), isOriginal: true },
        ...result?.filter((items) => items.versionno !== 1)
      ];
      return dataWithOriginal.map(item => ({ ...item, type: this.props.t("Dashboard.IDS_LBL_VERSION") }));
    };


    const getTransactionDatas = async (transactionDatas) => {
      let data = transactionDatas?.map(item => ({
        createdby: item.modifiedby,
        protocolmodifiedDate: item.protocolmodifiedDate,
        modifiedby: item.modifiedby,
        protocolcomment: item.protocolcomment,
        type: "Transaction",
        templateobjects: item.templateobjects && JSON.parse(item.templateobjects),
        createdate: item.protocolmodifiedDate
      })) || [];
      let dataWithOriginal = [
        {
          ...this.props.dataItem,
          type: "Transaction",
          isOriginal: true
        },
        ...data
      ];
      return dataWithOriginal;
    };

    const getWorkflowHistoryDatas = async (lsprotocolworkflowhistory) => {
      return lsprotocolworkflowhistory?.map(item => ({ ...item, type: "Workflow" })) || [];
    };

    Servicecalls(
      "" + this.ELNurl + "/protocol/GetProtocolTransactionDetails",
      passObjDet,
      async (respone) => {
        // let transaction_histtory;
        // let version = respone.lsprotocolversion.reverse()
        // version = this.getVersionDatas(respone?.lsprotocolversion?.reverse());
        const [transaction_histtory, version, workflows] = await Promise.all([
          getTransactionDatas(respone.modifiedlist || []),
          getVersionDatas(respone?.lsprotocolversion?.reverse() || []),
          getWorkflowHistoryDatas(respone?.lsprotocolworkflowhistory || [])
        ]);
        // let finalHistory = [...transaction_histtory, ...version, ...workflows]?.sort((a, b) => Date.parse(b.createdate) - Date.parse(a.createdate));
        let finalHistory = [...transaction_histtory, ...version, ...workflows].sort((a, b) => {
          const getTime = (item) => {
            const val = item.createdate;
            if (typeof val === "number") return val;
            return Date.parse(val);
          };
          return getTime(b) - getTime(a);
        });
        finalHistory = finalHistory.map((items, index) => { items.id = index; return items })
        let allDatas = this.formatHistorys(finalHistory || [])
        this.setState({ screenHistoryDatas: allDatas?.map((items) => { items.select = false; return items }), selecteddatevalue: event, })
        // if (respone.lsprotocoltransaction) {
        //   transaction_histtory = [...[{
        //     createdby: respone.createby,
        //     protocolmodifiedDate: respone.lsprotocoltransaction.createdate,
        //     modifiedby: respone.lsprotocoltransaction.createdbyusername,
        //     protocolcomment: this.props.t("Templates.Protocoltemplates.IDS_LBL_CREATEDF", {
        //       user1: respone.lsprotocoltransaction.createdbyusername,
        //       user2: respone.lsprotocoltransaction.protocolmastername,
        //     })
        //   }]]
        //   let retiredhistory = respone.modifiedlist.map(item =>
        //   ({
        //     createdby: item.modifiedby,
        //     protocolmodifiedDate: item.protocolmodifiedDate,
        //     modifiedby: item.modifiedby.username,
        //     protocolcomment: item.protocolcomment
        //   })

        //   )
        //   transaction_histtory.push(...retiredhistory);

        // } else {
        //   transaction_histtory = [];
        // }
        // let lsprotocolworkflowhistory = respone.lsprotocolworkflowhistory;
        // this.setState({
        //   Data: respone.lsprotocolworkflowhistory,
        //   versiondata: version,
        //   selecteddatevalue: event,
        //   transactionhistory: transaction_histtory.reverse(),
        //   lsprotocolworkflowhistory: lsprotocolworkflowhistory
        // });

      },
      (res) => {

      }
    );

    setTimeout(() => {
      let passObjDet = {
        objsilentaudit: Silentauditobject(
          "view",
          "Protocol Templates",
          this.props.t("Templates.Protocoltemplates.IDS_AUDIT_PROTOCOLINFOOPENED", {
            user1: this.props.dataItem.protocolmastername,
            user: store.getState().Loggeduser.username,
          })

        ),
      };
      Servicecalls(
        "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        (res) => { },
        (res) => { }
      );
    }, 50);

  }

  formatworkflowdetails = (dataItem, index) => {
    let imgurl;
    let localDate = convertUTCDateToLocalDate(new Date(dataItem?.createdate));
    let d = new Date(localDate);
    let day = d.getDate();
    let dayname = this.month[d.getMonth()];
    day = convertdoubledigitdate(day);
    let time = convertdoubledigittime(d.getHours(), d.getMinutes(), d.getSeconds());
    let year = d.getFullYear();
    imgurl = this.ELNurl + this.imageurl + "-1";
    let imgdetails = [];
    imgdetails.push(imgurl);
    if (
      dataItem?.createby !== null &&
      dataItem?.createby !== undefined
    ) {
      imgurl = this.ELNurl + this.imageurl + dataItem?.createby.usercode;
      imgdetails.push(imgurl);
    }

    const isWorkflowPresent = dataItem?.previousprotocoltemplateworkflowcode?.workflowcode !== undefined;
    const approvedStatusText = dataItem?.approvelstatus === 1
      ? this.props.t("Dashboard.IDS_LBL_APPROVED", {}) // "Approved"
      : dataItem?.approvelstatus === 2
        ? this.props.t("Orders.Sheetorders.IDS_LBL_RETURN", {})// "Returned"
        : this.props.t("Dashboard.IDS_LBL_REJECTED", {})// "Rejected";
    const fromOrin = (
      (dataItem?.approvelstatus === 1 && !dataItem?.elnprotocoltemplateworkflow) ||
      dataItem?.approvelstatus === 3
    ) ? this.props.t("Templates.Sheettemplates.IDS_LBL_IN", { param: "" }) : this.props.t("Templates.Sheettemplates.IDS_LBL_FROM", { param: "" });
    const translationParams = {
      Template: "Template",
      TemplateName: dataItem?.templatename || this.props?.dataItem?.protocolmastername || "N/A",
      VersionNumber: dataItem?.templateversionNumber || this.props?.dataItem?.viewoption || "N/A",
      ApprovedStatus: approvedStatusText,
      fromorin: fromOrin,
      previousworkflow: dataItem?.previousprotocoltemplateworkflowcode?.workflowname || "",
      nextworkflow: dataItem?.elnprotocoltemplateworkflow?.workflowname || "",
      user: dataItem?.createby?.username || "Unknown User"
    };
    let workflowHistoryText = this.props.t("Templates.Sheettemplates.IDS_WORKFLOWHISTORY", translationParams);
    if (!translationParams.nextworkflow) {
      workflowHistoryText = workflowHistoryText.replace("to  by", "by");
    }
    const commentsDesign = (
      <p>
        {isWorkflowPresent ? workflowHistoryText : dataItem?.action}
        <div className="userComts">
          <b>{this.props.t("Templates.Sheettemplates.IDS_LBL_COMMENT", { param: "" })} : </b>{" "}
          {dataItem?.comment}
        </div>
      </p>
    );
    return (
      {
        ...dataItem, userdetailsindex: "CreateWKFlow-" + index, key: "CreateWKFlow-" + dataItem?.historycode !== undefined ? dataItem?.historycode : index, dayname: dayname, day: day, year: year, time: time, imgurl: imgurl, commentsDesign:
          commentsDesign
      }
    );
  }



  formatHistorys = (finalHistory) => {
    let historys = finalHistory?.reduce((acc, curr, index) => {
      if (curr?.type === "Workflow") {
        acc.push(this.formatworkflowdetails(curr, index))
      } else if (curr?.type === "Transaction") {
        acc.push(this.formattransactiondetails(curr, index))
      } else if (curr?.type === "Version") {
        acc.push(this.formatversiondetails(curr, index))
      }
      return acc;
    }, [])
    return historys;
  }

  formatversiondetails(dataItem, index) {
    if (dataItem?.isOriginal) {
      let localdate = convertUTCDateToLocalDate(
        new Date(dataItem?.createdate || this.props.dataItem?.createdate || new Date())
      );
      let d = new Date(localdate);
      let day = d.getDate();
      let dayname = this.month[d.getMonth()];
      day = convertdoubledigitdate(day);
      let time = convertdoubledigittime(
        d.getHours(),
        d.getMinutes(),
        d.getSeconds()
      );
      let year = d.getFullYear();
      let imgurl = this.ELNurl + this.imageurl + "-1";
      // if (
      //   dataItem.createby !== null &&
      //   dataItem.createby !== undefined
      // ) {
      imgurl =
        this.ELNurl +
          this.imageurl +
          dataItem.createby !== null &&
          dataItem.createby !== undefined ? dataItem?.createby?.usercode : dataItem?.createdby;
      // }
      return (
        {
          ...dataItem, userdetailsindex: "version_" + index, key: dataItem.protocolmastercode + "version_" + index, dayname: dayname, day: day, year: year, time: time, imgurl: imgurl, commentsDesign:
            (<p>
              {this.props.t(
                "Templates.Protocoltemplates.IDS_LBL_CREATEDFILE",
                {
                  user2: dataItem?.createdbyusername || this.props?.dataItem?.createdbyusername,
                  user1: dataItem?.versionno || this.props?.dataItem?.versionno,
                }
              )}
            </p>)
        }
      );
    } else {
      let localdate = convertUTCDateToLocalDate(
        new Date(dataItem?.createdate || new Date())
      );
      let d = new Date(localdate);
      let day = d.getDate();
      let dayname = this.month[d.getMonth()];
      day = convertdoubledigitdate(day);
      let time = convertdoubledigittime(
        d.getHours(),
        d.getMinutes(),
        d.getSeconds()
      );
      let year = d.getFullYear();
      let imgurl = this.ELNurl + this.imageurl + "-1";
      if (
        dataItem.createdbyusername !== null &&
        dataItem.createdbyusername !== undefined
      ) {
        imgurl =
          this.ELNurl +
          this.imageurl +
          dataItem.createdby;
      }
      return (
        {
          ...dataItem, userdetailsindex: "version-" + index, key: this.props.dataItem.protocolmastercode + "version-" + index, dayname: dayname, day: day, year: year, time: time, imgurl: imgurl, commentsDesign:
            (<p>
              {this.props.t("Orders.Protocolorders.IDS_LBL_MODIFIEDF", {
                user2:
                  dataItem?.createdbyusername,
                user1:
                  dataItem?.versionname,
              })}
            </p>)
        }
      );
    }
  }

  formattransactiondetails(dataItem, index) {
    let d = null;
    let day = null;
    let dayname = null;
    let time = null;

    if (dataItem?.isOriginal) {
      let localdate = convertUTCDateToLocalDate(
        new Date(dataItem.createdate)
      );
      d = new Date(localdate);
      day = d.getDate();
      dayname = this.month[d.getMonth()];
      day = convertdoubledigitdate(day);
      time = convertdoubledigittime(
        d.getHours(),
        d.getMinutes(),
        d.getSeconds()
      );
      let year = d.getFullYear();
      let imgurl = this.ELNurl + this.imageurl + "-1";
      if (
        dataItem.createby !== null &&
        dataItem.createby !== undefined
      ) {
        imgurl =
          this.ELNurl + this.imageurl + dataItem.createby.usercode;
      }
      if (
        dataItem !== undefined &&
        dataItem[this.props.keyfield] !== undefined
      ) {
        return (
          {
            ...dataItem, userdetailsindex: "TransDetails_" + index, key: dataItem.protocolmastercode + "TransDetails_" + index, dayname: dayname, day: day, year: year, time: time, imgurl: imgurl, commentsDesign:
              (<p>
                {this.props.t("Templates.Sheettemplates.IDS_LBL_CREATEDF", {
                  user1: dataItem.createdbyusername,
                  user2: dataItem.protocolmastername,
                })}
              </p>)
          }
        );
      }
    } else {
      let localdate = convertUTCDateToLocalDate(
        new Date(
          dataItem.protocolmodifiedDate
        )
      );
      d = new Date(localdate);
      day = d.getDate();
      dayname = this.month[d.getMonth()];
      day = convertdoubledigitdate(day);
      time = convertdoubledigittime(
        d.getHours(),
        d.getMinutes(),
        d.getSeconds()
      );
      let year = d.getFullYear();
      let imgurl = this.ELNurl + this.imageurl + "-1";
      if (
        dataItem.modifiedby !== null &&
        dataItem?.modifiedby !== undefined
      ) {
        imgurl =
          this.ELNurl +
          this.imageurl +
          dataItem?.modifiedby?.usercode;
      }

      let commentsDesign = null;
      if (dataItem?.protocolcomment !== undefined && dataItem?.protocolcomment !== null) {
        commentsDesign = dataItem?.protocolcomment
      } else if ((dataItem?.templateobjects !== undefined || dataItem?.templateobjects !== null) && dataItem?.templateobjects?.action === "saveas") {
        commentsDesign = dataItem?.templateobjects?.type === "to" ? this.props.t("Templates.Sheettemplates.IDS_SHEETTEMPLATESAVEASTEMPLATE", {
          NewTemplatename: dataItem.templateobjects.filenameto,
          VersionNumber: dataItem.templateobjects.filenametoversionno,
          oldtemplatename: dataItem.templateobjects.filenamefrom,
          OldtempVersionNumber: dataItem.templateobjects?.filenamefromversionno,
          user: dataItem.templateobjects?.createdby?.username
        }) : this.props.t("Templates.Sheettemplates.IDS_SHEETTEMPLATESAVEASORIGINAL", {
          "Sheet/Protocol": this.props.t("Dashboard.IDS_LBL_PROTOCOL", {}),
          Templatename: dataItem.templateobjects.filenamefrom,
          VersionNumber: dataItem.templateobjects.filenamefromversionno,
          newtemplatename: dataItem.templateobjects.filenameto,
          user: dataItem.templateobjects?.createdby?.username
        })
      } else if ((dataItem?.templateobjects !== undefined || dataItem?.templateobjects !== null) && dataItem?.templateobjects?.action === "Edit") {
        console.log("kumu");
        if (dataItem?.templateobjects?.edittype === "Rename") {
          commentsDesign = this.props.t("Templates.Sheettemplates.IDS_LDL_EDITTEMPLATENAME", {
            "Sheet/Protocol": this.props.t("Dashboard.IDS_LBL_PROTOCOL", {}),
            templatename: dataItem.templateobjects?.filenameto,
            previousvalue: dataItem.templateobjects.filenamefrom,
            currentvalue: dataItem.templateobjects?.filenameto,
          })
        } else if (dataItem?.templateobjects?.edittype === "Visibility") {
          commentsDesign = this.props.t("Templates.Sheettemplates.IDS_LDL_EDITTEMPLATEVISIBILITY", {
            "Sheet/Protocol": this.props.t("Dashboard.IDS_LBL_PROTOCOL", {}),
            templatename: dataItem.templateobjects?.filenameto,
            previousvisibility: dataItem.templateobjects.viewoptionfrom === 1 ? "Site" : "Project Team",
            currentvisibility: dataItem.templateobjects?.viewoptionto === 1 ? "Site" : "Project Team",
            user: dataItem.createdby?.username
          })
        } else {
          // {Sheet/Protocol} Template: {TemplateName Version: {VersionNumber} was Modified by User: <user></user>
          commentsDesign = this.props.t("Templates.Sheettemplates.IDS_LDL_EDITTEMPLATEOTHERS", {
            "Sheet/Protocol": this.props.t("Dashboard.IDS_LBL_PROTOCOL", {}),
            TemplateName: dataItem.templateobjects?.filenameto,
            VersionNumber: dataItem.templateobjects?.VersionNumber,
            user: dataItem.createdby?.username
          })
        }
      } else if ((dataItem?.templateobjects !== undefined || dataItem?.templateobjects !== null) && dataItem?.templateobjects?.action === "Save") {
        commentsDesign = this.props.t("Templates.Sheettemplates.IDS_LDL_TEMPLATESAVE", {
          "Sheet/Protocol": this.props.t("Dashboard.IDS_LBL_PROTOCOL", {}),
          TemplateName: dataItem.templateobjects?.filename,
          VersionNumber: dataItem.templateobjects.versionno,
          user: dataItem.createdby?.username
        })
      } else if ((dataItem?.templateobjects !== undefined || dataItem?.templateobjects !== null) && dataItem?.templateobjects?.action === "Workflow") {
        const approvedStatusText = dataItem?.templateobjects?.approvelstatus === 1
          ? this.props.t("Dashboard.IDS_LBL_APPROVED", {}) // "Approved"
          : dataItem?.templateobjects?.approvelstatus === 2
            ? this.props.t("Orders.Sheetorders.IDS_LBL_RETURN", {})// "Returned"
            : this.props.t("Dashboard.IDS_LBL_REJECTED", {})// "Rejected";
        commentsDesign = this.props.t("Templates.Sheettemplates.IDS_LDL_WORKFLOWTRANSITION", {
          "Template/Order": this.props.t("Dashboard.IDS_LBL_TEMPLATE", {}),//"Template",
          "TemplateName/OrderID": dataItem.templateobjects?.filename,
          VersionNumber: dataItem.templateobjects.versionno,
          "Approved/Returned/Rejected": approvedStatusText,
          Workflowstep: dataItem?.templateobjects?.previousworkflow?.workflowname,
          user: dataItem.createdby?.username
        })
      } else if ((dataItem?.templateobjects !== undefined || dataItem?.templateobjects !== null) && dataItem?.templateobjects?.action === "Retire") {
        commentsDesign = this.props.t("Templates.Sheettemplates.IDS_LDL_TEMPALTERETIRED", {
          "Sheet/Protocol": this.props.t("Dashboard.IDS_LBL_PROTOCOL", {}),
          TemplateName: dataItem.templateobjects?.filename,
          user: dataItem.createdby?.username
        })
      } else if ((dataItem?.templateobjects !== undefined || dataItem?.templateobjects !== null) && dataItem?.templateobjects?.action === "ExportJSON") {
        commentsDesign = this.props.t("Templates.Sheettemplates.IDS_LDL_TEMPALTEEXPORTJSON", {
          "Sheet/Protocol": this.props.t("Dashboard.IDS_LBL_PROTOCOL", {}),
          TemplateName: dataItem.templateobjects?.filename,
          filename: dataItem.templateobjects?.exportFilename,
          extention: dataItem.templateobjects?.exportExtention,
          user: dataItem.createdby?.username
        })
      } else if ((dataItem?.templateobjects !== undefined || dataItem?.templateobjects !== null) && dataItem?.templateobjects?.action === "TemplateMapping") {
        if (dataItem?.templateobjects?.isNew) {
          commentsDesign = this.props.t("Templates.Sheettemplates.IDS_LDL_TEMPALTEMAPPING", {
            "Sheet/Protocol": this.props.t("Dashboard.IDS_LBL_PROTOCOL", {}),
            TemplateName: dataItem.templateobjects?.filename,
            TaskName: dataItem.templateobjects?.currentTask?.testname,
            user: dataItem.createdby?.username
          })
        } else if (dataItem.templateobjects?.PreviousTask !== undefined) {
          commentsDesign = this.props.t("Templates.Sheettemplates.IDS_LBL_TEMPALTEREMAPPING", {
            "Sheet/Protocol": this.props.t("Dashboard.IDS_LBL_PROTOCOL", {}),
            TemplateName: dataItem.templateobjects?.filename,
            TaskName: dataItem.templateobjects?.PreviousTask?.testname,
            user: dataItem.createdby?.username
          })
        }
      }
      return (
        {
          ...dataItem, userdetailsindex: "TransDetails_-" + index, key: this.props.dataItem.protocolmastercode + "TransDetails_" + index, dayname: dayname, day: day, year: year, time: time, imgurl: imgurl, commentsDesign:
            (<p>
              {commentsDesign}
            </p>)
        }
      );
    }
  }



  handleTabClick = (tab) => {
    this.setState({
      activeTab: tab
    })
  };

  onClose() {
    this.setState({ customProtocol: false });
  }

  handleChange = (event) => {
    this.TemplateHistroyService(event);
  };

  render() {
    return (
      this.props.dataItem[this.props.keyfield] !== undefined ? (
        <React.Fragment>
          <button
            id={`user-${this.props.dataItem[this.props.keyfield]}`}
            className="grid-icons"
            alt="user"
            data-placement="top"
            title={this.props.t("Templates.Sheettemplates.IDS_LBL_HISTORY")}
            onClick={this.OnClickHistory.bind(this)}

          >
            <i className="far fa-eye 5"></i>
          </button>
          {this.state.customProtocol &&
            <Suspense fallback={<div></div>}>
              <ProtocolHistory
                screentype={1}
                screen={"protocoleye"}
                versioncolumn={this.state.columns}
                transactionscolumn={this.state.transactionscolumn}
                isexpand={this.state.customProtocol}
                state={this.state}
                props={this.props}
                getThis={() => this}
                onClose={this.onClose.bind(this)}
                handleChange={this.handleChange.bind(this)}
                handleTabClick={this.handleTabClick.bind(this)}
                OnHistoryfromDatachange={this.OnHistoryfromDatachange.bind(this)}
                OnHistorytoDatachange={this.OnHistorytoDatachange.bind(this)}
                ondatefilterreset={this.ondatefilterreset.bind(this)}
              />
            </Suspense>}
        </React.Fragment>
      ) : (
        ""
      )
    );
  }
}
const Customprotocolcells = withTranslation(Customprotocol);

class Customsheetorder extends React.Component {

  _isMounted = false;
  constructor(props) {
    super(props);
    let filterdate = new Date();
    this.state = {
      Data: [],
      transactionhistory: {},
      inventryexpand: true,
      workflowexpanded: true,
      userMasterScreen: true,
      ServiceToUrl: "",
      ServiceMethodType: "POST",
      ServiceHeaderobject: {},
      ServcieonSuccess: undefined,
      ServcieonFailure: undefined,
      clickTimer: null,
      activeTab: 1,
      sheetView: false,
      transactionscolumn: [
        {
          header: this.props.t("Templates.Sheettemplates.IDS_LBL_TRANS"),
          datatype: "filecode",
          rowselector: false,
          visible: false,
          doFilter: true,
          sortable: false,
          resizable: false,
          celltype: "CommonTransactionHistoryDesing",
          className: "simple-grid-view",
          width: "100px"
        },
      ],
      screenHistoryDatas: [],
      OnKendoDateFrom: new Date(filterdate.setDate(filterdate.getDate() - 7)),
      OnKendoDateTo: new Date(),
      FilterType: [
        {
          id: 1,
          type: props.t("Dashboard.IDS_LBL_FILTERBYCURRENTDATE")
        },
        {
          id: 2,
          type: props.t("Dashboard.IDS_LBL_FILTERBY7DAYS")
        },
        {
          id: 3,
          type: props.t("Dashboard.IDS_LBL_FILTERBY30DAYS")
        },
        {
          id: 4,
          type: props.t("Dashboard.IDS_LBL_FILTERBYCUSTOMDATE")
        },
      ],
      SelectedFilter: {
        id: 1,
        type: props.t("Dashboard.IDS_LBL_FILTERBYCURRENTDATE")
      },
    };

    this.ELNurl = window.appUrl.ELN;

    this.imageurl = "";
    if (isMultitenant === 1 || isMultitenant === 2) {
      this.imageurl = "/User/Cloudprofile/";
    } else {
      this.imageurl = "/User/profile/";
    }

    this.month = [
      this.props.t("months.IDS_LBL_JAN", { param: "" }),
      this.props.t("months.IDS_LBL_FEB", { param: "" }),
      this.props.t("months.IDS_LBL_MAR", { param: "" }),
      this.props.t("months.IDS_LBL_APR", { param: "" }),
      this.props.t("months.IDS_LBL_MAY", { param: "" }),
      this.props.t("months.IDS_LBL_JUN", { param: "" }),
      this.props.t("months.IDS_LBL_JUL", { param: "" }),
      this.props.t("months.IDS_LBL_AUG", { param: "" }),
      this.props.t("months.IDS_LBL_SEP", { param: "" }),
      this.props.t("months.IDS_LBL_OCT", { param: "" }),
      this.props.t("months.IDS_LBL_NOV", { param: "" }),
      this.props.t("months.IDS_LBL_DEC", { param: "" }),
    ];
  }

  componentDidMount() {
    this._isMounted = true;
  }

  ongetProtocolOrderworkflowhistoryListFailure = (res) => { }
  ongetprotocolstephistorySuccess(responce) {
    responce.sort((a, b) => a.stepstartdate - b.stepstartdate);
    this.setState({
      sheetranshistory: responce,
    })
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  isToolTipOpen = (targetName) => {
    return this.state[targetName] ? this.state[targetName].tooltipOpen : false;
  };

  toggle = (targetName) => {
    if (!this._isMounted) return;

    if (!this.state[targetName]) {
      this.setState({
        ...this.state,
        [targetName]: {
          tooltipOpen: true,
        },
      });
    } else {
      this.setState({
        ...this.state,
        [targetName]: {
          tooltipOpen: !this.state[targetName].tooltipOpen,
        },
      });
    }

    this.setState({
      transactionexpanded: false,
      workflowexpanded: false,
    });
  };

  formatsheetorderworkflowhistorydetails(dataItem, index) {
    // var detail = [];
    let d = null;
    let day = null;
    let dayname = null;
    let time = null;
    let createby = {
      usercode: dataItem?.createby?.usercode,
      username: dataItem?.createby?.username,
    };
    let localdate = convertUTCDateToLocalDate(
      new Date(dataItem?.createdate)
    );

    d = new Date(localdate);
    day = d.getDate();
    dayname = this.month[d.getMonth()];
    let year = d.getFullYear();
    day = convertdoubledigitdate(day);
    time = convertdoubledigittime(
      d.getHours(),
      d.getMinutes(),
      d.getSeconds()
    );
    let imgurl = this.ELNurl + this.imageurl + "-1";
    if (
      dataItem?.createby.usercode !== null &&
      dataItem?.username !== undefined
    ) {
      imgurl =
        this.ELNurl +
        this.imageurl +
        dataItem?.createby.usercode;
    }
    const isWorkflowPresent = dataItem?.previousworkflowcode?.workflowcode !== undefined;
    let workflowHistoryText = "";
    const commentsDesign = (
      <p>
        {isWorkflowPresent ? workflowHistoryText : dataItem?.action}
        <div className="userComts">
          <b>{this.props.t("Templates.Sheettemplates.IDS_LBL_COMMENT", { param: "" })} : </b>{" "}
          {dataItem?.comment}
        </div>
      </p>
    );
    return (
      {
        ...dataItem, userdetailsindex: "CreateWKFlow-" + index, key: dataItem?.historycode !== undefined ? dataItem?.historycode + "Workflow_" + index : "Workflow_" + index, dayname: dayname, day: day, year: year, time: time, imgurl: imgurl, commentsDesign:
          commentsDesign
      }
    );

    // if (this.state.Data.length !== 0) {


    //   for (let index = this.state.Data.length - 1; index >= 0; index--) {
    //     let createby = {
    //       usercode: this.state.Data[index].createby.usercode,
    //       username: this.state.Data[index].createby.username,
    //     };

    //     if (
    //       this.state.Data[index].createby.usercode !== undefined &&
    //       this.state.Data[index].createby.username !== null
    //     ) {
    //       let localdate = convertUTCDateToLocalDate(
    //         new Date(this.state.Data[index].createdate)
    //       );

    //       d = new Date(localdate);
    //       day = d.getDate();
    //       dayname = this.month[d.getMonth()];
    //       let year = d.getFullYear();
    //       // let gmt =d.toString();
    //       // gmt=gmt.slice(25,34);

    //       // time = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
    //       day = convertdoubledigitdate(day);
    //       time = convertdoubledigittime(
    //         d.getHours(),
    //         d.getMinutes(),
    //         d.getSeconds()
    //       );
    //       let imgurl = this.ELNurl + this.imageurl + "-1";
    //       if (
    //         this.state.Data[index].createby.usercode !== null &&
    //         this.state.Data[index].username !== undefined
    //       ) {
    //         imgurl =
    //           this.ELNurl +
    //           this.imageurl +
    //           this.state.Data[index].createby.usercode;
    //       }
    //       detail.push(
    //         <li key={index} className="list-group-item" aria-disabled="true">
    //           <div className="row no-gutters align-items-center">
    //             <div className="col-2">
    //               <div className="calender-list small">
    //                 <span className="d-flex eln-stamp">{dayname}</span>
    //                 <span className="d-flex eln-date">{day}</span>
    //                 <span className="d-flex eln-stamp">{year}</span>
    //                 <span className="d-flex eln-stamp">{time}</span>
    //                 {/* <span className="d-flex eln-stamp">{gmt}</span> */}
    //               </div>
    //             </div>
    //             <div className="col-10 mnuContainer2 userDetails">
    //               <Userdetail
    //                 index={"Trans-" + index}
    //                 imgurl={imgurl}
    //                 user={createby}
    //               />
    //               <p>
    //                 {this.state.Data[index].action}
    //                 <div className="userComts">
    //                   <b>
    //                     {this.props.t("Orders.Protocolorders.IDS_LBL_COMMENT", { param: "" })} :
    //                   </b>{" "}
    //                   {this.state.Data[index].comment}
    //                 </div>
    //               </p>
    //             </div>
    //           </div>
    //         </li>
    //       );
    //     }
    //   }
    // } else {
    //   detail.push(
    //     <ul className="list-group list-group-flush" key="noworkflow">
    //       <li className="list-group-item" aria-disabled="true">
    //         <p>
    //           {this.props.t("Orders.Protocolorders.IDS_LBL_NOWORKF", {
    //             param: "",
    //           })}
    //         </p>
    //       </li>
    //     </ul>
    //   );
    // }

    // let detailsvalue = (
    //   <ul className="list-group list-group-flush">{detail}</ul>
    // );
    // return detailsvalue;
  }

  formatsheetorderversiondetails(dataItem, index) {

    // let filecode = this.props?.props?.dataItem?.lsf ? this.props.props.dataItem.lsf.filesamplecode : this.props.props?.dataItem?.lssamplefile?.filesamplecode

    // if (filecode !== undefined && filecode !== null) {
    //   let passObjDetFile = { filesamplecode: filecode };
    //   Servicecalls(
    //     "" + this.ELNurl + "/Instrument/GetSheetorderversions",
    //     passObjDetFile,
    //     (res) => {
    //       if (res !== undefined && res !== null) {
    //         let temp = res.lsorderversion.sort((a, b) => b.createdate - a.createdate);
    //         this.setState({
    //           lstorderversion: temp
    //         });
    //       }
    //     },
    //     (res) => { }
    //   );
    // }

    let localdate = convertUTCDateToLocalDate(
      new Date(dataItem?.createdate || new Date(dataItem?.modifieddate))
    );
    let d = new Date(localdate);
    let day = d.getDate();
    let dayname = this.month[d.getMonth()];
    day = convertdoubledigitdate(day);
    let time = convertdoubledigittime(
      d.getHours(),
      d.getMinutes(),
      d.getSeconds()
    );
    let year = d.getFullYear();
    let imgurl = this.ELNurl + this.imageurl + "-1";
    if (dataItem?.modifiedby !== undefined && dataItem?.modifiedby?.usercode !== undefined) {
      imgurl = this.ELNurl + this.imageurl + dataItem?.modifiedby?.usercode;
    } else if (dataItem?.createbyuser !== undefined && dataItem?.createbyuser?.usercode !== undefined) {
      imgurl = this.ELNurl + this.imageurl + dataItem?.createbyuser?.usercode;
    }
    let createby;
    if (dataItem?.modifiedby !== undefined && dataItem?.modifiedby?.usercode !== undefined) {
      createby = {
        usercode: dataItem?.modifiedby?.usercode,
        username: dataItem?.modifiedby?.username
      };
    } else if (dataItem?.createbyuser !== undefined && dataItem?.createbyuser?.usercode !== undefined) {
      createby = {
        usercode: dataItem?.createbyuser?.usercode,
        username: dataItem?.createbyuser?.username
      };
    }
    let content = null;
    if (createby) {
      if (Number(dataItem?.versionno) === 1) {
        content = this.props.t("Orders.Protocolorders.IDS_LBL_CREATEDFILE", { user2: createby.username, user1: dataItem?.versionno, })
      }
      else {
        content = this.props.t("Orders.Protocolorders.IDS_LBL_MODIFIEDF", { user2: createby.username, user1: dataItem?.versionno, })
      }
    }
    return (
      {
        ...dataItem, userdetailsindex: "version_" + index, key: dataItem.batchcode + "version_", dayname: dayname, day: day, year: year, time: time, imgurl: imgurl, commentsDesign:
          (<p>
            {content}
          </p>)
      }
    );


    // var detail = [];
    // if (dataItem !== undefined) {
    //   let d = null;
    //   let day = null;
    //   let dayname = null;
    //   let time = null;

    //   if (
    //     this.state.lstorderversion !== undefined && this.state.lstorderversion !== null && this.state.lstorderversion.length > 0
    //   ) {
    //     for (let index = 0; index < this.state.lstorderversion.length; index++) {

    //       let localdate;

    //       if (this.state.lstorderversion[index].modifieddate !== undefined && this.state.lstorderversion[index].modifieddate !== undefined) {
    //         localdate = convertUTCDateToLocalDate(new Date(this.state.lstorderversion[index].modifieddate));
    //       } else {
    //         localdate = convertUTCDateToLocalDate(new Date(this.state.lstorderversion[index].createdate));
    //       }

    //       d = new Date(localdate);
    //       let createby;

    //       if (this.state.lstorderversion[index].modifiedby !== undefined && this.state.lstorderversion[index].modifiedby.usercode !== undefined) {
    //         createby = {
    //           usercode: this.state.lstorderversion[index].modifiedby.usercode,
    //           username: this.state.lstorderversion[index].modifiedby.username
    //         };
    //       } else if (this.state.lstorderversion[index].createbyuser !== undefined && this.state.lstorderversion[index].createbyuser.usercode !== undefined) {
    //         createby = {
    //           usercode: this.state.lstorderversion[index].createbyuser.usercode,
    //           username: this.state.lstorderversion[index].createbyuser.username
    //         };
    //       }

    //       day = d.getDate();
    //       dayname = this.month[d.getMonth()];
    //       day = convertdoubledigitdate(day);
    //       time = convertdoubledigittime(d.getHours(), d.getMinutes(), d.getSeconds());
    //       let year = d.getFullYear();
    //       // let gmt =d.toString();
    //       // gmt=gmt.slice(25,34);
    //       let imgurl = this.ELNurl + this.imageurl + "-1";

    //       if (this.state.lstorderversion[index].modifiedby !== undefined && this.state.lstorderversion[index].modifiedby.usercode !== undefined) {
    //         imgurl = this.ELNurl + this.imageurl + this.state.lstorderversion[index].modifiedby.usercode;
    //       } else if (this.state.lstorderversion[index].createbyuser !== undefined && this.state.lstorderversion[index].createbyuser.usercode !== undefined) {
    //         imgurl = this.ELNurl + this.imageurl + this.state.lstorderversion[index].createbyuser.usercode;
    //       }

    //       let content = null;
    //       if (createby) {
    //         if (Number(this.state.lstorderversion[index].versionno) === 1) {
    //           content = "Version " + this.props.t("Orders.Protocolorders.IDS_LBL_CREATEDFILE", { user2: createby.username, user1: this.state.lstorderversion[index].versionno, })
    //         }
    //         else {
    //           content = this.props.t("Orders.Protocolorders.IDS_LBL_MODIFIEDF", { user2: createby.username, user1: this.state.lstorderversion[index].versionno, })
    //         }
    //       }

    //       detail.push(
    //         <li
    //           key={this.props.props.dataItem.batchid + "Trans_" + index}
    //           className="list-group-item"
    //           aria-disabled="true"
    //         >
    //           <div className="row no-gutters align-items-center">
    //             <div className="col-2">
    //               <div className="calender-list small">
    //                 <span className="d-flex eln-stamp">{dayname}</span>
    //                 <span className="d-flex eln-date">{day}</span>
    //                 <span className="d-flex eln-stamp">{year}</span>
    //                 <span className="d-flex eln-stamp">{time}</span>
    //                 {/* <span className="d-flex eln-stamp">{time}</span> */}
    //               </div>
    //             </div>
    //             <div className="col-10 mnuContainer2 userDetails">
    //               {this._isMounted && <Userdetail
    //                 index={"Trans_" + index}
    //                 imgurl={imgurl}
    //                 user={createby}
    //               />}
    //               <p>
    //                 {content}
    //               </p>
    //             </div>{" "}
    //           </div>
    //         </li>
    //       );
    //       // }
    //     }
    //   }
    // }

    // let detailsvalue = (
    //   <ul className="list-group list-group-flush">{detail}</ul>
    // );
    // return detailsvalue;
  }

  formatsheetordertranshistorydetails(dataItem, index) {
    let d = null;
    let day = null;
    let dayname = null;
    let time = null;
    if (dataItem?.isOriginal) {
      let createby = {
        usercode: this.props.props.dataItem.lsuserMaster.usercode,
        username: this.props.props.dataItem.lsuserMaster.username,
      };
      let localdate = convertUTCDateToLocalDate(
        new Date(dataItem.createdtimestamp)
      );
      d = new Date(localdate);
      day = d.getDate();
      dayname = this.month[d.getMonth()];
      day = convertdoubledigitdate(day);
      time = convertdoubledigittime(
        d.getHours(),
        d.getMinutes(),
        d.getSeconds()
      );
      let year = d.getFullYear();
      let imgurl = this.ELNurl + this.imageurl + "-1";
      if (
        createby !== undefined &&
        createby !== null
      ) {
        imgurl =
          this.ELNurl + this.imageurl + createby.usercode;
      }
      const content = dataItem.testname !== undefined ? this.props.t("Orders.Sheetorders.IDS_LBL_REGISTERORDER", {
        OrderType: this.props.t("Orders.Sheetorders.IDS_LBL_SHEETORDERS", {}),
        OrderID: dataItem.batchid,
        taskname: dataItem.testname,
        visibilityname: dataItem.viewoption === 1 ? "site" : "project team",
        "assigneduser/workflow": dataItem.assignedto?.username || dataItem.lsworkflow?.workflowname,
        user: createby.username
      }) : this.props.t("Orders.Sheetorders.IDS_LBL_REGISTERORDERWITHOUTTASK", {
        OrderType: this.props.t("Orders.Sheetorders.IDS_LBL_SHEETORDERS", {}),
        OrderID: dataItem.batchid,
        visibilityname: dataItem.viewoption === 1 ? "site" : "project team",
        "assigneduser/workflow": dataItem.assignedto?.username || dataItem.lsworkflow?.workflowname,
        user: createby.username
      });

      if (
        dataItem !== undefined &&
        dataItem[this.props.keyfield] !== undefined
      ) {
        return (
          {
            ...dataItem, userdetailsindex: "Trans-" + index, key: dataItem.batchcode + "Trans_-2" + index, dayname: dayname, day: day, year: year, time: time, imgurl: imgurl, commentsDesign:
              (<p>
                {content}
              </p>)
          }
        );
      }
    } else {
      let localdate = convertUTCDateToLocalDate(
        new Date(
          dataItem?.stepstartdate !== undefined ? dataItem?.stepstartdate : dataItem?.stependdate
        )
      );
      let d = new Date(localdate);
      let day = d.getDate();
      let dayname = this.month[d.getMonth()];
      let time = convertdoubledigittime(
        d.getHours(),
        d.getMinutes(),
        d.getSeconds()
      );
      let year = d.getFullYear();
      let imgurl = this.ELNurl + this.imageurl + "-1";
      if (
        dataItem?.createby !== null &&
        dataItem?.createby !== undefined
      ) {
        imgurl =
          this.ELNurl +
          this.imageurl +
          dataItem?.createby?.usercode;
      }
      let commentsDesign = null;
      if ((dataItem?.action !== undefined && dataItem?.action !== null && (dataItem?.orderobjects === undefined || dataItem?.orderobjects === null))) {
        commentsDesign = dataItem?.action
      } else if (dataItem?.orderobjects !== undefined && dataItem?.orderobjects !== null && dataItem?.orderobjects?.action === "File Attachment") {
        commentsDesign = this.props.t("Orders.Sheetorders.IDS_LBL_UPLOADATTACHEMENT", {
          "OrderType": this.props.t("Orders.Sheetorders.IDS_LBL_SHEETORDERS", {}),
          Attachmentfilename: dataItem.orderobjects?.lsOrderattachments?.filename,
          OrderID: dataItem?.orderobjects?.batchid,
          user: dataItem?.createby?.username
        })
      } else if (dataItem?.orderobjects !== undefined && dataItem?.orderobjects !== null && dataItem?.orderobjects?.action === "Attachment Download") {
        commentsDesign = this.props.t("Orders.Sheetorders.IDS_LBL_DOWNLOADATTACHEMENT", {
          "OrderType": this.props.t("Orders.Sheetorders.IDS_LBL_SHEETORDERS", {}),
          Attachmentfilename: dataItem.orderobjects?.lsOrderattachments?.filename,
          OrderID: dataItem?.orderobjects?.batchid,
          user: dataItem?.createby?.username
        })
      } else if (dataItem?.orderobjects !== undefined && dataItem?.orderobjects !== null && dataItem?.orderobjects?.action === "save") {
        commentsDesign = this.props.t("Orders.Sheetorders.IDS_LBL_SAVEWITHOUTVERSION", {
          OrderType: this.props.t("Orders.Sheetorders.IDS_LBL_SHEETORDERS", {}),
          OrderID: dataItem?.orderobjects?.batchid,
          VersionNumber: dataItem?.orderobjects?.versionno,
          user: dataItem?.createby?.username
        })
      } else if (dataItem?.orderobjects !== undefined && dataItem?.orderobjects !== null && dataItem?.orderobjects?.action === "savewithversion") {
        commentsDesign = this.props.t("Orders.Sheetorders.IDS_LBL_SAVEWITHVERSION", {
          OrderType: this.props.t("Orders.Sheetorders.IDS_LBL_SHEETORDERS", {}),
          OrderID: dataItem?.orderobjects?.batchid,
          VersionNumber: dataItem?.orderobjects?.previousversionnumber,
          newversionumber: dataItem?.orderobjects?.newversionumber,
          user: dataItem?.createby?.username
        })
      } else if (dataItem?.orderobjects !== undefined && dataItem?.orderobjects !== null && dataItem?.orderobjects?.action === "Share") {
        commentsDesign = this.props.t("Orders.Sheetorders.IDS_LBL_SHAREDUSER", {
          OrderType: this.props.t("Orders.Sheetorders.IDS_LBL_SHEETORDERS", {}),
          OrderID: dataItem?.orderobjects?.batchid,
          users: dataItem?.createby?.username,
          user2: dataItem?.orderobjects?.sharetousername,
          privileges: this.props.t((dataItem?.orderobjects?.privileges === 0 ? "Orders.Sheetorders.IDS_LBL_READ" : "Orders.Sheetorders.IDS_LBL_READ/WRITE"), {})
        })
      } else if (dataItem?.orderobjects !== undefined && dataItem?.orderobjects !== null && dataItem?.orderobjects?.action === "unshare") {
        commentsDesign = this.props.t("Orders.Sheetorders.IDS_LBL_UNSHARED", {
          OrderType: this.props.t("Orders.Sheetorders.IDS_LBL_SHEETORDERS", {}),
          OrderID: dataItem?.orderobjects?.batchid,
          users: dataItem?.orderobjects?.sharetousername,
          user2: dataItem?.createby?.username,
          privileges: this.props.t((dataItem?.orderobjects?.privileges === 0 ? "Orders.Sheetorders.IDS_LBL_READ" : "Orders.Sheetorders.IDS_LBL_READ/WRITE"), {})
        })
      } else if (dataItem?.orderobjects !== undefined && dataItem?.orderobjects !== null && dataItem?.orderobjects?.action === "Cancelledorder") {
        commentsDesign = this.props.t((dataItem?.orderobjects?.Reason !== undefined ? "Orders.Sheetorders.IDS_LBL_CANCELORDERWITHREASON" : "Orders.Sheetorders.IDS_LBL_CANCELORDER"), {
          OrderType: this.props.t("Orders.Sheetorders.IDS_LBL_SHEETORDERS", {}),
          OrderID: dataItem?.orderobjects?.batchid,
          users: dataItem?.createby?.username,
          ...dataItem?.orderobjects?.Reason !== undefined && { Reason: dataItem?.orderobjects?.Reason }
        })
      }
      else if (dataItem?.orderobjects !== undefined && dataItem?.orderobjects !== null && dataItem?.orderobjects?.action === "CompletedOrder") {
        commentsDesign = this.props.t("Orders.Sheetorders.IDS_LBL_COMPLTORDER", {
          OrderType: this.props.t("Orders.Sheetorders.IDS_LBL_SHEETORDERS", {}),
          OrderID: dataItem?.orderobjects?.batchid,
          users: dataItem?.createby?.username,
        })
      }
      else if (dataItem?.orderobjects !== undefined && dataItem?.orderobjects !== null && dataItem?.orderobjects?.action === "OrderOpen") {
        commentsDesign = this.props.t("Orders.Sheetorders.IDS_LBL_PROCEDSSORDER", {
          OrderType: this.props.t("Orders.Sheetorders.IDS_LBL_SHEETORDERS", {}),
          OrderID: dataItem?.orderobjects?.batchid,
          users: dataItem?.createby?.username,
        })
      }
      else if (dataItem?.orderobjects !== undefined && dataItem?.orderobjects !== null && dataItem?.orderobjects?.action === "OrderMoved") {
        commentsDesign = this.props.t("Orders.Sheetorders.IDS_LBL_ORDERMOVED", {
          OrderType: this.props.t("Orders.Sheetorders.IDS_LBL_SHEETORDERS", {}),
          OrderID: dataItem?.orderobjects?.batchid,
          FromFolderName: dataItem?.orderobjects?.OrderPreviousFolder,
          ToFolderName: dataItem?.orderobjects?.OrderNewFolder,
          users: dataItem?.createby?.username,
        })
      }
      else if (dataItem?.orderobjects !== undefined && dataItem?.orderobjects !== null && dataItem?.orderobjects?.action === "UnLockOrders") {
        commentsDesign = this.props.t("Orders.Sheetorders.IDS_LBL_UNLOCKEDORDER", {
          OrderType: this.props.t("Orders.Sheetorders.IDS_LBL_SHEETORDERS", {}),
          OrderID: dataItem?.orderobjects?.batchid,
          users1: dataItem?.orderobjects?.lockeduser,
          users2: dataItem?.orderobjects?.unlockeduser

        })
      }
      else if (dataItem?.orderobjects !== undefined && dataItem?.orderobjects !== null && dataItem?.orderobjects?.action === "OrderClose") {
        commentsDesign = this.props.t(dataItem?.orderobjects?.withoutsave ? ("Orders.Sheetorders.IDS_LBL_CLOSEORDERWITHOUTSAVE") : ("Orders.Sheetorders.IDS_LBL_CLOSEORDER"), {
          OrderID: dataItem?.orderobjects?.batchid,
          users: dataItem?.createby?.username,
        })
      }
      else if (dataItem?.action !== undefined && dataItem?.action !== null) {
        commentsDesign = dataItem?.action
      }
      return (
        {
          ...dataItem, userdetailsindex: "Trans2-" + index, key: dataItem.batchcode + "TransDetails_" + index, dayname: dayname, day: day, year: year, time: time, imgurl: imgurl, commentsDesign:
            (<p>
              {commentsDesign}
            </p>),
          createby: dataItem.createby
        }
      );
    }
  }

  async onfinddataworkflowclick(e) {
    let passobject = this.props.props.dataItem;

    if (passobject.createdtimestamp !== undefined) {
      if (
        typeof passobject.createdtimestamp === "string" ||
        passobject.createdtimestamp instanceof String
      ) {
        passobject.createdtimestamp = new Date(passobject.createdtimestamp);
      }

      if (
        typeof passobject.completedtimestamp === "string" ||
        passobject.completedtimestamp instanceof String
      ) {
        passobject.completedtimestamp = new Date(passobject.completedtimestamp);
      }
    }

    Servicecalls(
      "" + this.ELNurl + "/Instrument/updateVersionandWorkflowhistory",
      passobject,
      this.ongetOrderworkflowhistoryListSuccess.bind(this),
      this.ongetOrderworkflowhistoryListFailure.bind(this)
    );
  }

  ongetOrderworkflowhistoryListSuccess(response) {
    if (response.lsorderworkflowhistory !== undefined) {
      response.lsorderworkflowhistory.sort((a, b) => parseFloat(a.historycode) - parseFloat(b.historycode));
    }
    this.setState({
      Data: response.lsorderworkflowhistory
      // workflowexpanded: !this.state.workflowexpanded,
    });
  }

  ongetOrderworkflowhistoryListFailure(res) { }

  async onfinddataclick(e) {

    let passObjDetAudit = store.getState().Loggeduser;
    passObjDetAudit.objsilentaudit = Silentauditobject(
      "view",
      "Sheet Orders",
      this.props.t("Orders.Sheetorders.IDS_AUDIT_TRANSHISTORYSHEET", {
        screen: orderType(this.props.props.dataItem.filetype),
        user1: store.getState().Loggeduser.username,
        orderid: this.props.props.dataItem.batchid,
      })
    );

    Servicecalls(
      "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
      passObjDetAudit,
      (res) => { },
      (res) => { }
    );
    let passobject = {
      usercode: this.props.props.dataItem.lsuserMaster.usercode,
    };

    Servicecalls(
      "" + this.ELNurl + "/User/getUserOnCode",
      passobject,
      this.onRepositorySuccess.bind(this),
      this.onRepositoryFailure.bind(this)
    );


    let passobject1 = {
      batchcode: this.props.props.dataItem.batchcode,
    };
    Servicecalls(
      "" + this.ELNurl + "/protocol/getprotocolstephistory",
      passobject1,
      this.ongetprotocolstephistorySuccess.bind(this),
      this.ongetProtocolOrderworkflowhistoryListFailure.bind(this)
    );
  }
  // sathish kumar added
  // async onfinddataclick(e) {
  //   let passobject = {
  //     filesamplecode: this.props.props.dataItem.lssamplefile.filesamplecode,
  //   };
  //   Servicecalls(
  //     "" + this.ELNurl + "/Instrument/getlsorderfileversion",
  //     passobject,
  //     this.onRepositorySuccess.bind(this),
  //     this.onRepositoryFailure.bind(this)
  //   );
  // }

  onRepositoryFailure(res) { }

  onRepositorySuccess(response) {
    this.setState({
      transactionhistory: response
      // inventryexpand: !this.state.inventryexpand
    });
  }
  onClose(e) {
    this.setState({ sheetView: false })

    let screenName = this.props.props.dataItem.filetype !== undefined ? this.props.props.dataItem.filetype === 2 ? "ELN Order" :
      this.props.props.dataItem.filetypee === 3 ? "Research Activity order" :
        this.props.props.dataItem.filetype === 4 ? "Manage excel" :
          this.props.props.dataItem.filetype === 5 ? "Sheet Validation" : "" : "";
    this.setState({ screenName: screenName });
  }



  getTransactionDatas = async () => {
    if (!this.props?.props?.dataItem?.batchcode) return [];
    const result = await this.fetchHistoryData(
      `${this.ELNurl}/protocol/getprotocolstephistory`,
      {
        batchcode: this.props?.props?.dataItem?.batchcode,
        response: { information: this?.state?.SelectedFilter.id?.toString() || "" },
        ...this?.state?.SelectedFilter.id === 4 && {
          objsilentaudit: {
            fromdate: this?.state?.OnKendoDateFrom?.setHours(0, 0, 0, 0), todate: toDateFilter(this?.state?.OnKendoDateTo)
          }
        }
      }
    );
    const { dataItem } = this.props?.props || {};
    const created = new Date(dataItem.createdtimestamp);
    const from = this.state.OnKendoDateFrom;
    const to = this.state.OnKendoDateTo;

    const isBetween =
      created.getTime() >= from.getTime() &&
      created.getTime() <= to.getTime();

    const base = isBetween ? { ...dataItem, type: "Transaction", isOriginal: true, createdateobj: dataItem.createdtimestamp } : {};
    const data = (result || []).map((items) => {
      items.type = "Transaction";
      items.createdateobj = items.stepstartdate || items.stependdate || items.stepskipeddate;
      items.orderobjects = items.orderobjects && JSON.parse(items.orderobjects)
      return items;
    })
    const dataWithOriginal = [base, ...data];
    return dataWithOriginal;

  };

  getVersionDatas = async () => {
    let filecode = this.props?.props?.dataItem?.lsf ? this.props.props.dataItem.lsf.filesamplecode : this.props.props?.dataItem?.lssamplefile?.filesamplecode;
    if (!filecode) return [];
    const result = await this.fetchHistoryData(
      `${this.ELNurl}/Instrument/GetSheetorderversions`,
      {
        filesamplecode: filecode, information: this?.state?.SelectedFilter.id?.toString() || "",
        ...this?.state?.SelectedFilter.id === 4 && {
          fromdate: this?.state?.OnKendoDateFrom?.setHours(0, 0, 0, 0), todate: toDateFilter(this?.state?.OnKendoDateTo)
        }
      }
    );
    return result?.lsorderversion?.map(item => ({ ...item, type: "Version", createdateobj: item.createdate })) || [];
  };

  getWorkflowHistoryDatas = async () => {
    let passobject = this.props.props.dataItem;
    if (passobject.createdtimestamp !== undefined) {
      if (
        typeof passobject.createdtimestamp === "string" ||
        passobject.createdtimestamp instanceof String
      ) {
        passobject.createdtimestamp = new Date(passobject.createdtimestamp);
      }
      if (
        typeof passobject.completedtimestamp === "string" ||
        passobject.completedtimestamp instanceof String
      ) {
        passobject.completedtimestamp = new Date(passobject.completedtimestamp);
      }
    }
    passobject.response = { information: this?.state?.SelectedFilter.id?.toString() || "" };
    if (this?.state?.SelectedFilter.id === 4) {
      passobject.objsilentaudit = {
        fromdate: this?.state?.OnKendoDateFrom?.setHours(0, 0, 0, 0), todate: toDateFilter(this?.state?.OnKendoDateTo)
      };
    }
    const result = await this.fetchHistoryData(
      `${this.ELNurl}/Instrument/updateVersionandWorkflowhistory`,
      passobject,
    );
    return result?.lsorderworkflowhistory?.map(item => ({ ...item, type: "Workflow", createdateobj: item.createdate })) || [];
  };

  fetchHistoryData = async (url, body) => {
    return new Promise((resolve, reject) => {
      Servicecalls(
        url,
        body,
        (res) => resolve(res || []),
        (err) => reject(err)
      );
    });
  };



  formatHistorys = (finalHistory) => {
    let historys = finalHistory?.reduce((acc, curr, index) => {
      if (curr?.type === "Workflow") {
        acc.push(this.formatsheetorderworkflowhistorydetails(curr, index))
      } else if (curr?.type === "Transaction") {
        acc.push(this.formatsheetordertranshistorydetails(curr, index))
      } else if (curr?.type === "Version") {
        acc.push(this.formatsheetorderversiondetails(curr, index))
      }
      return acc;
    }, [])
    return historys;
  }





  handleclickevent = async (event) => {
    const withTimeout = (promise, ms = 15000) =>
      Promise.race([
        promise,
        new Promise((_, reject) =>
          setTimeout(() => reject(new Error("Timeout")), ms)
        )
      ]);
    const results = await Promise.allSettled([
      withTimeout(this.getTransactionDatas()),
      withTimeout(this.getVersionDatas()),
      withTimeout(this.getWorkflowHistoryDatas())
    ]);

    // Convert settled results to usable arrays
    const [transactions, versions, workflows] = results.map(r =>
      r.status === "fulfilled" ? (r.value || []) : []
    );
    let finalHistory = [...transactions, ...versions, ...workflows].sort((a, b) => {
      const getTime = (item) =>
        typeof item.createdateobj === "number"
          ? item.createdateobj
          : Date.parse(item.createdateobj);

      const diff = getTime(b) - getTime(a);
      if (diff === 0) {
        return (a.id || "").toString().localeCompare((b.id || "").toString());
      }
      return diff;
    });

    finalHistory = finalHistory.map((items, index) => { items.id = index; return items })
    let allDatas = this.formatHistorys(finalHistory || [])
    let screenHistoryDatas = allDatas?.map((items) => { items.select = false; return items });
    this.setState({ sheetView: true, screenHistoryDatas });

  }
  onFilterTypeChange = (event) => {
    this.setState({ SelectedFilter: event }, () => {
      this.handleclickevent()
    })
  }

  onDatefilterDatachange = (changedDate, statekey) => {
    this.setState({ [statekey]: changedDate }, () => {
      this.handleclickevent()
    })
  }

  onFilteReset = () => {
    this.setState({ SelectedFilter: { id: 1 }, OnKendoDateFrom: new Date(new Date().setDate(new Date().getDate() - 7)), OnKendoDateTo: new Date() }, () => {
      this.handleclickevent()
    })
  }




  render() {
    const { activeTab } = this.state;
    const props = {
      t: (key, options) => {/* Your translation logic here */ },
    };

    return (
      <div className="openEyeBtn">
        <button
          id={`user-${this.props.props.dataItem[this.props.keyfield]}`}
          className="grid-icons"
          alt="user"
          data-placement="top"
          title={this.props.t("Masters.Inventory.IDS_LBL_TRANSACTION")}
          // onDoubleClick={this.handleSheetViewChange}
          onClick={this.handleclickevent.bind(this)}

        >
          <i className="far fa-eye sheet-eye"></i>
        </button>
        {this.state.sheetView ?
          <Modal
            isOpen={this.state.sheetView}
            backdrop={true}
            toggle={() => {
              this.setState({ sheetView: !this.state.sheetView })
            }}
            className=" modal-md smallPopup protocol-history sheet-history"
          >
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                {this.props.t("Orders.Sheetorders.IDS_LBL_ORDERHISTORY", {
                  param: "",
                  // Order: this.props.props.dataItem.batchid,
                })}
              </h5>
              <button
                type="button"
                className="btn_white_bg"
                data-dismiss="modal"
                aria-label="Close"
                onClick={this.onClose.bind(this)}
              >
                <i className="fas fa-times" aria-hidden="true"></i>
              </button>
            </div>
            <ModalBody>
              <div className={this.props.props.dataItem.assignedto !== undefined ? "assigned" : null}>

                {/* <ul className="nav nav-tabs">
                  <li className={`nav-item ${activeTab === 1 ? 'active' : ''}`}>
                    <a
                      className="nav-link"
                      onClick={() => this.handleTabClick(1)}
                      href="#tab1"
                    >
                      {this.props.t("Templates.Sheettemplates.IDS_LBL_VERSIONHISTORY")}
                    </a>
                  </li>
                  <li className={`nav-item ${activeTab === 2 ? 'active' : ''}`}>
                    <a
                      className="nav-link"
                      onClick={() => this.handleTabClick(2)}
                      href="#tab2"
                    >
                      {this.props.t("Templates.Sheettemplates.IDS_LBL_TRANS")}
                    </a>
                  </li>
                  {this.props.props.dataItem.assignedto === undefined ?
                    <li className={`nav-item ${activeTab === 3 ? 'active' : ''}`}>
                      <a
                        className="nav-link"
                        onClick={() => this.handleTabClick(3)}
                        href="#tab3"
                      >
                        {this.props.t("Templates.Sheettemplates.IDS_LBL_WORKF")}
                      </a>
                    </li> : ""}
                </ul> */}
                {/* <div> */}

                <div className="row w-100 align-items-center mb-2">
                  <span className="col-3 filter-table text-left m-0">{this.props.t("Dashboard.IDS_LBL_FILTERBY")}</span>
                  <KendoCombobox
                    initialValue=""
                    id="protocol-history-date"
                    Datasource={this.state.FilterType}
                    DefaultValue={this.state.SelectedFilter}
                    onvaluechange={this.onFilterTypeChange.bind(this)}
                    ValueMember="id"
                    DisplayMember="type"
                    allowCustom={true}
                    additionalclass={"clshideclearbutton col-6"}
                  />
                </div>
                {this.state.SelectedFilter?.id === 4 &&
                  <div className="shadow-box filter-date-group">
                    <div className="flex-form-group padding-align-form disable-callendar-input">
                      <label htmlFor="inputText">
                        {this.props.t("Dashboard.IDS_LBL_FILTERFROMDATE")}
                      </label>
                      <Suspense fallback={<div></div>}>
                        <KendoDatepicker
                          DefaultValue={this.state.OnKendoDateFrom}
                          onDatachanges={(changedDate) => { this.onDatefilterDatachange(changedDate, "OnKendoDateFrom") }}
                        />
                      </Suspense>
                    </div>
                    <div className="flex-form-group padding-align-form disable-callendar-input">
                      <label htmlFor="inputText">
                        {this.props.t("Dashboard.IDS_LBL_FILTERTO")}
                      </label>
                      <Suspense fallback={<div></div>}>
                        <KendoDatepicker
                          DefaultValue={this.state.OnKendoDateTo}
                          onDatachanges={(changedDate) => { this.onDatefilterDatachange(changedDate, "OnKendoDateTo") }}

                        />
                      </Suspense>
                    </div>
                    <div className="d-flex align-items-end flex-column bd-highlight mb-3">
                      <button
                        className="mg-l-1 btn btn-primary-blue active"
                        onClick={this.onFilteReset.bind(this)}
                      >
                        {this.props.t("Orders.Sheetorders.IDS_LBL_RESET")}
                      </button>
                    </div>
                  </div>
                }




                <div
                  className={`tab-pane ${activeTab === 1 ? 'active' : ''}`}
                  id="tab1"
                >
                  <div className="popup-group-list-inner" >
                    <KendoGridView
                      enableTooltip={true}
                      primaryKey={"id"}
                      source={this.state.screenHistoryDatas}
                      Columns={this.state.transactionscolumn}
                      DataSearchvisible={false}
                      ShowDetailsVisible={false}
                      height="calc(100vh - 165px)"
                    />
                  </div>
                </div>
                {/* <div className="tab-content">
                  <div
                    className={`tab-pane ${activeTab === 1 ? 'active' : ''}`}
                    id="tab1"
                  >
                    <div className="popup-group-list-inner" >
                      {this.formatsheetorderversiondetails()}
                    </div>
                  </div>
                  <div
                    className={`tab-pane ${activeTab === 2 ? 'active' : ''}`}
                    id="tab2"
                  >
                    <div className="popup-group-list-inner" >
                      {this.formatsheetordertranshistorydetails()}
                    </div>
                  </div>
                  <div
                    className={`tab-pane ${activeTab === 3 ? 'active' : ''}`}
                    id="tab3"
                  >
                    <div
                      className="popup-group-list-inner"
                    >
                      {this.formatsheetorderworkflowhistorydetails()}
                    </div>
                  </div>
                </div> */}
              </div>
              {/* <OverlayScrollbarsComponent
                options={{ scrollbars: { autoHide: "scroll" } }}
              >
                 <div className="popup-group-list full-width popup-lg-container">
                  <h6 className="icon-head">
                    {this.props.t("Orders.Protocolorders.IDS_LBL_VERSIONHIS", {
                      param: "",
                    })}
                    <button
                      className="btn float-right"
                      onClick={() => {
                        this.setState({
                          sheetorderversionexpanded: !this.state.sheetorderversionexpanded,
                        });
                      }}
                    >
                      <i
                        className={
                          this.state.sheetorderversionexpanded
                            ? "fa fa-angle-up"
                            : "fa fa-angle-down"
                        }
                        aria-hidden="true"
                      ></i>
                    </button>
                  </h6>
                  {this.state.sheetorderversionexpanded ? (
                    <div
                      className="popup-group-list-inner"
                    >
                      {this.formatsheetorderversiondetails()}
                    </div>
                  ) : (
                    ""
                  )}

                  <h6 className="icon-head">
                    {this.props.t("Orders.Protocolorders.IDS_LBL_TRANS", {
                      param: "",
                    })}
                    <button
                      className="btn float-right"
                      onClick={() => {
                        this.setState({
                          inventryexpand: !this.state.inventryexpand,
                        });

                      }}
                    >
                      <i
                        className={
                          this.state.inventryexpand
                            ? "fa fa-angle-up"
                            : "fa fa-angle-down"
                        }
                        aria-hidden="true"
                      ></i>
                    </button>
                  </h6>

                  {this.state.inventryexpand ? (
                    <div
                      className="popup-group-list-inner"
                    >
                      {this.formatsheetordertranshistorydetails()}
                    </div>
                  ) : (
                    ""
                  )}
                  <h6 className="icon-head">
                    {this.props.t("Orders.Protocolorders.IDS_LBL_WORKF", {
                      param: "",
                    })}
                    <button
                      className="btn float-right"
                      onClick={() => {
                        this.setState({
                          workflowexpanded: !this.state.workflowexpanded,
                        });

                      }}
                    >
                      <i
                        className={
                          this.state.workflowexpanded
                            ? "fa fa-angle-up"
                            : "fa fa-angle-down"
                        }
                        aria-hidden="true"
                      ></i>
                    </button>
                  </h6>

                  {this.state.workflowexpanded ? (
                    <div
                      className="popup-group-list-inner"
                    >
                      {this.formatsheetorderworkflowhistorydetails()}
                    </div>
                  ) : (
                    ""
                  )}

                </div> 
              </OverlayScrollbarsComponent> */}
            </ModalBody>
            {/* <div className="modal-footer">
              <button
                type="button"
                className="textBtn btn_white_bg"
                onClick={this.onClose.bind(this)}
              > Close
              </button>
            </div> */}
          </Modal>
          : ""
        }
        {/* <Popover
          placement="right"
          trigger="hover"
          className="popoverContainer"
          id="popover-trigger-focus"
          isOpen={this.isToolTipOpen(
            `user-${this.props.props.dataItem[this.props.keyfield]}`
          )}
          target={`user-${this.props.props.dataItem[this.props.keyfield]}`}
          toggle={() =>
            this.toggle(
              `user-${this.props.props.dataItem[this.props.keyfield]}`
            )
          }
        >
          <PopoverBody className="no-pad">
            <OverlayScrollbarsComponent
              style={{ maxHeight: "300px" }}
              options={{ scrollbars: { autoHide: "scroll" } }}
            >
              <div className="popup-group-list">
                <h6 className="icon-head">
                  {this.props.t("renderfunction.IDS_TRANS", {
                    param: "",
                  })}
                  <button
                    className="btn float-right"
                    onClick={() => {
                      this.setState({
                        inventryexpand: !this.state.inventryexpand,
                      });
                      this.onfinddataclick();
                    }}
                  >
                    <i
                      className={
                        this.state.inventryexpand
                          ? "fa fa-angle-up"
                          : "fa fa-angle-down"
                      }
                      aria-hidden="true"
                    ></i>
                  </button>
                </h6>

                {this.state.inventryhistoryexpand ? (
                  <div
                    className="popup-group-list-inner"
                    isOpen={this.state.inventryhistoryexpand}
                  >
                    {this.state.inventryhistoryexpand &&
                      this.formatversiondetails()}
                  </div>
                ) : (
                  ""
                )}
                <h6 className="icon-head">
                  {this.props.t("renderfunction.IDS_WORKF", {
                    param: "",
                  })}
                  <button
                    className="btn float-right"
                    onClick={() => {
                      this.setState({
                        workflowexpanded: !this.state.workflowexpanded,
                      });
                      this.onfinddataworkflowclick();
                    }}
                  >
                    <i
                      className={
                        this.state.workflowexpanded
                          ? "fa fa-angle-up"
                          : "fa fa-angle-down"
                      }
                      aria-hidden="true"
                    ></i>
                  </button>
                </h6>

                {this.state.workflowehistoryxpanded ? (
                  <div
                    className="popup-group-list-inner"
                    isOpen={this.state.workflowehistoryxpanded}
                  >
                    {this.state.workflowehistoryxpanded
                      ? this.formatworrkflowhistorydetails()
                      : ""}
                  </div>
                ) : (
                  ""
                )}
              </div>
            </OverlayScrollbarsComponent>
          </PopoverBody>
        </Popover> */}
      </div>
    );
  }
}
const Customordercells = withTranslation(Customsheetorder);

class Customcompleteorder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Data: [],
      transactionhistory: {},
      inventryexpand: false,
      workflowexpanded: false,
      workflowehistoryxpanded: false,
      inventryhistoryexpand: false,
      userMasterScreen: true,
      ServiceToUrl: "",
      ServiceMethodType: "POST",
      ServiceHeaderobject: {},
      ServcieonSuccess: undefined,
      ServcieonFailure: undefined,
    };
    this.props = props;
    this.ELNurl = window.appUrl.ELN;

    this.imageurl = "";
    if (isMultitenant === 1 || isMultitenant === 2) {
      this.imageurl = "/User/Cloudprofile/";
    } else {
      this.imageurl = "/User/profile/";
    }

    this.month = [
      this.props.t("months.IDS_LBL_JAN", { param: "" }),
      this.props.t("months.IDS_LBL_FEB", { param: "" }),
      this.props.t("months.IDS_LBL_MAR", { param: "" }),
      this.props.t("months.IDS_LBL_APR", { param: "" }),
      this.props.t("months.IDS_LBL_MAY", { param: "" }),
      this.props.t("months.IDS_LBL_JUN", { param: "" }),
      this.props.t("months.IDS_LBL_JUL", { param: "" }),
      this.props.t("months.IDS_LBL_AUG", { param: "" }),
      this.props.t("months.IDS_LBL_SEP", { param: "" }),
      this.props.t("months.IDS_LBL_OCT", { param: "" }),
      this.props.t("months.IDS_LBL_NOV", { param: "" }),
      this.props.t("months.IDS_LBL_DEC", { param: "" }),
    ];
  }

  isToolTipOpen = (targetName) => {
    return this.state[targetName] ? this.state[targetName].tooltipOpen : false;
  };

  toggle = (targetName) => {
    if (!this.state[targetName]) {
      this.setState({
        ...this.state,
        [targetName]: {
          tooltipOpen: true,
        },
      });
    } else {
      this.setState({
        ...this.state,
        [targetName]: {
          tooltipOpen: !this.state[targetName].tooltipOpen,
        },
      });
    }

    this.setState({
      transactionexpanded: false,
      workflowexpanded: false,
    });
  };

  formatworrkflowhistorydetails() {
    var detail = [];

    if (this.state.Data.length !== 0) {
      let d = null;
      let day = null;
      let dayname = null;
      let time = null;

      for (let index = 0; index < this.state.Data.length; index++) {
        let createby = {
          usercode: this.state.Data[index].createby.usercode,
          username: this.state.Data[index].createby.username,
        };

        if (
          this.state.Data[index].createby.usercode !== undefined &&
          this.state.Data[index].createby.username !== null
        ) {
          let localdate = convertUTCDateToLocalDate(
            new Date(this.state.Data[index].createdate)
          );
          d = new Date(localdate);
          day = d.getDate();
          dayname = this.month[d.getMonth()];
          // time = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
          day = convertdoubledigitdate(day);
          time = convertdoubledigittime(
            d.getHours(),
            d.getMinutes(),
            d.getSeconds()
          );
          let year = d.getFullYear();
          // let gmt =d.toString();
          // gmt=gmt.slice(25,34);

          let imgurl = this.ELNurl + this.imageurl + "-1";
          if (
            this.state.Data[index].createby.usercode !== null &&
            this.state.Data[index].username !== undefined
          ) {
            imgurl =
              this.ELNurl +
              this.imageurl +
              this.state.Data[index].createby.usercode;
          }
          detail.push(
            <li
              key={this.props.dataItem.repositorydatacode + "Trans_" + index}
              className="list-group-item"
              aria-disabled="true"
            >
              <div className="row no-gutters align-items-center">
                <div className="col-2">
                  <div className="calender-list small">
                    <span className="d-flex eln-stamp">{dayname}</span>
                    <span className="d-flex eln-date">{day}</span>
                    <span className="d-flex eln-stamp">{year}</span>
                    <span className="d-flex eln-stamp">{time}</span>
                    {/* <span className="d-flex eln-stamp">{gmt}</span> */}
                  </div>
                </div>
                <div className="col-10 mnuContainer2 userDetails">
                  <Userdetail
                    index={"Trans-" + index}
                    imgurl={imgurl}
                    user={createby}
                  />
                  <p>
                    {this.state.Data[index].action}
                    <div className="userComts">
                      <b>
                        {this.props.t("Orders.Protocolorders.IDS_LBL_COMMENT", { param: "" })} :
                      </b>{" "}
                      {this.state.Data[index].comment}
                    </div>
                  </p>
                </div>
              </div>
            </li>
          );
        }
      }
    } else {
      detail.push(
        <ul className="list-group list-group-flush">
          <li className="list-group-item" aria-disabled="true">
            <p>
              {this.props.t("Orders.Protocolorders.IDS_LBL_NOWORKF", {
                param: "",
              })}
            </p>
          </li>
        </ul>
      );
    }

    let detailsvalue = (
      <ul className="list-group list-group-flush">{detail}</ul>
    );
    return detailsvalue;
  }

  formatversiondetails() {
    var detail = [];

    if (this.state.transactionhistory !== "") {
      let d = null;
      let day = null;
      let dayname = null;
      let time = null;

      let createby = {
        usercode: this.state.transactionhistory.usercode,
        username: this.state.transactionhistory.username,
      };

      if (
        this.state.transactionhistory.usercode !== undefined &&
        this.state.transactionhistory.username !== null
      ) {
        let localdate = convertUTCDateToLocalDate(
          new Date(this.state.transactionhistory.createddate)
        );
        d = new Date(localdate);
        day = d.getDate();
        dayname = this.month[d.getMonth()];
        // time = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
        day = convertdoubledigitdate(day);
        time = convertdoubledigittime(
          d.getHours(),
          d.getMinutes(),
          d.getSeconds()
        );
        let year = d.getFullYear();
        // let gmt =d.toString();
        // gmt=gmt.slice(25,34);

        let imgurl = this.ELNurl + this.imageurl + "-1";
        if (
          this.state.transactionhistory.usercode !== null &&
          this.state.transactionhistory.username !== undefined
        ) {
          imgurl =
            this.ELNurl +
            this.imageurl +
            this.state.transactionhistory.usercode;
        }
        detail.push(
          <li
            key={this.props.dataItem.batchcode + "Trans_" + 1}
            className="list-group-item"
            aria-disabled="true"
          >
            <div className="row no-gutters align-items-center">
              <div className="col-2">
                <div className="calender-list small">
                  <span className="d-flex eln-stamp">{dayname}</span>
                  <span className="d-flex eln-date">{day}</span>
                  <span className="d-flex eln-stamp">{year}</span>
                  <span className="d-flex eln-stamp">{time}</span>
                  {/* <span className="d-flex eln-stamp">{gmt}</span> */}
                </div>
              </div>
              <div className="col-10 mnuContainer2 userDetails">
                <Userdetail
                  index={"Trans-" + 1}
                  imgurl={imgurl}
                  user={createby}
                />
                <p>
                  {this.props.t("Orders.Protocolorders.IDS_LBL_CREATEDFILE", {
                    user2: this.props.dataItem.lsuserMaster.username,
                    user1: this.props.dataItem.batchid,
                  })}
                </p>
              </div>{" "}
            </div>
          </li>
        );
      }
    } else {
      detail.push(
        <ul className="list-group list-group-flush">
          <li className="list-group-item" aria-disabled="true">
            <p>
              {this.props.t("Masters.Inventory.IDS_LBL_NOINVENTRYDETAAILS", {
                param: "",
              })}
            </p>
          </li>
        </ul>
      );
    }

    let detailsvalue = (
      <ul className="list-group list-group-flush">{detail}</ul>
    );
    return detailsvalue;
  }

  async onfinddataworkflowclick(e) {
    let passobject = this.props.dataItem;

    if (passobject.completedtimestamp !== undefined) {
      if (
        typeof passobject.createdtimestamp === "string" ||
        passobject.createdtimestamp instanceof String
      ) {
        passobject.createdtimestamp = new Date(passobject.createdtimestamp);
      }

      if (
        typeof passobject.completedtimestamp === "string" ||
        passobject.completedtimestamp instanceof String
      ) {
        passobject.completedtimestamp = new Date(passobject.completedtimestamp);
      }
    }

    Servicecalls(
      "" + this.ELNurl + "/Instrument/updateVersionandWorkflowhistory",
      passobject,
      this.ongetOrderworkflowhistoryListSuccess.bind(this),
      this.ongetOrderworkflowhistoryListFailure.bind(this)
    );
  }

  ongetOrderworkflowhistoryListSuccess(response) {
    this.setState({
      Data: response.lsorderworkflowhistory,
      workflowexpanded: !this.state.workflowexpanded,
      workflowehistoryxpanded: !this.state.workflowehistoryxpanded,
    });
  }

  ongetOrderworkflowhistoryListFailure(res) { }

  async onfinddataclick(e) {

    let passobject = {
      usercode: this.props.dataItem.lsuserMaster.usercode,
    };

    Servicecalls(
      "" + this.ELNurl + "/User/getUserOnCode",
      passobject,
      this.onRepositorySuccess.bind(this),
      this.onRepositoryFailure.bind(this)
    );
  }

  onRepositoryFailure(res) { }

  onRepositorySuccess(response) {
    this.setState({
      transactionhistory: response,
      inventryexpand: !this.state.inventryexpand,
      inventryhistoryexpand: !this.state.inventryhistoryexpand,
    });
  }

  render() {
    return (this.props.dataItem[this.props.keyfield] !== undefined ? (
      <div className="openEyeIcon">
        <button
          id={`user-${this.props.dataItem[this.props.keyfield]}`}
          className="btn_white_bg"
          alt="user"
          data-placement="top"
          title=""
        >
          <i className="far fa-eye 4"></i>
        </button>
        <Popover
          placement="bottom"
          trigger="hover"
          className="popoverContainer"
          id="popover-trigger-focus"
          isOpen={this.isToolTipOpen(
            `user-${this.props.dataItem[this.props.keyfield]}`
          )}
          target={`user-${this.props.dataItem[this.props.keyfield]}`}
          toggle={() =>
            this.toggle(`user-${this.props.dataItem[this.props.keyfield]}`)
          }
        >
          <PopoverBody className="no-pad">
            <OverlayScrollbarsComponent
              style={{ maxHeight: "300px" }}
              options={{ scrollbars: { autoHide: "scroll" } }}
            >
              <div className="popup-group-list">
                <h6 className="icon-head">
                  {this.props.t("Orders.Protocolorders.IDS_LBL_TRANS", {
                    param: "",
                  })}
                  <button
                    className="btn float-right"
                    onClick={() => {
                      this.setState({
                        inventryexpand: !this.state.inventryexpand,
                      });
                      this.onfinddataclick();
                    }}
                  >
                    <i
                      className={
                        this.state.inventryexpand
                          ? "fa fa-angle-up"
                          : "fa fa-angle-down"
                      }
                      aria-hidden="true"
                    ></i>
                  </button>
                </h6>

                {this.state.inventryhistoryexpand ? (
                  <div
                    className="popup-group-list-inner"
                    isOpen={this.state.inventryhistoryexpand}
                  >
                    {this.state.inventryhistoryexpand &&
                      this.formatversiondetails()}
                  </div>
                ) : (
                  ""
                )}
                <h6 className="icon-head">
                  {this.props.t("Orders.Protocolorders.IDS_LBL_WORKF", {
                    param: "",
                  })}
                  <button
                    className="btn float-right"
                    onClick={() => {
                      this.setState({
                        workflowexpanded: !this.state.workflowexpanded,
                      });
                      this.onfinddataworkflowclick();
                    }}
                  >
                    <i
                      className={
                        this.state.workflowexpanded
                          ? "fa fa-angle-up"
                          : "fa fa-angle-down"
                      }
                      aria-hidden="true"
                    ></i>
                  </button>
                </h6>

                {this.state.workflowehistoryxpanded ? (
                  <div
                    className="popup-group-list-inner"
                    isOpen={this.state.workflowehistoryxpanded}
                  >
                    {this.state.workflowehistoryxpanded &&
                      this.formatworrkflowhistorydetails()}
                  </div>
                ) : (
                  ""
                )}
              </div>
            </OverlayScrollbarsComponent>
          </PopoverBody>
        </Popover>
      </div>
    ) : (
      ""
    )
    );
  }
}
const Customcompletecell = withTranslation(Customcompleteorder);

export {
  CustomUsergroupviewCells,
  Custominventrycells,
  Customprotocolordercells,
  Customprotocolcells,
  Customordercells,
  Customcompletecell,
  Formatprotocolversioncell,
  Formatprotocoltransactioncell,
  FormatResultUsedDetailscell,
  // Formatprotocolordertransactioncell,
  Formatprotocolversiondetailscell,
  FormatResultUsedEquipment
};
